// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23eb4e0e%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23f16806%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=UTF-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 7\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.839293 1.08474C0.979918 0.944293 1.17054 0.865403 1.36929 0.865403C1.56804 0.865403 1.75867 0.944293 1.89929 1.08474L5.36929 4.55474L8.83929 1.08474C8.98147 0.952263 9.16951 0.880139 9.36382 0.883567C9.55812 0.886995 9.7435 0.965708 9.88092 1.10312C10.0183 1.24053 10.097 1.42592 10.1005 1.62022C10.1039 1.81452 10.0318 2.00257 9.89929 2.14474L5.89929 6.14474C5.75867 6.28519 5.56804 6.36408 5.36929 6.36408C5.17054 6.36408 4.97992 6.28519 4.83929 6.14474L0.839293 2.14474C0.698843 2.00412 0.619954 1.81349 0.619954 1.61474C0.619954 1.41599 0.698843 1.22537 0.839293 1.08474Z\" fill=\"black\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 7\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.84 1.085a.75.75 0 0 1 1.06 0l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06Z\" fill=\"%23000\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-image: linear-gradient(109.6deg, rgb(221 232 241 / 31%) 11.2%, rgb(205 216 220 / 49%) 100.2%);
    font-family: "Mulish", sans-serif;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 600; 
}
::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.116);
	background-color: #F5F5F5;
}

::-webkit-scrollbar
{
	width: 7px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb
{
	background-color: #555555; 
	border: 2px solid #ffffff;
}

.el-board-table::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.116);
	background-color: #F5F5F5;
}

.el-board-table::-webkit-scrollbar
{
	height: 7px;
	background-color: #F5F5F5;
}

.el-board-table::-webkit-scrollbar-thumb
{
	background-color: #555555; 
	border: 2px solid #ffffff;
}

a{
    cursor: pointer;
}
.btn-check:checked+.btn:focus-visible, :not(.btn-check)+.btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
    box-shadow:none!important;
}
th .btn.dropdown-toggle:hover { 
    background-color:transparent!important; 
}
.back-link {
    text-decoration: none;
    text-decoration: none;
    color: #eb4e0e!important;
    position: relative;
    left: -7px;
    font-weight: 600!important;
    font-size: 18px!important;
    position: relative;
    left: -7px;
    width: fit-content!important;
}
td .btn:hover, td .btn:focus,td .btn:active{
    background-color: transparent;border: 0;
}
.btn:first-child:active{
    background-color: transparent!important;border: 0;
}
.back-link + .el-bg-table {
    margin-top: 20px;
}

.el-bg-table.el-super-admin .col-md-4:has(.form-check) {
    margin: 0;
}
main {
    min-height: 100vh;
}

.el-logo {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;padding-top: 4px;
}

.el-sidebar {
    height: 100vh;
    overflow: auto;
    background: #fff;
    position: fixed;
    left: 0;
    transition: all 0.5s ease;
    top: 0;
    z-index: 9999;
}
@media (max-width: 480px) {
    .el-sidebar {
        position: absolute !important;
        display: block !important;
    }
}
 

@media (max-width: 992px) {
    .el-sidebar {
        position: absolute !important;
        display: block;
    }
    .el-middle {
        padding: 0;
    }
}
.el-sidebar .navbar-expand-lg {
    display: flex;
    flex-direction: column;
}

.el-sidebar .navbar-expand-lg .navbar-collapse {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: normal;
}

.el-sidebar .nav-item {
    /* padding: 0 20px; */

}

.el-sidebar .nav-item .nav-link {
    background: rgba(0, 0, 0, 0);
    padding: 12px 17px;
    color: #202224;
    font-weight: 600;
    font-size: 15px;
    border-radius: 6px; 
}

.el-sidebar .nav-item .nav-link i {
    font-size: 18px;
    display: inline-block;
    vertical-align: middle;
    color: #000;
}

.el-sidebar .nav-item .nav-link span {
    display: inline-block;
    vertical-align: middle;
    margin: 0 0 0 8px;
}

.el-sidebar .nav-item .nav-link.active,
.el-sidebar .nav-item .nav-link:hover {
    background: #f47403;
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
    color: #fff;
}

.el-sidebar .el-navlabel {
    display: flex;
    position: relative;
    align-items: center;
    font-size: 13px;
    color: #000;
    font-weight: bold;
    margin: 10px 0;
    text-transform: uppercase;
}

.el-sidebar .el-navlabel:before {
    content: "";
    display: block;
    background: #202224;
    /* width: 43px; */
    width: 35px;
    height: 1px;
    margin-right: 10px;
}

.el-middle {
    width: 100%;
    padding-left: 280px;
}

@media (max-width: 992px) {
    .el-middle {
        padding: 0;
    }
}

.el-middle-wrapper {
    padding: 20px 45px;
}

@media (max-width: 768px) {
    .el-middle-wrapper {
        padding: 20px;
    }
}

.el-topbar {
    background: #fff;
    padding: 15px 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 280px;
}

@media (max-width: 1199px) {
    .el-topbar {
        flex-wrap: wrap;
        padding: 20px;
    }
}

.el-topbar-left {
    font-size: 22px;
    margin-left: 45px;
}

.el-topbar-left span {
    color: #ec008c;
}

.el-topbar-right {
    display: flex;
}

.el-topbar-right > div {
    background: #f2f2f2;
    margin: 0 0 0 10px;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    min-width: 240px;
}

.el-topbar-right > div i {
    width: 21%;
    display: flex;
    background: #fff;
    border-radius: 5px;
    font-size: 30px;
    color: #f16806;
    align-items: center;
    justify-content: center;
    height: 46px;
}

.el-topbar-right > div span {
    display: block;
    width: calc(100% - 57px);
    font-size: 14px;
    line-height: 1.5;
}

.el-topbar-right > div span small {
    font-size: 14px;
    color: #f16806;
}

.el-topbar-right > div.el-topbar-weather {
    min-width: 200px;
}

.el-topbar-right > div.el-topbar-weather i {
    width: 46px;
}

.el-topbar-right > div.el-topbar-weather span {
    width: calc(100% - 57px);
}

.el-middle-top {
    display: flex;
    margin: 0 0 20px;
}

@media (max-width: 1300px) {
    .el-middle-top {
        flex-wrap: wrap;
    }
}

@media (min-width: 992px) and (max-width: 1300px) {
    .el-middle-top .el-middle-top-col {
        margin-bottom: 15px;
        max-width: 100%;
        min-width: 400px;
    }
}

@media (min-width: 568px) and (max-width: 768px) {
    .el-middle-top .el-middle-top-col {
        margin-bottom: 15px;
        max-width: 100%;
        min-width: fit-content;
    }
}

@media (min-width: 568px) {
    .el-middle-top-col {
        margin-bottom: 15px;
        max-width: 100%;
        min-width: fit-content;
    }
}

@media (max-width: 568px) {
    .el-middle-top-col {
        margin-bottom: 15px;
        max-width: 100%;
        min-width: 100%;
    }
}

@media (max-width: 1300px) {
    .el-table-container.el-board-table {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
}

.el-middle-top-col {
    margin-right: 1%;
    display: flex;
    align-items: center;
    border-radius: 12px;
    padding: 12px 20px;
    background: #f47403;
    background: linear-gradient(136deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
}

@media (min-width: 1600px) {
    .el-middle-top-col {
        width: 24%;
    }
}

@media (min-width: 1201px) {
    .el-middle-top-col {
        flex-wrap: wrap;
    }
}

.el-middle-top-col strong {
    display: block;
    font-size: 32px;
    color: #fff;
    margin: 0 0 10px;
}

.el-middle-top-col span {
    font-size: 18px;
    color: #fff;
    font-weight: bold;
}

.el-middle-top-col + .el-middle-top-col {
    background: #e83f12;
    background: linear-gradient(136deg, rgb(232, 63, 18) 0%, rgb(189, 75, 118) 58%, rgb(145, 79, 179) 100%);
}

.el-middle-top-col + .el-middle-top-col + .el-middle-top-col {
    background: #8d4db2;
    background: linear-gradient(
        136deg,
        rgb(141, 77, 178) 0%,
        rgb(141, 77, 178) 40%,
        rgb(123, 64, 157) 64%,
        rgb(72, 26, 98) 92%
    );
}

.el-middle-top-img {
    margin-right: 16px;
}

.el-middle-content {
    padding: 20px;
    background: #fff;
    border-radius: 20px;
}

.el-middle-title {
    margin: 0 0 20px;
}

.el-middle-title h2 {
    color: #ec008c;
    font-size: 20px;
    font-weight: 500;
}

.el-table-container {
    border: 1px solid RGB(196, 196, 196);
    border-radius: 10px;
    padding: 0 8px;
    margin-bottom: 20px;
}

.el-table-container .table {
    margin: 0;
}

.el-table-container .table tbody tr td {
    vertical-align: middle;
     padding: 15px 13px; 
    border-bottom: 2px solid #efefef;
}

.el-table-container .table tbody tr:nth-last-child(1) td {
    border-bottom: 0px;
}

.btn.btn-primary {
    height: auto;
    padding-top: 0px;
    padding-bottom: 0px;
    text-align: left !important;
    justify-content: flex-start;
    border-radius: 6px;
    color: #fff !important;font-weight: 600;
    min-height: initial !important;
    /* padding-left: 8px !important; */
    /* min-width: 147px; */
    /* min-width: 85px; */
    font-size: 16px;
    font-weight: 500;
}

.btn.btn-primary:hover {
    opacity: 0.8;
}

.btn.btn-primary.blood {
    background: #c82121;
    border-color: #c82121;
}

.el-radio {
    position: relative;
    height: 100%;
}

.el-radio input {
    -webkit-appearance: none;
    position: absolute;
    left: -9999px;
    opacity: 0;
}

.el-radio input + label {
    width: 16px;
    height: 16px;
    display: block;
}

.el-radio input + label:before {
    content: "";
    border: solid 1px #202224;
    width: 16px;
    height: 16px;
    display: block;
    border-radius: 100%;
}

.el-radio input + label:after {
    content: "";
    display: block;
    position: absolute;
    background: #f47324;
    width: 12px;
    height: 12px;
    border-radius: 100%;
    top: 2px;
    left: 2px;
    opacity: 0;
}

.el-radio input:checked + label:after {
    opacity: 1;
}

.el-login-sec .el-login-card .el-login-logo img {
    margin: 0 auto 30px auto;
    display: block;
    width: 250px;
    max-width: 100%;
}

@media (max-width: 768px) {
    .el-login-sec .el-login-card .el-login-logo img {
        width: 200px;
        margin: 0 auto 40px auto;
    }
}

.el-login-sec .el-login-footer {
    background-color: #fff;
    padding: 45px 0px 37px;
}

.el-login-sec .el-login-footer .el-copyright-txt p {
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    color: #585858;
    margin-bottom: 60px;
}

.el-login-sec .el-login-background {
    background: #fff;
    padding: 80px 58px;
    border-radius: 20px;
    max-width: 600px;
    height: 100%;
    backdrop-filter: blur(50px);
    box-shadow: -2px 2px 25px rgba(0, 0, 0, 0.0705882353);
}

@media (max-width: 768px) {
    .el-login-sec .el-login-background {
        padding: 40px 30px;
    }
}

.el-login-sec .el-form-group label {
    font-size: 17px;
    margin-bottom: 10px;
    color: #000 !important;
}

.el-login-sec .form-control {
    height: 50px;
    border: 1px solid #000;
    margin-bottom: 10px;
}

.el-login-sec .el-btn-primary {
    background: #f47324;
    background: #000;
    color: #fff;
    text-decoration: none;
    padding: 15px 30px;
    margin: 15px auto !important;
    display: block;
    text-align: center;
    max-width: 70%;
    margin-bottom: 15px;
    width: 100%;
    box-shadow: none;
    font-weight: 700;
    transition: all 0.5s ease;
    border-radius: 12px;
    border: 2px solid #fff;
    margin-top: 10px;
}

.el-login-sec .el-btn-primary:hover {
    background: rgba(0, 0, 0, 0);
    border: 2px solid #000;
    color: #000;
}

.el-login-sec .elfotget-password {
    color: #ec008c;
    font-size: 16px;
    padding-top: 20px;
}

.el-login-sec .text-red {
    color: #c82121;
    margin-left: 5px;
}

.el-login-sec .form-check-input:checked {
    background-color: #f47324;
    border-color: #f47324;
}

.el-gradient-login-box {
    width: 50%;
    position: absolute;
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
    height: 100%;
    left: 0;
    opacity: 0.8;
    backdrop-filter: blur(40px);
}

.el-gradient-login-box {
    width: 52%;
    position: absolute;
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
    height: 100%;
    left: 0;
    opacity: 0.8;
    backdrop-filter: blur(74px);
}

@media (max-width: 992px) {
    .el-gradient-login-box {
        width: 100%;
        opacity: 0.8;
    }
}

.el-text-dark {
    text-decoration: underline !important;
}

section.el-login-sec.w-100 {
    max-width: 600px;
    background: #fff;
    height: 100vh;
    display: flex;
    align-items: center;
}

@media (max-width: 768px) {
    section.el-login-sec.w-100 {
        background: rgba(255, 255, 255, 0.6196078431) !important;
    }
}

.el-login-card h3 {
    text-align: left;
    font-weight: 700;
    font-size: 24px;
    line-height: 40px;
    margin: 20px 0 20px 0 !important;
}

.el-login-sec .el-login-background {
    background: #fff;
    padding: 0;
    border-radius: 20px;
    max-width: 500px;
    height: 100%;
    position: relative;
    margin: 15px;
    backdrop-filter: unset;
    padding: 30px;
    margin: 20px;
    box-shadow: none;
}

.el-login-sec .el-login-card .el-login-logo img {
    margin: 0 auto 50px 0 !important;
    display: block;
    width: 200px;
    max-width: 100%;
}

.el-login-card h2 {
    text-align: left;
    font-weight: 700;
    font-size: 24px;
    line-height: 40px;
    margin: 20px 0;
}

.el-login-sec .form-control {
    height: initial;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 24px;
    border: 1px solid #dad9da;
    border-radius: 4px;
    max-width: 100%;
}

@media (min-width: 1200px) {
    .el-login-sec .form-control {
        width: 450px;
    }
}

.el-login-sec .form-control:focus {
    box-shadow: none;
    border: 1px solid #f47324;
}

.el-login-sec .el-btn-primary {
    max-width: 100%;
}

.el-login-sec .elfotget-password {
    color: #ec008c;
    font-size: 14px;
    padding-top: 20px;
    text-decoration: none;
}

.el-login-sec .el-login-background {
    background: #fff !important;
    padding: 0;
    border-radius: 0;
    max-width: 600px;
    position: relative;
    margin: 15px;
    backdrop-filter: unset;
    padding: 80px;
    margin: 0;
    box-shadow: none;
    left: 0;
    align-items: center;
}

@media (max-width: 768px) {
    .el-login-sec .el-login-background {
        background: rgba(0, 0, 0, 0) !important;
        padding: 40px;
    }
    .el-login-card {
        margin-top: 0;
        background: #fff;
        border-radius: 20px;
        padding: 40px !important;
        padding: 15px;
    }
    .el-login-sec .el-login-card .el-login-logo img {
        margin: 0 auto 50px auto !important;
        display: block;
        width: 200px;
        max-width: 100%;
    }
}

@media (max-width: 568px) {
    .el-login-sec .el-login-background {
        padding: 20px;
    }
    .el-login-card {
        padding: 20px !important;
    }
}

.el-login-card p {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 40px;
}

@media (max-width: 768px) {
    .el-topbar-right {
        display: none;
    }
}

.el-addministrative-setting {
    background: #fff;
    border-radius: 16px;
    box-sizing: border-box;
    box-shadow: 10px 15px 25px rgba(204, 204, 204, 0.459);
    text-align: start;
    padding: 15px 20px !important;
    margin: 15px 0;
    height: 100%;
    position: relative;
    margin: auto;
    width: 100%;
    min-height: 350px;
}

@media (max-width: 1200px) {
    .el-addministrative-setting {
        height: 100%;
    }
}

.el-addministrative-setting img {
    height: 100px;
    max-width: 100%;
    object-fit: contain;
    margin: 20px 0;
}

.el-addministrative-setting p {
    line-height: 130%;
}

.el-addministrative-setting h3 {
    font-size: 18px;
    line-height: 26px;
    font-weight: 700;
    font-family: "Mulish", sans-serif;
    margin-bottom: 14px;
}

.el-addministrative-setting button.btn.btn-outline-primary {
    border: 1px solid #ee5b0b;
    transition: all 0.2s ease-in;
    color: #ee5b0b;
    position: absolute;
    bottom: 20px;
}

@media (max-width: 1400px) {
    .el-addministrative-setting button.btn.btn-outline-primary {
        position: relative !important;
        bottom: 0 !important;
    }
}

.el-addministrative-setting button.btn.btn-outline-primary:hover {
    background: #ee5b0b;
    color: #fff;
}

.col-xxl-3:has(.el-addministrative-setting) {
    margin: 15px 0;
}

.el-title {
    font-size: 26px;
    margin-bottom: 15px;
    font-weight: 900;
    font-weight: 500;
}

.el-bg-table {
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    box-shadow:4px 11px 50px rgb(45 43 43 / 5%); 
    border-radius: 12px;
    /* overflow: auto; */
}

.el-bg-table:has(table) {
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 4px 11px 50px rgb(45 43 43 / 5%); 
    border-radius: 12px;
    overflow: auto;
}
.el-bg-table .el-bordered-btn {
    background: rgba(0, 0, 0, 0);
    color: #202224;
    margin: 0 15px;
    border: 1px solid #202224;
    margin: auto;
    padding: 8px 20px;
    font-size: 17px;
}

.el-bg-table .el-bordered-btn:hover {
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
    color: #fff;
    border: 1px solid rgba(0, 0, 0, 0);
}

.el-bg-table button.btn.btn-secondary.dropdown-toggle {
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
    border: 0;
    outline: 0;
    min-height: 43px;
    padding: 4px 20px;
    font-size: 17px;
}
.el-bg-table button.btn.btn-secondary .dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid rgba(0, 0, 0, 0);
    border-bottom: 0;
    border-left: .3em solid rgba(0, 0, 0, 0);
    top: 2px;
    position: relative;
}
.el-bg-table h3 {
    font-size: 20px;
    margin-bottom: 15px;
    font-weight: 900;
    margin: 0;
    font-weight: 500;
}

.el-bg-table ul.dropdown-menu.el-admin {
    border: 0;
    box-sizing: border-box;
    overflow: hidden;
    box-shadow: 3px 5px 25px 13px rgba(204, 204, 204, 0.25);
    padding: 0;
    left: -80% !important;
}

.el-bg-table ul.dropdown-menu.el-admin a.dropdown-item {
    border-bottom: 1px solid #ccc;
    padding: 10px 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0);
}

.el-bg-table ul.dropdown-menu.el-admin a.dropdown-item:hover {
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%) !important;
    color: #fff;
}

.el-bg-table ul.dropdown-menu.el-admin li {
    border-bottom: 1px solid #ccc;
}

.el-bg-table ul.dropdown-menu.el-admin li:last-child {
    border: 0;
}

.el-bg-table .el-table-container {
    margin-top: 30px;
}

.el-bg-table .btn-primary {
    outline: 0;
    width: fit-content;
    background: rgba(0, 0, 0, 0);
    border: 0;
}

.el-bg-table .btn-primary:focus {
    background: rgba(0, 0, 0, 0);
}

.el-bg-table ul.dropdown-menu.el-action {
    border: 0;
    box-sizing: border-box;
    overflow: hidden;
    box-shadow: 3px 5px 25px 13px rgba(204, 204, 204, 0.25);
    padding: 0;
    top: -36px !important;
    left: 30px !important;
}

.el-bg-table ul.dropdown-menu.el-action a.dropdown-item {
    border-bottom: 1px solid #ccc;
    padding: 10px 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0);
}

.el-bg-table ul.dropdown-menu.el-action a.dropdown-item:hover {
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%) !important;
    color: #fff;
}

.el-bg-table ul.dropdown-menu.el-action li {
    border-bottom: 1px solid #ccc;
}

.el-bg-table ul.dropdown-menu.el-action li:last-child {
    border: 0;
}

.el-bg-table .el-active {
    color: #03a827 !important;
    display: flex;
    align-items: center;
}

.el-bg-table .el-active .el-activebtn {
    width: 10px;
    height: 10px;
    background: #03a827 !important;
    margin-right: 15px;
    border-radius: 50%;
}

.el-bg-table .el-inactive {
    color: #3a3a3a !important;
    display: flex;
    align-items: center;
}

.el-bg-table .el-inactive .el-inactive {
    width: 10px;
    height: 10px;
    background: #222 !important;
    margin-right: 15px;
    border-radius: 50%;
}

.el-bg-table .el-table-container {
    padding: 0;
}

.el-bg-table .el-table-container th {
    background: #e6ebed;
    color: #161616;min-width: 100px;
}

.el-bg-table .el-table-container th:first-child {
    border-top-left-radius: 10px;
}

.el-bg-table .el-table-container th:last-child {
    border-top-right-radius: 10px;
}

.el-bg-table .el-table-container .table tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
}

.el-bg-table .el-table-container .table tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
}

.el-deactivate-modal .modal-body {
    padding: 30px;
}

.el-deactivate-modal .modal-body h2 {
    font-size: 24px;
    text-align: center;
    font-weight: 700;
    line-height: 32px;
    margin-bottom: 30px;
}

.el-deactivate-modal .modal-body .deactivateimg {
    width: 150px;
    margin: 20px auto;
    display: block;
    height: auto;
}

.el-deactivate-modal .el-filled-btn {
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
    color: #fff;
    margin: auto;
    padding: 4px 50px;
    font-size: 17px;
    margin: 0 15px;
}

.el-deactivate-modal .el-filled-btn :hover {
    color: #fff;
}

.el-deactivate-modal .el-bordered-btn {
    background: rgba(0, 0, 0, 0);
    color: #202224;
    margin: 0 15px;
    border: 1px solid #202224;
    margin: auto;
    padding: 4px 50px;
    font-size: 17px;
}

.el-deactivate-modal .w-f-content {
    width: fit-content;
}

.el-profile-board {
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 10px 15px 25px rgba(204, 204, 204, 0.459);
    border-radius: 20px;min-height: auto;
}

.el-profile-board h3 {
    font-size: 20px;
    line-height: 26px;
    font-weight: 600;
    color: #070a13;
    margin: 0;
}

.el-profile-board h4 {
    font-size: 20px;
    line-height: 26px;
    font-weight: 500;
    color: #070a13;
    margin: 0;
}

.el-profile-board h5 {
    font-size: 19px;
    line-height: 26px;
    font-weight: 700;
    color: #070a13;
    margin: 0;
}

.el-profile-board .el-border-rounded {
    width: fit-content;
    margin: 20px 10px;
}

.el-profile-board .el-property-details-card-content {
    width: 100%;
}

.el-profile-board .el-flexbox {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    align-items: center;
    border-bottom: 1px solid #cbd5e1;
    margin-bottom: 15px;
}

.el-profile-board .el-request-detail-profile-name {
    font-size: 12px;
    color: #000;
    line-height: 18px;
    font-weight: 600;
    margin-bottom: 0px !important;
}

.el-profile-board .el-request-detail-profile-name a {
    color: #000 !important;
    text-decoration: none;
}

.el-profile-board .location-icon {
    padding: 0 8px;
}

.el-profile-board .location-icon img {
    height: auto;
    width: 10px;
    margin-right: 10px;
}

.el-profile-board .el-card-content p {
    font-size: 12px;
    line-height: 18px;
    font-weight: 600;
    margin-bottom: 0px !important;
    color: #64748b;
}

.el-profile-board .el-border-rounded img {
    width: 100px;
    height: 100px;
    border-radius: 8px;
}



.el-profile-board .active {
    color: #03a827 !important;
}

.el-profile-board button.btn.btn-secondary.dropdown-toggle {
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
    border: 0;
    outline: 0;
}

.el-profile-board ul.dropdown-menu.el-admin {
    border: 0;
    box-sizing: border-box;
    overflow: hidden;
    box-shadow: 3px 5px 25px 13px rgba(204, 204, 204, 0.25);
    padding: 0;
    left: -80% !important;
}

.el-profile-board ul.dropdown-menu.el-admin a.dropdown-item {
    border-bottom: 1px solid #ccc;
    padding: 10px 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0);
}

.el-profile-board ul.dropdown-menu.el-admin a.dropdown-item:hover {
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%) !important;
    color: #fff;
}

.el-profile-board ul.dropdown-menu.el-admin li {
    border-bottom: 1px solid #ccc;
}

.el-profile-board ul.dropdown-menu.el-admin li:last-child {
    border: 0;
}

.el-profile-board .form-check {
    margin-bottom: 30px !important;
}

.el-profile-board .el-filled-btn {
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
    color: #fff;
    margin: auto;
    padding: 8px 20px;
    border: 1px solid rgba(0, 0, 0, 0);
    font-size: 17px;
    margin: 0 15px;
}

.el-profile-board .el-filled-btn:hover {
    color: #202224;
    background: rgba(0, 0, 0, 0) !important;
    border: 1px solid #202224;
}

.el-profile-board .el-bordered-btn {
    background: rgba(0, 0, 0, 0);
    color: #202224;
    margin: 0 15px;
    border: 1px solid #202224;
    margin: auto;
    padding: 8px 20px;
    font-size: 17px;
}

.el-profile-board .el-bordered-btn:hover {
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
    color: #fff;
    border: 1px solid rgba(0, 0, 0, 0);
}

.el-profile-board .w-f-content {
    width: fit-content;
}

@media (min-width: 768px) {
    .el-card-content .flex-sec {
        display: flex;
        justify-content: start;
        flex-wrap: wrap;
    }
}

.el-profile-board .el-card-content p {
    font-size: 16px;
    line-height: 24px;
    color: #000;
    font-family: "Mulish", sans-serif;
    margin-bottom: 5px !important;
    font-weight: 600;
}

.el-flex-area {
    display: flex;
     
    align-items: center;
}

.el-profile-board .el-request-detail-profile-name {
    font-size: 14px;
    color: #000000e8;
    line-height: 18px;
    font-weight: 500;
    margin-bottom: 0px !important;
}

.el-profile-board .location-icon img {
    height: auto;
    width: 21px;
    margin-right: 5px !important;
}

.el-profile-board .form-check {
    margin-bottom: 30px !important;
    color: #000;
    font-weight: 600;
    display: flex;
    align-items: center;
}

.el-profile-board .form-check .form-check-input[type="checkbox"] {
    border-radius: 0.25em;
    border: 1px solid #f16806;
    margin-right: 15px;
}

.el-profile-board .form-check .form-check-input:checked {
    background-color: #f16806;
    border-color: #f16806;
}

span.navbar-toggler-icon img {
    width: 14px;
    line-height: 40px;
}

span.navbar-toggler-icon {
    background: #f16806;
    position: absolute;
    right: 0;
    top: 40px;
    display: flex;
    width: 30px;
    height: 40px;
    border-radius: 6px 0 0 6px;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

#sidebar-open img {
    width: 24px;
}

.hr-line {
    margin-bottom: 20px;
    background: #cbd5e1;
    height: 1px;
    width: 100%;
}

.el-super-admin .form-check {
    margin-bottom: 30px;
    color: #000;
    font-weight: 600;
    display: flex;
    align-items: center;
}

.el-super-admin .form-check .form-check-input[type="checkbox"] {
    border-radius: 0.25em;
    border: 1px solid #f16806;
    margin-right: 15px;
}

.el-super-admin .form-check .form-check-input:checked {
    background-color: #f16806;
    border-color: #f16806;
}

.el-super-admin .el-filled-btn {
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
    color: #fff;
    margin: auto;
    padding: 8px 20px;
    border: 1px solid rgba(0, 0, 0, 0);
    font-size: 17px;
    margin: 0 15px 0 0;
}

.el-super-admin .el-filled-btn:hover {
    color: #202224;
    background: rgba(0, 0, 0, 0) !important;
    border: 1px solid #202224;
}

.el-or {
    position: relative;
}

.el-or h2 {
    background: #fff;
    font-size: 20px;
    position: absolute;
    width: 60px;
    top: -11px;
    border-radius: 0;
    text-align: center;
    font-size: 19px;
    font-weight: bold;
    padding: 2px;
    left: 19px;
    top: -15px;
    border-left: 1px solid #cbd5e1;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #cbd5e1;
}

.el-or .hr-line {
    margin: 40px 0;
}

.el-appoinment-duration label.form-label {
    font-size: 16px;
    margin-bottom: 15px;
    font-weight: 700;
}
label.form-label {
    font-weight: 700;
    font-size: 16px;
}
.el-appoinment-duration select.form-select {
    border: 1px solid #888;
}

.el-appoinment-duration input.form-control {
    border: 1px solid #888;
}

.el-appoinment-duration span.input-group-text {
    background: #f16806;
    border: 1px solid #888;
    color: #fff;
}

.el-appoinment-duration .form-select:focus {
    border-color: #f16806;
    box-shadow: 0 0 0 0.25rem rgba(241, 104, 6, 0.25);
}

.el-appoinment-duration .form-select option {
    background-color: #fff;
    color: #000;
}

.el-appoinment-duration .form-select option:hover {
    background-color: #f16806;
    color: #fff;
}

.el-appoinment-duration .form-select option:checked {
    background-color: #f16806;
    color: #fff;
}

.el-appoinment-duration .form-control:focus {
    border-color: #f16806;
    box-shadow: 0 0 0 0.25rem rgba(241, 104, 6, 0.25);
}

.form-switch .form-check-input {
    width: 51px !important;
    height: 23px;
    border-radius: 50px;
}

.form-check.form-switch .form-check-input {
    border-radius: 50px !important;
}

select.form-select.w-fit-content {
    width: fit-content;
}

.btn-hours-outline {
    width: fit-content !important;
    margin-right: auto;
    display: block;
    margin-left: 13px !important;
    margin-top: 15px !important;
    padding: 10px;
}

.el-super-admin select.form-select {
    border: 1px solid #888;
}

.el-super-admin .input-group-text {
    background: #f16806;
    border: 1px solid #888;
    color: #fff;
}

.ely-sample-request-details button.accordion-button {
    font-size: 18px;
    font-weight: 500;
}

.ely-sample-request-details .accordion-button:focus {
    box-shadow: none;
}

.ely-sample-request-details .accordion-button:not(.collapsed) {
    color: #000;
    background-color: #e6ebed4f;
    box-shadow: none;
}

.ely-sample-request-details .accordion-button:not(.collapsed)::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    transform: var(--bs-accordion-btn-icon-transform);
}

.ely-sample-request-details .accordion-item {
    margin-bottom: 20px;
}

.ely-sample-request-details .accordion-item:has(.show) {
    border: 0;
}

.ely-sample-request-details .accordion-body {
    padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
    background: rgba(204, 204, 204, 0.21);
    border: 0;
    box-shadow: none;
}

.ely-sample-request-details button.accordion-button[aria-expanded="true"] .badge {
    background: #dc3545  !important;
    color: #fff !important;
}
 
.ely-sample-request-details div#accordionFlushExample1 .accordion-button:not(.collapsed) {
    color: #212529 !important;
}

.ely-sample-request-details div#accordionFlushExample1 .accordion-button:not(.collapsed)::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    transform: var(--bs-accordion-btn-icon-transform);
}

 
.ely-sample-request-details div#accordionFlushExample1 .accordion-body {
    padding: 20px;
 border: 0;
    border-top: 0;
    background: #fff;
    box-shadow: 7px 5px 18px rgba(0, 0, 0, .0705882353);
}
.ely-sample-request-details div#accordionFlushExample1 .accordion-item .dropdown-toggle {
    background: #f4f4f4 !important;
     
    padding: 10px 10px;
    justify-content: center;
    width: 40px;
    height: 40px;
    display: flex;
}
.ely-sample-request-details div#accordionFlushExample1 .accordion-item .dropdown-toggle img {
    margin: auto;
    display: block;
}

.ely-sample-request-details div#accordionFlushExample1 .accordion-item .dropdown-toggle::after {
    display: none !important;
}
 
.form-select {
    height: 50px !important;
    border: 1px solid #888 !important;
}

.el-mb-0 {
    margin-bottom: 0px !important;
}

.w-f-content {
    width: fit-content;
}

@media (max-width: 768px) {
    .el-bg-table .d-flex:first-child {
        flex-wrap: wrap;
    }
    .el-bg-table h3 {
        margin-bottom: 20px;
    }
    .form-select {
        margin-bottom: 15px;
    }
    .el-property-details-card-content select {
        margin-top: 30px;
    }
    .el-property-details-card-content .col-md-3 select {
        margin-top: 0;
    }
}

/* sidebar closing arrow */

span.navbar-toggler-icon img {
    width: 14px;
    line-height: 40px;
}

span.navbar-toggler-icon {
    background: #f16806;
    position: absolute;
    right: 0;
    top: 40px;
    display: flex;
    width: 30px;
    height: 40px;
    border-radius: 6px 0 0 6px;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

#sidebar-open img {
    width: 20px;
}


@media (max-width: 1300px) {
    .el-middle-top {
        flex-wrap: wrap;
    }
}

@media (min-width: 992px) and (max-width: 1300px) {
    .el-middle-top .el-middle-top-col {
        margin-bottom: 15px;
        max-width: 100%;
        min-width: 400px;
    }
}

@media (min-width: 568px) and (max-width: 768px) {
    .el-middle-top .el-middle-top-col {
        margin-bottom: 15px;
        max-width: 100%;
        min-width: fit-content;
    }
}

@media (min-width: 568px) {
    .el-middle-top-col {
        margin-bottom: 15px;
        max-width: 100%;
        min-width: fit-content;
    }
}

@media (max-width: 568px) {
    .el-middle-top-col {
        margin-bottom: 15px;
        max-width: 100%;
        min-width: 100%;
    }
}

@media (max-width: 1400px) {
    .el-table-container.el-board-table {
        display: block;
        width: 100%;
        overflow: unset;
    }
    .el-table-container .table {
        margin: 0;
        overflow: auto;
    }
}

.el-middle-top-col {
    margin-right: 1%;
    display: flex;
    align-items: center;
    border-radius: 12px;
    padding: 12px 20px;
    background: #f47403;
    background: linear-gradient(136deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
}

@media (min-width: 1600px) {
    .el-middle-top-col {
        width: 24%;
    }
}

@media (min-width: 1201px) {
    .el-middle-top-col {
        flex-wrap: wrap;
    }
}

.el-middle-top-col strong {
    display: block;
    font-size: 32px;
    color: #fff;
    margin: 0 0 10px;
}

.el-middle-top-col span {
    font-size: 18px;
    color: #fff;
    font-weight: bold;
}

.el-middle-top-col + .el-middle-top-col {
    background: #e83f12;
    background: linear-gradient(136deg, rgb(232, 63, 18) 0%, rgb(189, 75, 118) 58%, rgb(145, 79, 179) 100%);
}

.el-middle-top-col + .el-middle-top-col + .el-middle-top-col {
    background: #8d4db2;
    background: linear-gradient(
        136deg,
        rgb(141, 77, 178) 0%,
        rgb(141, 77, 178) 40%,
        rgb(123, 64, 157) 64%,
        rgb(72, 26, 98) 92%
    );
}

@media (max-width: 568px) {
    .el-topbar-right {
        display: none;
    }
    .el-topbar {
        padding: 20px;
    }
}

.el-middle {
    transition: all 0.5s linear;
}

.el-middle.collapsed-body {
    width: 100%;
    padding: 0;
}

@media (min-width: 992px) {
    .el-topbar.el-middle.collapsed-body {
        padding: 15px 45px;
    }
}
@media (max-width: 991px) {
    .el-topbar.el-middle.collapsed-body {
        padding: 20px !important;
    }
    .el-middle #sidebar-open {
        display: block !important;
    }
    button#sidebar-open {
        position: unset !important;
    }
}

.el-middle #sidebar-open {
    display: none;
}

.el-middle.collapsed-body #sidebar-open {
    display: block;
}

button#sidebar-open {
    position: absolute;
}

.el-board-table th .dropdown-menu.show {
    padding: 12px 12px;
    min-width:240px;
    border: 0;
    box-shadow: 6px 20px 45px #cccccc70;
}

.el-board-table th .form-check-input[type="checkbox"] {
    border-radius: 0.25em;
    margin-top: 0;
    border: 1px solid #000;
}

.el-board-table th input.btn.btn-link {
    padding: 0;
    text-decoration: none;
    border-top: 1px solid #ccc;
    border-radius: 0;
    width: 100%;
    margin-top: 16px;
    font-weight: 700;
    padding: 6px 0 0 0;
    color: #e63516;
}

.el-board-table th .form-check {
    margin-bottom: 15px!important;
}
.el-board-table th input.btn.btn-link {
    margin-top: 0;
}
.el-board-table th .form-check-input:checked {
    background-color: #f47324;
    border-color: #f47324;
}
.el-board-table th label {
    margin-right: 10px;
}

.el-board-table th input[type="text"] {
    width: 90%;
    position: absolute;
    left:0;
    top: 4px;
    height: 85%;
    border: 0;
    padding: 0 15px;
    border-radius: 10px ;padding-left: 40px!important;
}
.el-board-table th {
    position: relative;
}

/* .el-board-table button#roleFilterDropdown:hover { */
    /* background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%); */
/* } */

.el-board-table .btn.show {
    background: transparent;
}

input[type="text"]:focus-visible {
    border: 0;
    outline: 0;
}

  a.nav-link.active i {
    color: #fff !important;
}

 a.nav-link:hover i {
    color: #fff !important;
}
.el-searchimg {
    width: 25px;
    height: 28px;
    background: #ffffff;
    z-index: 999;
    position: absolute; 
    left:1px;
    display: flex;cursor: pointer;
    align-items: center;
    justify-content: center;
    color: #888;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-right: 1px solid #888;
} 
.el-table-input + input {
    padding-left: 30px !important;
}
.el-board-table .el-table-input {
    display: flex;height: 30px;
    align-items: center;
}
.el-board-table .el-table-input svg{
    cursor: pointer;
}

.el-table-input:has(label) {
    position: relative; 
}
.el-page-count {
    display: flex;
    align-items: center; 
    padding: 6px 0px;
    font-weight: 700;
    border-radius: 8px;
    color: #161616;
}

.el-page-count .btn-link {
    color: #161616;
    text-decoration: none;
}
.el-page-count .btn-link:hover {
    color: #161616;
}

  a.page-link {
    background: #EB4E0E;
    color: #fff;
    font-size: 18px;
    border: 0;border-radius: 5px;
}
.el-board-table .btn:focus-visible {
    background: transparent !important;
}
/* .el-board-table .btn:hover {
    background: transparent !important;
} */
  li.page-item.disabled .page-link {
    background: transparent !important;
    border: 0;
    font-size: 50px;
    color: #003479 !important;
}

.el-bg-table.el-super-admin .col-md-4 {
    margin-bottom: 0px;
}

.form-check-input{
    margin-top: 0!important; color:  #888;
}
@media(max-width:991px){
.el-searchimg {  
    left: 0; 
}}
.dropdown-item:active{
    background: #fb8b43!important;
}
.toast-container{
    z-index: 99999!important;
}



/*  */
.text-red{
    margin-left: 5px;
    color: red;
}

.react-datepicker-wrapper {
    display: block;
}

.remove-btn-wrapper button {
    padding: 5px 15px !important;
}
.remove-btn-wrapper {
    margin-bottom: 15px;
}

.text-green{
    margin-left: 5px;
    color: green;
}


.child-wrapper {
    position: relative;
}

.child-wrapper::before {
    content: "";
    position: absolute;
    background: #eee;
    width: 1px;
    height: 100%;
    left: 20px;
    top: -15px;
}

.child-menu-permission {
    padding-left: 40px !important;
    position: relative;
}

.child-menu-permission::before {
    content: "";
    position: absolute;
    background: #ccc;
    width: 20px;
    height: 1px;
    top: 12px;
    left: 20px;
}
.text-bodyla-fluid {
    color: #796c00 !important;
}
.text-exhaledbreath {
    color: #1ce4ff !important;
}
.text-skin-tap {
    color: #C98C55 !important
}

.text-hair-follicle {
    color: #000 !important;
}

.text-stool {
    color: #a3622c !important;
}
/* CSS to remove arrows from number input */
.no-arrows::-webkit-outer-spin-button,
.no-arrows::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.no-arrows[type="number"] { /* For Firefox */
    appearance: textfield; 
}

.el-blood-donation-section {
    margin-top: 50px;
}
.bg-bodyla-fluid {
    background: #4d460c !important;
    background-image: initial !important;
    background-position-x: initial !important;
    background-position-y: initial !important;
    background-size: initial !important;
    background-repeat: initial !important;
    background-attachment: initial !important;
    background-origin: initial !important;
    background-clip: initial !important;
    background-color: rgb(77, 70, 12) !important;
    font-size: 14px;
}

.text-white {
    --bs-text-opacity: 1!important;
    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}
.bg-bukkal-swab {
    background:#E8598C !important;
    font-size: 14px;
}
.el-dononr-sample-type .btn {
    background: #fff;
    margin: 10px 15px;
    font-weight: 600;
    border: 1px solid #f16806;
    font-size: 18px;
    cursor: auto;
    padding: 6px 7px;text-align: left;
    min-width: 140px;
    font-size: 15px;
}
.bg-hair-follicle {
    background: #353333 !important;
    font-size: 14px;
}
.bg-text-skin-tap {
    background: #8d5524 !important;
    font-size: 14px;
}
.bg-stool {
    background:#674F12 !important;
    font-size: 14px;
}

/* .form-control {
    background: RGB(255, 255, 255);
    border: 1px solid rgba(0, 0, 0, .47);
    border-radius: 10px;
    padding: 17px 20px;
    font-weight: 500;
    font-size: inherit;
    line-height: inherit;
 
    color: #000;
    min-height: 53px;
} */
.form-control.invalid {
    border-color: red !important;
}

.ely-sample-request-details div#accordionFlushExample1 .accordion-item button {
    background: #f4f4f4;
    border: 0px solid var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
    padding: 10px 10px;
    font-size: 15px;
}
 

.ely-sample-request-details div#accordionFlushExample1 .accordion-button:not(.collapsed) {
    color: #212529 !important;
    background: #e8e8e8;
} 

.el-line-btns {
    background: rgba(0, 0, 0, 0) !important;
    color: #f47403;
    font-size: 17px;
    margin: 0 15px;
    height: fit-content;
    border: 1px solid #f47403 !important;
    padding: 24px 30px !important;
    line-height: 0!important;
    font-weight: 600;
} 
span.navbar-toggler-icon {
    background: linear-gradient(136deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
    position: relative;
    left: 58px;
    top: -2px;
    display: flex;
    width: 22px;
    height: 34px;
    border-radius: 0 5px 5px 0;
    align-items: center;
    justify-content: center;
    z-index: 9999;
} 
.el-sidebar {
    height: 100vh;
    overflow: visible;
    background: #fff;
    position: fixed;
    left: 0;
    transition: all 0.5s ease;
    top: 0;
    z-index: 99!important;
}

.el-main-button {  
        font-weight: 700;
        padding: 8px 16px;
        color: #ee5b0b!important;
        border: 1px solid #ee5b0b!important;
        font-size: 16px;
        overflow: hidden;
        border-radius: 50px;
        display: flex;
        align-items: center;
        background: transparent;
        pointer-events: auto;
        position: relative;
        cursor: pointer;
        width: fit-content!important;
        margin: 0 30px 0 0;
        transition: color 0.2s ease-in;
} 

.el-error-button {  
    font-weight: 700;
    padding: 8px 16px;
    color: #ff0000 !important;
    border: 1px solid #ff0000 !important;
    font-size: 16px;
    overflow: hidden;
    border-radius: 50px;
    display: flex;
    align-items: center;
    background: transparent;
    pointer-events: auto;
    position: relative;
    cursor: pointer;
    width: fit-content!important;
    margin: 0 30px 0 0;
    transition: color 0.2s ease-in;
}
  
.el-main-button:after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute; 
    left: -100%;
    top: 0;
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%); 
    transition: all .2s ease-in;
}

.el-error-button:after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute; 
    left: -100%;
    top: 0;
    background: linear-gradient(321deg, rgb(244, 3, 3) 0%, rgb(227, 42, 25) 100%); 
    transition: all .2s ease-in;
}

.el-main-button:hover::after,
.el-error-button:hover::after {
    left: 0;
}

.el-main-button:hover span,
.el-error-button:hover span {
    color: #fff; position: relative;
    z-index: 99;
}

.el-main-button:hover span,
.el-error-button:hover span {
    transition-delay: 0.1s;
}


.el-super-admin .el-filled-btn {
    font-weight: 700;
    padding: 8px 16px;    
    color: #ee5b0b;
    border: 1px solid #ee5b0b;
    font-size: 16px;
    overflow: hidden; 
    border-radius: 6px;display: flex;align-items: center;
    background: transparent; 
    pointer-events: auto;
    position: relative; 
    cursor: pointer; 
    transition: color 0.2s linear;
}


.el-super-admin .el-filled-btn:after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute; 
    left: -100%;
    top: 0;
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%); 
    transition: all .2s linear;
}

.el-super-admin .el-filled-btn:hover::after {
    left: 0;
}

.el-super-admin .el-filled-btn:hover span {
    color: #fff; position: relative;
    z-index: 99;
}

.el-super-admin .el-filled-btn:hover span {
    transition-delay: 0.2s;
}
 
.el-main-button i{
    font-size: 20px;
}
.el-board-table .el-table-input label{
    font-weight: 600;
    color: #161616;
}
.el-min-height-content {
    min-height: 140px;
}
  
.el-text-btn {
    color: #ee5b0b;
    outline: 0;
    border: 0;
    background: transparent;
    font-weight: 700;
    text-decoration: underline;
}

/* @media(min-width:1600px){
    .el-bg-table.el-super-admin > form {
        width: 80%;
    }
} */
.form-control {
    display: block;
    width: 100%;
    padding: .375rem .75rem;
    font-size: 1rem;
    border: 1px solid #00000091!important;
    font-weight: 400;
    line-height: 1.5;
    min-height: 50px;
    background: transparent;
    color: var(--bs-body-color);
    appearance: none;
    background-color: #f1f1f1;
    background-clip: padding-box;
    border-radius: var(--bs-border-radius);
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.form-check-input[type=radio] {
    border-radius: 50%;
    border: 1px solid #00000091!important;
}

button + .back-link {
    color: #000000!important;
    
}

.el-sidebar .el-navlabel { 
    color: #000000; 
}
.el-sidebar .el-navlabel:before { 
    background: #000000; 
}
.el-sidebar .nav-item .nav-link.active {
    background: transparent;
    background: transparent;
    color: #202224;
    border: 1px solid #eb4e0e;
    border-radius: 50px;font-weight: 700;
}
a.nav-link.active i, a.nav-link:hover i {
    color: #eb4e0e!important 
}
.el-sidebar .nav-item .nav-link{
    margin-bottom: 5px; 
}
table.table.table-striped.table td {
    background: transparent;
    box-shadow: none;
}
.el-board-table .el-table-input label, .el-bg-table .btn-primary, .el-board-table th label {
    font-weight: 600;
    color: #161616!important;
    font-size: 17px;
} 


.el-table-container .table tbody tr:last-child td .dropdown-toggle::after{
     opacity: 0;
}

button.text-danger.btn.btn-outlined-secondary {
    background: transparent;
    padding: 0;
    width: 35px;
    height: 35px;
    /* border: 1px solid #eb4e0e; */
}
/* table.table.table-striped.table td .btn{ */
    /* background: transparent;
    padding: 0;
    width: 35px;
    height: 35px;
    border: 1px solid #eb4e0e;border-radius: 5px; */
    /* color: #eb4e0e!important; */
    /* margin: 0 5px; */
/* } */

table.table.table-striped.table td .btn {
    background: transparent;
    /* padding: 0; */
    width: auto;
    height: auto;
    padding-top: 0;
    padding-bottom: 0;
    border: none;
    border-radius: 5px; 
    color: #000; 
    margin: 0;
}

table.table.table-striped.table td .btn.text-danger{
    color: #000!important;
} 


button#dropdown-basic{
    border: 0;
}
.el-sidebar .nav-item .nav-link.active:before {    content: '';
    width: 8px;
    height: 90%;
    background: linear-gradient(136deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);
    position: absolute;
    left: 0;
    border-radius: 0 5px 5px 0;
    top: 3px;

}
 
.el-sidebar .nav-item {
    /* padding: 0 20px; */
    padding: 0 0px;
    position: relative;
}
.el-sidebar .nav-item .nav-link.active, .el-sidebar .nav-item .nav-link:hover {
    background: transparent;
    background: transparent;
    color: #eb4e0e;
    font-weight: 600;
    border: 0px solid #eb4e0e;
    border-radius: 50px;
}
 
.el-sidebar .nav-item .nav-link.active span {
    display: inline-block;
    vertical-align: middle;
    color: #eb4e0e!important;
    margin: 0 0 0 8px;
}

.el-sidebar .nav-item .nav-link span {
    display: inline-block;
    vertical-align: middle;
    margin: 0 0 0 8px;
    font-weight: 600;
}
.el-topbar {
    transition: all 0.5s linear;
    border-bottom: 1px solid #dee2e6;
}
.el-sidebar{
    border-right: 1px solid #dee2e6;
}
.el-sidebar .navbar-expand-lg {
    padding-top: 14px; 
}
.el-logo {
    height: 96px; 
}
 
.el-middle-content { 
    box-shadow: 4px 11px 25px #20202012;
}
.el-board-table  th {
    padding: 10px!important;
}
.el-board-table  th {
    position: relative;
    line-height: 100%;
}
.el-board-table  th {
    padding: 10px 13px!important;
}

.el-board-table .job-list-st-filter {
    padding: 0px !important;
}
.job-list-st-filter #statusFilterDropdown::after {
    display: none;
    content: none;
}

.el-action.dropdown-menu {
    box-shadow: -5px 2px 25px #3733332e;padding: 0;overflow: hidden;
}
.el-action.dropdown-menu  a.dropdown-item {
    padding: 4px 8px;
    margin: 0 0 5px 0;
    font-weight: 600;
}
.el-action.dropdown-menu  a.dropdown-item:last-child{
    margin: 0;
}
.el-action.dropdown-menu  a.dropdown-item:hover{
    background: #eb4e0e; 
    color: #fff!important;
}
.el-action.dropdown-menu  a.dropdown-item:hover label{
    background: #eb4e0e; 
    color: #fff!important;
}

.dropdown-item:hover{
    background: #eb4e0e!important; 
    color: #fff!important;
}
.dropdown-menu{
    padding: 0;margin: 0;border-radius: 5px!important;
}
.dropdown-menu.show {
    display: block;overflow: hidden;
    padding: 0;
}
button.back-link  {
    outline: 0;
    background: transparent;
    border: 0;
}
 
td .dropdown button::after {
    opacity: 0;
}
li.page-item {
    margin: 0 5px;
}

td .btn.btn-primary {
    height: auto;
    padding-top: 0px;
    padding-bottom: 0px;
    text-align: left !important;
    justify-content: flex-start;
    border-radius: 6px;
    color: #fff !important;
    font-weight: 600;
    min-height: initial !important;
    /* padding-left: 8px !important; */
    min-width: 100px;
    font-size: 16px;
    font-weight: 700;
    padding: 5px 15px;
    text-align: center;
}
.btn.btn-primary.blood:hover{
    background: #c82121;color: #c82121!important;
}
.dropdown-item { 
    padding: 7px 7px!important; 
}

/* icons shadow */

/* .el-icon-job-board:before,.el-icon-upcoming-donation:before, .el-icon-donation-history:before, .el-icon-donation-history:before, .el-icon-email-sms:before,.el-icon-profile-setting:before, .el-icon-email-sms:before  { 
    text-shadow: 1px 0px #000;
}  */
/* Default text shadow for icons */
/* .el-icon-job-board:before,
.el-icon-upcoming-donation:before,
.el-icon-donation-history:before,
.el-icon-email-sms:before,
.el-icon-profile-setting:before {
    text-shadow: 1px 0px #000;
} */

/* Text shadow on hover */
.el-sidebar .nav-item .nav-link:hover .el-icon-job-board:before,
.el-sidebar .nav-item .nav-link:hover .el-icon-upcoming-donation:before,
.el-sidebar .nav-item .nav-link:hover .el-icon-donation-history:before,
.el-sidebar .nav-item .nav-link:hover .el-icon-email-sms:before,
.el-sidebar .nav-item .nav-link:hover .el-icon-profile-setting:before {
    text-shadow: 1px 0px #eb4e0e;
}

.w-40{width: 40%;}
.w-20{width: 20%;}
.w-30{width: 30%;}
button.text-danger:has(.el-icon-trash) {
    border: 1px solid #dc3545;
    background: transparent;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0;
    border-radius: 5px;
}
button.text-danger:has(.el-icon-trash):hover {
background: #dc3545;color: #fff;
}
button.text-danger:hover i {
color: #fff;
}

/* table.table.table-striped.table td .btn:hover i{
     color: #eb4e0e; 
} */
.bs-popover-end>.popover-arrow::after, .bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after { 
    border-right-color: #e9ecef!important;
}

.el-bg-table .el-table-container th {
    background: #e6ebed;
    color: #161616;
    vertical-align: middle;
    min-width: 100px;
}

.el-bg-table .el-table-container th {
    background: #e6ebed4f;
    color: #161616;
    min-width: 100px;
}

li.page-item.disabled .page-link {
    background: transparent !important;
    border: 0;
    line-height: 17px;
    font-size: 35px;
    color: #000!important;
}


.btn-outlined-secondary i {
    font-size: 24px!important;
}


  span.page-link span { 
    position: relative;
    visibility: hidden;
}

.backbtnarrow span.page-link span::after{
    content: "5";
    font-size: 16px;font-family: "elily";
    cursor: pointer;
    left: 0;
    line-height: 24px;
    position: absolute;
    visibility: visible;
    opacity: 1;
}  

.nexttnarrow span.page-link span::after{
    content: "v";
    font-size: 16px;font-family: "elily";
    cursor: pointer;
    right: 0;
    line-height: 24px;
    position: absolute;
    visibility: visible;
    opacity: 1;
}   
.page-link:hover{
    border: 1px solid #eb4e0e!important;
    color:#eb4e0e!important; ;
}
.page-link{
    border: 1px solid transparent!important;
}

.alert.alert-dark.h-100 {
    background: #eaf3fd9c;border: 1px solid #d0e3f7;
}

.disabled {
    opacity: .6;
}

.ely-sample-request-details div#accordionFlushExample1 .accordion-item button {
    background: #f4f4f4;
    border: 1px solid var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
    padding: 10px 10px;
    font-size: 15px;
}


.el-line-btns {
    background: rgba(0, 0, 0, 0) !important;
    color: #f47403;
    font-size: 17px;
    margin: 0 15px;
    height: fit-content;
    border: 1px solid #f47403 !important;
    padding: 24px 30px !important;
    line-height: 0!important;
    font-weight: 600;
}
.el-fill-btns {
    background: linear-gradient(321deg, #f47403 0%, rgb(227, 42, 25) 100%) !important;
    color: #fff;
    font-size: 17px;
    margin: 0 15px;
    height: fit-content;
    border: 1px solid #f47403;
    padding: 24px 30px !important;
    line-height: 0!important;
    font-weight: 600;
}

.el-custom-button i.el-icon-blood ,.el-custom-button  .el-icon-urine, .el-custom-button  i.el-icon-saliva{
    font-size: 16px!important;
}
.el-sidebar .navbar-expand-lg .navbar-collapse {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: normal;
    height: 100vh;
    overflow: auto;
}
@media(max-width:1500px){
    .el-sidebar .navbar-expand-lg .navbar-collapse {
    height: 80vh;}
}
 
 
 
 
.navbar-drop-buttons{
    background: transparent!important;
    border: 0;
    outline: 0;
    min-height: 43px;
    font-size: 17px;
    font-weight: 700;
    padding: 8px 16px;
    color: #ee5b0b!important;
    border: 1px solid #ee5b0b!important;
    font-size: 16px;
    overflow: hidden;
    border-radius: 50px!important;
    display: flex;
    align-items: center;
    background: transparent;
    pointer-events: auto;
    position: relative;
    cursor: pointer;
    width: fit-content !important; 
    transition: color 0.2s linear;
}
.dropdown-menu.show { 
        display: block;
        border-color: #ee5b0b;
        padding: 12px 0; 
}
.navbar-drop-buttons:hover{
    background:#ee5b0b!important ;
    color: #fff!important;
}
td .navbar-drop-buttons:hover{
    background:transparent!important ;
    color: #fff!important;
}
td .navbar-drop-buttons{
    border: 0!important;
}
.el-bg-table label.form-label {
    font-weight: 700;
    font-size: 15px;
    position: relative;
    margin-top: 2px !important;
    /* left: 9px; */
    left: 10px;;
    /* bottom: -19px; */
    bottom: -15px;
    z-index: 9;
    background: #fff;
    /* padding: 0 10px; */
    padding: 0 5px;
}

[class*=btn-outlined-secondary] i {
    width: 24px;
    height: 24px;
    font-size: 24px!important;
    display: inline-flex;
    color: #000!important;
    margin: 0 8px;
    align-items: center;
    justify-content: center; 
}
.el-flexarea-icon{
    align-items: center;
    border-radius: 6px;
    display: inline-flex;
    height: 24px;
    justify-content: space-evenly;
    max-width: 100%;
    padding: 0px!important;
    width: auto;
    margin-top: 10px;
}

.el-flexarea-icon .button {
    padding: 0;
}
button.text-urine.btn.btn-outlined-secondary {
    padding: 0;
}
.el-icon-urine:before{
  font-size: 80%;
}
.el-icon-saliva:before{
    font-size: 80%;
  }
  table.table.table-striped.table td .btn{
    padding: 0;
  }
    

  .modal-header {
    background: #e6ebed4f;
}

.modal-header .h4 {
    font-size: 24px;
    margin-bottom: 0;
}

.modal-body .form-check {
    margin-bottom: 15px!important;
} 

.css-5wchs2-MuiDateCalendar-root {
    margin: 0;
    border: 1px solid #ccc;
    padding: 0;
    border-radius: 20px;
} 
 
.modal-body:has(.el-super-admin){
    padding: 0;
}
.modal-body:has(.el-super-admin) form {
    width: fit-content;
    margin: auto;
}
.react-datepicker-popper {
    z-index: 1;
    line-height: 0;
    z-index: 999;
}
.form-control:focus { 
    box-shadow: 0 0 0 .25rem rgba(222, 228, 255, 0.644)!important;
}
.opened-label{
    margin-top: -6px;
}
.bg-danger {
    border: 1px solid transparent!important;
    background: #C82121 !important;
}
.bg-saliva-fluid{
background: #d7b91c !important;
}

.bg-hair-follicle{
  background:  #3C3C3C !important
}
.bg-bodyla-fluid{
background: #d7b91c !important ;  border: 1px solid transparent!important;
}

.bg-exhaledbreath {
background: #d7b91c !important;  border: 1px solid transparent!important;
}
 
.bg-warning{
    background: #d7b91c !important; 
}
 
.el-sample-btn {
    padding: 5px 15px 5px 10px !important;
    font-weight: 800!important;color: #fff!important;
    border: 1px solid transparent!important;
}
.el-sample-btn:hover{
    color: #fff!important;
}
.el-dononr-sample-type .btn i:before {
    font-size: 100%!important;
}
.el-flex-area img {
    margin-top: 5px;
    width: 18px!important;
}
.el-flex-area {
    display: flex;
    align-items: start;
}
.el-icons-bg-box:has(.btn-outlined-secondary){
    background: #003479b6;border-radius: 6px;padding: 5px; color: #fff!important;flex-wrap: nowrap!important; display: flex;width: fit-content;
}
.el-icons-bg-box:has(.btn-outlined-secondary) i{
    color: #fff!important;
}
.el-sample-btn:hover {
    filter: brightness(.9);
}
.el-profile-board .el-flex-area {
    margin: 15px 20px 15px 0;
}
 
@media(min-width:1600px){
    .el-profile-board .el-flex-area {
        margin: 15px 40px 15px 0;
    }
}

 

 
.dropdown-toggle .form-check {
    margin-bottom: 0!important;
}

/* sample request   */
 .el-custom-accordion {
    width: 70%!important;
}
.el-custom-accordion   .accordion-body  .accordion-item .accordion-body {
    padding-left: 24px!important;
}
.el-custom-accordion .accordion-body .accordion-item .accordion-body:has(.text-danger) {
    padding-left: 15px !important;
}
.el-custom-accordion .el-flex-area {
    display: flex;
    flex-direction: column;
    align-items: start;
}
 .el-custom-accordion .accordion-body img{
    display: none;
}
.el-custom-accordion   .accordion-body {
    padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
    background: #fff;
    box-shadow: none;
    box-shadow: 7px 13px 20px 0px #00000012;
    border-radius: 0 0 10px 10px;
    border: 1px solid #f1f1f196;
}
 
.el-custom-accordion button.accordion-button {
    background: #f2f2f2;border-radius: 12px;
}

.el-custom-accordion  .flex-sec {
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    flex-direction: column!important;
}
.el-custom-accordion  .flex-sec div:first-child{
    margin-top: 0;
}

.el-custom-accordion  p {
    font-size: 20px;
    line-height: 24px;
    color: #000; 
    margin-bottom: 5px !important;
    font-weight: 600;
}
  


.el-custom-accordion .accordion-item {
    border: 0;
}
.el-custom-accordion .accordion-button:not(.collapsed) {
    color: #000;
    background-color: #f2f2f2;
    box-shadow: none;
}
/* .el-custom-accordion  .mx-fit-content.col-md-12 {
    padding: 0;
} */

.el-custom-accordion  .el-request-detail-profile-title {
    font-size: 17px!important; font-weight: bold;
    line-height: 24px;
    color: #000; 
    margin-bottom: 5px !important;
    font-weight: 700!important;
}
 


.el-custom-accordion  .el-content-detail {
    display: flex;
    align-items: start;
}
.el-custom-accordion .el-request-detail-profile-name{
    margin-left: 10px;  font-size: 17px!important; 
    line-height: 24px;
    color: #000; font-weight: 500;
    margin-bottom: 5px !important; 
}
/* .el-custom-accordion .accordion-header button {
    font-size: 19px!important;
} */

th , th button, th label{
    font-weight: 700!important;
}
.el-page-count button#dropdown-basic-button {
    padding: 0;
}
.el-icons-bg-box button {
    border-right: 1px solid #ffffff66 !important;
    border-radius: 0!important;
}
.el-icons-bg-box button:last-child{
    border-right:0px solid #ffffff66 !important;
}
.el-custom-accordion .accordion-body .el-content-detail {
    display: block!important;
}

.el-custom-accordion .el-custom-accordion .el-request-detail-profile-name{
    margin-left:0 
}
.el-custom-accordion .accordion-body h4.el-request-detail-profile-name {
    padding: 0;
    margin-left: 0!important;
}

.el-custom-accordion .accordion-body .el-flex-area {
    margin: 5px 0 !important;
}
.el-custom-accordion .accordion-body p.el-request-detail-profile-name {
    margin: 0!important;
}
.el-custom-accordion .accordion-body p.el-request-detail-profile-name {
    margin: 5px 0!important;
    font-weight: 500!important;
}
button.accordion-button div:has(i) {
    padding: 5px 30px 5px 20px!important;
    text-align: start;
}

.ely-sample-request-details div#accordionFlushExample1 .accordion-item button {
    background: transparent;
    border: 0px solid #aeb2ae;
    padding: 15px 10px;
    font-size: 15px; 
}  
#accordionFlushExample1 .flex-sec.justify-content-between.col-xxl-6 {
    padding: 0 ;
}
span.text-bg-success.badge {
    padding: 10px;
}


span.text-bg-success.badge i.el-icon-dot.mb-0 {
    font-size: 34px;
    line-height: 0;
    position: relative;
    top: 6px !important;
}
span.text-bg-success.badge .el-icon-dot:before {
    content: "N";
    line-height: 0;
    margin: 0;
    padding: 0;
    height: 0;
} 

#accordionFlushExample .accordion  .accordion-item, #accordionFlushExample1  .accordion  .accordion-item{
    border: 1px solid #00000021 ;
    padding: 0!important;
    border-radius: 15px!important;
    overflow: hidden;
}

/* .btn.bg-bodyla-fluid:hover i{  */
  /* color: #4d460c!important; */
/* } */

.css-5wchs2-MuiDateCalendar-root{
    width:100%!important
}


.el-main-active{
 
    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%); 
  color: white!important;
}

.el-schedule-pickup-sr-modal {
    max-width: 50% !important;
}
.el-change-appointment-time-modal {
    max-width: 80% !important;
}
.el-change-appointment-time-modal .modal-body {
    padding: 60px!important; 
}

/** Autocomplete Style **/
.autocomplete-container {
    position: relative;
}

.input-wrapper {
position: relative;
width: 100%;
}

.search-icon {
position: absolute;
left: 10px;
top: 50%;
transform: translateY(-50%);
font-size: 16px;
color: #888;
}

.autocomplete-input {
padding: .375rem 0.75rem .375rem 2.5rem !important;
}

.autocomplete-dropdown {
background-color: #fff;
border-bottom: 1px solid #f2f2f2;
border-left: 1px solid #f2f2f2;
border-radius: 4px;
border-right: 1px solid #f2f2f2;
left: 12px;
max-height: 200px;
overflow-y: auto;
position: absolute;
right: 12px;
top: 81%;
z-index: 10;
}

.autocomplete-item {
padding: 10px;
cursor: pointer;
}

.autocomplete-item:hover,
.autocomplete-item.active {
background-color: #F2F2F2;
}

.no-suggestions {
padding: 10px;
color: #999;
}


.radio-wrapper .form-check {
    padding-right: 1.5rem;
    margin-bottom: 5px !important;
}

.sample-type-dropdown-menu {
    width: 400px;
    padding: 20px 50px !important;
}

.sample-type-dropdown-menu .form-check {
    margin-bottom: 5px !important;
}

.el-bg-inner-table {
    border: 1px solid #f2f2f2;
    box-shadow: none !important;
}

.sample-heading {
    font-weight: 700 !important;
}
body .sample-type {    
    color: #fff !important;
    padding: 5px 30px 2px 15px;
    border-radius: 5px;
}
.sample-type i {
    display: inline-block;
    padding-right: 10px;
}
.sample-type.text-danger {
    background-color: #C82121;
}
.sample-type.text-urine,
.sample-type.text-exhaled-breath,
.sample-type.text-saliva {
    background-color: #E3BF00;
}
.sample-type.text-bukkal-swab {
    background-color: #E8598C;
}
.sample-type.text-hair-follicle {
    background-color:#3C3C3C;
}
.sample-type.text-skin-tap {
    background-color:#C98C55;
}
.sample-type.text-stool {
    background-color: #674F12;
}



.el-bg-content-inner .el-bg-collapsable {
    position: absolute;
    border: none;
    background-color: transparent;  
    width: 100%;
    right: 20px;
    margin-top: -30px;  
}

.el-bg-content-inner .el-bg-collapsable i::before {
    font-size: 24px;
    font-weight: 300;
    padding: 0;
    width: auto;
    margin: 0;
    float: inline-end;
}
.el-bg-content-inner .el-bg-collapsable i::before {
    font-size: 24px;
    font-weight: 300;
    padding: 0;
    width: auto;
    margin: 0;
}

.el-bg-collapsible-content { 
    transform-origin: top; 
    transition: transform 0.3s ease;  
    opacity: 0;height: 0;
}

.el-bg-collapsible-content.open { 
    height: auto;
    opacity: 1;
}

#accordionFlushExample #accordionFlushExample1.accordion .accordion-item{
    border: 0;
}

 .accordion-body .accordion .accordion-item{
    border: 1px solid #87878750  !important;
    padding: 0!important;
    border-radius: 15px!important;
    overflow: hidden;
}

.accordion-body .accordion .accordion-flush {
    margin-bottom: 0!important;
}

#accordionFlushExample #accordionFlushExample1.accordion .accordion-item {
    border: 0;
    margin-bottom: 8px;
}

.el-custom-accordion .accordion-body:has(.accordion-item) {
    padding: 20px!important;
}

.el-custom-accordion .accordion-body .accordion-body{
    padding: 20px!important;
}

.el-profile-board:has(.el-custom-accordion) {
    padding-left: 20px!important;
}
.text-danger {
    --bs-text-opacity: 1;
    color: rgb(211 0 20) !important;
}
.el-property-details-card-content .mx-fit-content {
    padding-top: 0;padding-bottom: 0;
}
.el-main-button span:has(i) {
    padding-right: 9px;
}
/** Custom Fields **/
.custom-type-label,
.custom-type-checkbox,
.custom-type-input,
.custom-type-number {
    min-height: 60px;
    display: flex;
    align-content: center;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
}
.custom-type-input,
.custom-type-number{
    flex-wrap: wrap;
}
.custom-type-label {
    text-align: center;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;    
}

.sample-new-request .radio-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: row;
}

.sample-new-request .special-donor-or {
    text-align: center;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: center;
    justify-content: space-around;
    align-items: center;
}

.sample-new-request .special-donor-qty,
.sample-new-request .special-donor-gender {
    margin-top: 1.7rem;
}

.tube-size-wrapper {
    text-align: center;
    width: 100%;
}

.el-bg-content-inner .el-bg-collapsable-delete {
    right: 110px;
}
.el-schedule-pickup-sr-modal .modal-body {
    padding: 20px!important; 
}

.m-2.d-flex.align-items-center:has(button) {
    border-top: 1px solid #ccc;
    padding-top: 20px;
}
 
.el-modal-content{ 
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        margin: 0;
        margin-top: 15px; 
}
button.el-main-button.me-3.mb-3.el-datebtn {
    min-width: 123px;
    text-align: center;
    justify-content: center;
    color: #000000cc !important;
    font-weight: 500;
}
.el-board-table th .form-check-input[type="checkbox"] {
    border-radius: 0.25em;
    margin-top: 0; 
    margin-right: 10px;
    border-radius: 0.25em;
    border: 1px solid #f16806;
    margin-right: 15px;
}
.el-board-table th .form-check {
    margin-bottom: 10px!important;
    display: flex;
    align-items: center;
    font-size: 16px;
}
 
.el-board-table .el-table-input label, .el-bg-table .btn-primary, .el-board-table th label {
    font-weight: 600;
    color: #161616!important;
    font-size: 16px;
    font-weight: 500!important;
}
 

.css-5wchs2-MuiDateCalendar-root {
    margin: 0;
    border: 1px solid #595959;
    padding: 0;
    border-radius: 20px;
}
.css-5wchs2-MuiDateCalendar-root {
    margin: 0;
    border: 1px solid #f16806;
    padding: 0;
    border-radius: 20px;
}
.css-4k4mmf-MuiButtonBase-root-MuiPickersDay-root.Mui-selected {
    color: #fff;
    background-color: #f16806!important;
    font-weight: 500;
} 
button.el-main-button.me-3.mb-3.el-datebtn {
    min-width: 123px;
    height: fit-content;
    text-align: center;
    justify-content: center;
    color: #000000cc !important;
    font-weight: 500;
}
.css-4k4mmf-MuiButtonBase-root-MuiPickersDay-root { 
    font-size: 17px!important; 
}
.el-bg-collapsible-content .dropdown-menu {
    padding: 15px 0px!important;
    box-shadow: 4px 17px 25px #cccccc82;
}


.el-bg-content-inner {
    color: #000;
    background-color: #f2f2f2;position: relative;
    box-shadow: none;
    padding: 16px 20px;
}

.el-bg-table.el-sample-request-wrapper {
    padding: 0!important; 
    border: 1px solid #00000021;
    padding: 0 !important;
}
.el-bg-table.el-super-admin { 
    border: 1px solid #00000021; 
    border-radius: 15px !important;
    /* overflow: hidden; */
}

.el-bg-collapsible-content.open {
    padding: 16px 20px;
    background: #fff;
    box-shadow: none!important;
    border-radius: 0 0 10px 10px;
    border: 1px solid #f1f1f196;
}

/* .el-bg-collapsible-content .mt-4 {
    margin-top: 0!important; 
} */
 

button.el-bg-collapsable i {
    color: #eb4e0e;
}

.el-bg-table:has(.el-bg-content-inner){
    box-shadow: none; 
}

@media(min-width:1600px){
    .w-md-70{
        width: 70%;
    }
}
@media(min-width:1200px){
    .w-md-70{
        width:85%;
    }
}
.w-md-70   h3 {
    font-size: 19px;
    line-height: 26px;
    font-weight: 700;
    color: #000;
    margin: 0;
    margin-bottom: 0!important;
}

.w-md-70 .sample-type-dropdown-menu .form-check {
    margin-bottom: 10px !important;
}
h3.mb-3 {
    margin-bottom: 1rem !important;
}

.el-bg-content-inner .el-bg-collapsable-delete {
    right: 78px;
    position: absolute;
    z-index: 99;width: fit-content;
}
.el-bg-content-inner .el-bg-collapsable-delete  i{ 
    color: #C82121!important;
}
.el-display-block {
    display: block;
    width: 100%;
}

/** Hours **/
body .el-add-hours {
    margin-top: -11px;
}
body .remove-btn-wrapper {
    margin-top: 38px;
}
body .el-add-hours-btn {
    margin-left: 10px;
    margin-top: 15px;
}

.el-bg-collapsible-content > .mt-4 {
    margin-top: 0!important;
}

.custom-type-checkbox .form-check-input[type="checkbox"] {
    border-radius: 0.25em;
    border: 1px solid #f16806;
    margin-right: 15px;
}

.el-bg-collapsible-content.open > .mt-4:has(.el-main-button) {
    margin-top: 20px!important;
}


span.text-bg-success.badge {
    padding: 10px 30px;
}
span.text-bg-success.badge i.el-icon-dot.mb-0 {
    font-size: 31px;
    line-height: 0;
    width: 0;
    position: relative;
    top: 5px !important;
    height: 0;
    display: inline-flex ;
    right: 10px;
    align-items: center;
}
.left-0 {
    left: 0!important;padding: 0!important;
}

.custom-type-checkbox:has([type="checkbox"]) {
    display: flex!important;
}
select.form-control{
    appearance: none; /* Remove default arrow */
    -webkit-appearance: none; /* For Safari */
    -moz-appearance: none; /* For Firefox */ 
    background-repeat: no-repeat;    
     background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: right 10px center;
    background-size: 16px; /* Adjust size based on your arrow */
    padding-right: 30px; /* Add space for the arrow */
}
div.form-control{
    appearance: none; /* Remove default arrow */
    -webkit-appearance: none; /* For Safari */
    -moz-appearance: none; /* For Firefox */ 
    background-repeat: no-repeat;    
     background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: right 10px center;
    background-size: 16px; /* Adjust size based on your arrow */
    padding-right: 30px; /* Add space for the arrow */
    
}

.left-38{
    left: 38px!important;
}

.el-bg-table.el-super-admin:has(.el-bg-collapsible-content) { 
    padding: 0!important;
}

.dateRanegeFilter button {
	border: none;
	box-shadow: none;
    background: transparent;
}

.dateRanegeFilter button span {
  font-weight: 500 !important;
  font-size: 16px;
  color: #161616 !important;
}
@media(max-width:480px){
    /* .accordion-body {
        padding: 0px!important;
    }

    #accordionFlushExample .accordion .accordion-item, #accordionFlushExample1 .accordion .accordion-item {
       border: none !important;
        padding: 0 !important;
        border-radius: 15px !important; 
    } */

    .el-custom-accordion {
          width: 100% !important;  
    }
} 

.li-sl-bg-blue{
    background: #00A0DF!important;   
    padding: 10px 10px!important;   
}

.li-sl-blue{
    color: #00A0DF!important;   
}

.fa-dot{
    font-size: xx-small;
}


.el-sample-tyep .el-checkbox-wrap input {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    opacity: 0;
    z-index: 9;
}
.el-sample-tyep .el-checkbox-wrap {
    display: inline-block;
    position: relative;
}
.el-sample-tyep .el-checkbox-wrap input:checked + .btn::after {
    opacity: 1;
    border: 2px solid;
}
.el-sample-tyep .el-checkbox-wrap .btn::after {
    content: "✔";
    font-family: "janssen";
    position: absolute;
    font-weight: 200;
    letter-spacing: 0px !important;
    font-size: 17px;
    opacity: 0;
    background-color: inherit;
    padding: 2px;
    border-radius: 50px;
    top: -8px;
    right: 0px;
    width: 23px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-404-title span{
    color: #f16806;
}

.dashboard-card-count{
    cursor: pointer
}


.dropdown-item label{
cursor: pointer;
}
/* .error-placeholder {
    min-height: 20px;
} */
.radio-pointer {
    cursor: pointer;
}



.el-bg-collapsible-content:not(.open) h3 {
    opacity: 0;
}

.el-bg-content-inner:not(.open) h3 .el-bg-collapsible-content.open {
    background: #fff;
    border: 1px solid #f1f1f196;
    border-radius: 0 0 20px 20px;
    box-shadow: 7px 13px 20px 0 #00000012;
    padding: 16px 20px;
}; 


.el-bg-collapsible-content {
    border-radius: 20px 20px 14px 20px!important;
}
.el-bg-table.el-bg-inner-table.el-super-admin:has(.el-bg-collapsible-content:not(.open)) .el-bg-content-inner{
    border-radius: 14px !important;
}  

.el-bg-table.el-bg-inner-table.el-super-admin:has(.open) .el-bg-content-inner {
   border-radius: 14px!important;

}

.el-bg-table.el-bg-inner-table.el-super-admin:has(.el-bg-collapsible-content.open) .el-bg-content-inner{
    border-radius: 14px 14px 0 0 !important;
}  

 
 .el-bg-collapsible-content.open {
    background: #fff;
    border: 1px solid #f1f1f196;
    border-radius: 0 0 10px 10px;
    box-shadow: 7px 13px 20px 0 #00000012;
    padding: 16px 20px;
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 14px;
}

.el-bg-table.el-super-admin.el-sr:has(.el-bg-collapsible-content.open) .el-bg-content-inner-sr {
    border-radius: 14px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}


/* When .el-bg-collapsible-content is present but not open, remove bottom border radius */
.el-bg-table.el-super-admin.el-sr:has(.el-bg-collapsible-content-sr:not(.open)) .el-bg-content-inner-sr {
    border-radius: 14px;
}

/* //Css added 22-08-2025*/

.form-control { 
	min-height: 30px;
}
.job-list-st-filter button {
	width: 100%;
}

 
.el-board-table .dropdown-menu  .form-check {
  margin: 10px 10px;
}
.el-board-table .dropdown-menu .form-check input {
  margin-right: 10px;
}  

.el-board-table .dropdown-menu  .form-check-input:focus{
  box-shadow:none
}
.job-list-st-filter .d-inline-block.form-control.dropdown {
	display: flex !important;
	align-items: center;
}

 
.job-list-st-filter .d-inline-block.form-control.dropdown {
  display: flex !important;
  align-items: center;
}
.d-inline-block.form-control.show.dropdown button {
  width: 100% !important;
}
.job-list-st-filter  .form-control.dropdown {
  background-image: none;
  padding-right: 0;
}
 
.dropdown-toggle {
  width: 100% !important;
}
.job-list-st-filter .form-control.dropdown:after {
  content: "";
  position: absolute;
  right: 0px;pointer-events: none;
  top: 60%;
  transform: translateY(-90%);
  width: 24px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-size: contain;
}


 
.job-list-st-filter .d-inline-block.form-control.dropdown {
  display: flex !important;
  align-items: center;min-height: 52px;
}
 
.d-inline-block.form-control.show.dropdown button {
  width: 100% !important;
}
.job-list-st-filter  .form-control.dropdown {
  background-image: none;
  padding-right: 0;
}
 
.dropdown-toggle {
  width: 100% !important;
}
.job-list-st-filter .form-control{
padding-right:0!important; 
}
.job-list-st-filter .form-control:after {
  content: "";
  position: absolute;
  right: 0px;pointer-events: none;
  top: 60%;
  transform: translateY(-90%);
  width: 24px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-size: contain;
}  

.job-list-st-filter button:hover {
  background: transparent;
}

.job-list-st-filter button {
	padding: 0 !important;
}
.pagination {
	align-items: center;
}
.el-sidebar .navbar-expand-lg .navbar-collapse {
	height: calc(100vh - 96px);
}

.el-sidebar .nav-item .nav-link { 
	padding: 12px ;
}

.el-recruit-donor-box  p.el-request-detail-profile-title {
	padding-left: 13px;
}
#compensation {
	cursor: pointer;
}

.job-list-st-filter .form-control {
	position: relative;
}


.job-list-st-filter div.form-control {
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
	background-repeat: no-repeat;
	background-image: none !important;
	background-position: right 10px center;
	background-size: 16px;
	padding-right: 30px;
}
.jb-filters{
    width: 175px;
}

.jb-filter-date{
    width: 100px;
}
.el-board-table div input.btn.btn-link {
    padding: 0;
    text-decoration: none;
    border-top: 1px solid #ccc;
    border-radius: 0;
    width: 100%;
    margin-top: 16px;
    font-weight: 700;
    padding: 6px 0 0 0;
    color: #e63516;
}

.el-board-table div .dropdown-menu.show {
    padding: 12px 0px;
    /* min-width: 240px; */
    border: 0;width: max-content;
    box-shadow: 6px 20px 45px #cccccc70;
    border: 1px solid #f16806;
}

.profile-setting-accord .el-custom-accordion{
    width: 100%!important;
}
.donate-st-question{
    font-size: medium!important;
}

.form-check-profile-setting-race-ethnicity{
    margin-bottom: 10px!important;
}

.el-custom-accordion p{
    /* margin-top: 10px; */
    /* width: 98%!important; */
    font-size: medium!important;
}

.custom-list-style li::marker {
  font-size: 1.2em!important;    
  color: #f16806!important;      
}
.form-check-health-questionnaire-radio{
    width: 1.15rem!important;
    height: 1.1rem!important;
}
    
.cursor-pointer{
    cursor: pointer!important;
}
 .large-modal {
  max-width: 65% !important; /* default is ~500px */
  width: 65% !important;
}
.health-quesion-popup-accord 
.accordion-item 
.accordion-header 
.accordion-button::after {
    display: none;
}

.font-size-small{
    font-size: small!important;
}

 .parent-study  .form-control{
    line-height: 2.5rem!important;
    width: 25%;
    border-radius: 10px;
 }

 .form-check input{
    cursor: pointer;
 }
 .form-check label{
    cursor: pointer;
 }
.confirmInfoCheckbox {
  appearance: none;          /* Remove default browser style */
  -webkit-appearance: none;
  width: 19px;
  height: 19px;
  border: 2px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  position: relative;
}

.confirmInfoCheckbox:checked {
  background-color: #f47324;
  border-color: #f47324;
}

.confirmInfoCheckbox:checked::after {
  content: "✓";
  color: #fff;                    
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -58%);
  font-size: 12px;
  font-weight: bold;
  pointer-events: none;
}
.el-submenu .accordion-button {
  background: none;
  padding: 0.5rem 0.8rem!important;
  font-weight: normal;
  box-shadow: none !important;
}

.el-submenu .accordion-button::after {
  margin-left: auto;
}

.el-submenu .accordion-body {
  padding: 0;
}

.el-submenu .nav-link {
  padding-left: 2rem; 
  font-size: 0.9rem;
}
.el-submenu .nav-item{
    padding: 0px!important;
}

.nav-pills .accordion-body{
padding: 0px!important;
}
.nav-pills .accordion-button{
  background: none;
  padding: 0.5rem 0.5rem 0.5rem 0rem;
  font-weight: normal;
  box-shadow: none !important;
}

/* Remove hover/active blue background */
.nav-pills .accordion-button:not(.collapsed),
.nav-pills .accordion-button:focus,
.el-submenu .accordion-button:not(.collapsed),
.el-submenu .accordion-button:focus {
  background: none !important;
  color: inherit;
  box-shadow: none !important;
} 
.password-info-btn{
    background: white !important;
    position: absolute;
    bottom: -2px;
}

.appointment-duration-compensation{
 left: 0px!important;
}
.el-submenu span{
    margin-left: 10px;
}
/* target accordion-items inside el-submenu (top-level and nested cases) */
.el-submenu.accordion > .accordion-item,
.el-submenu .accordion > .accordion-item,
.el-submenu .accordion-item.el-submenu-item,
.el-submenu .accordion .accordion-item.el-submenu-item {
  border: none !important;
  padding: 0 !important;
  border-radius: 0 !important;
  overflow: visible !important;
} 
.position-unset{
    position: unset!important;
}
.error-placeholder:has(.text-danger){
    margin-top: 10px;
}
.el-bg-collapsible-content .radio-wrapper .form-check {
    padding-right: 1.5rem;
    margin-bottom: 0px !important;
}
strong {
    font-weight: 700!important;
}
.el-form-group input.form-control + .text-danger {
    margin-top: 10px;
}
.el-bg-collapsible-content-sr button.el-main-button + .text-danger {
    margin-top: 10px;
}
.el-bg-collapsible-content-sr .dropdown-item {
    padding: 5px 8px!important;line-height: 1.2;
}
input.form-control + .text-danger {
    margin-top: 10px;
}
p{
    font-weight: 400;
}
.el-bg-table li {
    font-weight: 400;
    line-height: 1.2;
}
.el-table-container .table tbody tr td {
    vertical-align: middle;
    padding: 15px 13px;
    border-bottom: 2px solid #efefef;
    font-weight: 400;
}

.el-bg-table .el-table-container th { 
    font-weight: 600!important;
}
.el-board-table .el-table-input label, .el-bg-table .btn-primary, .el-board-table th label { 
    font-weight: 600!important;
}
.el-horizontal-action-button img {
transform: rotate(90deg);
 margin-left: 20px;
}
.modal-body .form-check.el-mb-0{
    margin-bottom: 0!important;
}

.modal-body  .form-check + .text-danger {
    margin-bottom: 20px!important; 
}

.modal-body .form-check:has(+ .text-danger) {
    margin: 0!important;
}

.modal-dialog.modal-dialog-centered .modal-body  .form-check-input[type=checkbox] {
    border-radius: .25em;
    width: 20px;
    height: 20px;
}

#donor-health-questionnaire-section .form-check-input[type=radio] {
    border-radius: 50%;
    min-width: 20px!important;
    min-height: 20px!important;
    max-width: 20px;
    max-height: 20px;
}
.navbar  .accordion-item {
    border-bottom: 0;
}

.job-list-st-filter.el-request-management-dropdown .form-control, .job-list-st-filter.el-request-management-dropdown.form-control {
    position: relative;
    text-align: left;
    padding-left: 15px!important;min-height: 54px!important;
    border-radius: 0.575rem;
}

.job-list-st-filter.el-request-management-dropdown   .form-control , .job-list-st-filter.el-request-management-dropdown.form-control{
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: right 10px center;
    background-size: 16px;
    padding-right: 30px;
}
.confirmInfoCheckbox{
    margin-left: 8px;
}
.confirmInfoCheckbox + label{
    margin-left: 13px!important;
}

.job-list-st-filter.el-request-management-dropdown.dropdown-toggle::after{
    display:none!important
    ;
}

.dropdown-menu.sample-type-dropdown-menu.show {
    padding: 15px!important;
}

.el-profile-board .special-donor-gender .form-check {
    margin-bottom: 12px !important; 
}
.el-bg-table .el-appoinment-duration label.form-label {
    bottom: 0px!important;
}
.custom-type-number:has(.text-danger) {
    margin-bottom: 15px;
} 

.el-bg-table:has(table) { 
    min-height: 65vh;
}
.donate-el-between-radio-button{
    justify-content: space-between;max-width: 150px;
}


/* @media (min-width: 1600px) {
 .el-bg-table.el-super-admin + .el-bg-table.el-super-admin + .el-bg-table.el-super-admin:has(#donor-health-questionnaire-section) .el-custom-accordion {
    max-width: 80%;
}
} */

.table-x-scroll{
    overflow-x: auto!important;
}

.bg-orange{
    background-color: #ee5b0b!important;
    border-color: #ee5b0b!important;
}`, "",{"version":3,"sources":["webpack://./src/Assets/css/style.css"],"names":[],"mappings":"AAEA;IACI,wGAAwG;IACxG,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;CAEC,sDAAsD;CACtD,yBAAyB;AAC1B;;AAEA;;CAEC,UAAU;CACV,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;;CAEC,sDAAsD;CACtD,yBAAyB;AAC1B;;AAEA;;CAEC,WAAW;CACX,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;IACV,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,4BAA4B;AAChC;AACA;IACI,6BAA6B,CAAC,SAAS;AAC3C;AACA;IACI,uCAAuC,CAAC,SAAS;AACrD;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB,CAAC,gBAAgB;AACxC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,OAAO;IACP,yBAAyB;IACzB,MAAM;IACN,aAAa;AACjB;AACA;IACI;QACI,6BAA6B;QAC7B,yBAAyB;IAC7B;AACJ;;;AAGA;IACI;QACI,6BAA6B;QAC7B,cAAc;IAClB;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;IAGnB,+EAA+E;IAC/E,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,iCAAiC;IACrC;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,+EAA+E;AACnF;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,uGAAuG;AAC3G;;AAEA;IACI,mBAAmB;IACnB;;;;;;KAMC;AACL;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,sBAAsB;KACrB,kBAAkB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB,CAAC,gBAAgB;IACvC,8BAA8B;IAC9B,kCAAkC;IAClC,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,YAAY;QACZ,wBAAwB;IAC5B;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,qDAAqD;AACzD;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,4BAA4B;IAC5B,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAGlB,+EAA+E;IAC/E,YAAY;IACZ,OAAO;IACP,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAGlB,+EAA+E;IAC/E,YAAY;IACZ,OAAO;IACP,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,wDAAwD;IAC5D;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,OAAO;IACP,mBAAmB;AACvB;;AAEA;IACI;QACI,uCAAuC;QACvC,aAAa;IACjB;IACA;QACI,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,wBAAwB;QACxB,aAAa;IACjB;IACA;QACI,mCAAmC;QACnC,cAAc;QACd,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,qDAAqD;IACrD,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,6BAA6B;QAC7B,oBAAoB;IACxB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2CAA2C;IAC3C,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,4BAA4B;IAC5B,cAAc;IACd,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,+EAA+E;IAC/E,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,+EAA+E;IAC/E,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,sBAAsB;IACtB,yCAAyC;IACzC,gBAAgB;IAChB,wCAAwC;IACxC,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,gBAAgB;IAChB,uDAAuD;IACvD,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,0FAA0F;IAC1F,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,SAAS;AACb;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,gBAAgB;IAChB,uDAAuD;IACvD,UAAU;IACV,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,0FAA0F;IAC1F,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,cAAc,CAAC,gBAAgB;AACnC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,+EAA+E;IAC/E,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,cAAc;IACd,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,qDAAqD;IACrD,mBAAmB,CAAC,gBAAgB;AACxC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;;;AAIA;IACI,yBAAyB;AAC7B;;AAEA;IACI,+EAA+E;IAC/E,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,gBAAgB;IAChB,uDAAuD;IACvD,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,0FAA0F;IAC1F,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+EAA+E;IAC/E,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,uCAAuC;IACvC,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,cAAc;IACd,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,+EAA+E;IAC/E,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,iCAAiC;IACjC,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;;IAEb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+EAA+E;IAC/E,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,uCAAuC;IACvC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAAkO;IAClO,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,8EAA8E;IAC9E,qCAAqC;IACrC,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yDAAkO;IAClO,iDAAiD;AACrD;;;AAGA;IACI,aAAa;CAChB,SAAS;IACN,aAAa;IACb,gBAAgB;IAChB,mDAAmD;AACvD;AACA;IACI,8BAA8B;;IAE9B,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;AACA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA,0BAA0B;;AAE1B;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,eAAe;IACnB;IACA;QACI,SAAS;QACT,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,+EAA+E;AACnF;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,uGAAuG;AAC3G;;AAEA;IACI,mBAAmB;IACnB;;;;;;KAMC;AACL;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,SAAS;IACT,eAAe;IACf,oBAAoB,CAAC,4BAA4B;AACrD;AACA;IACI,kBAAkB;AACtB;;AAEA,sDAAsD;IAClD,qFAAqF;AACzF,MAAM;;AAEN;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;EAEE;IACE,sBAAsB;AAC1B;;CAEC;IACG,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,aAAa,CAAC,eAAe;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa,CAAC,YAAY;IAC1B,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;;EAEE;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,SAAS,CAAC,kBAAkB;AAChC;AACA;IACI,kCAAkC;AACtC;AACA;;GAEG;EACD;IACE,kCAAkC;IAClC,SAAS;IACT,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB,EAAE,YAAY;AACzC;AACA;AACA;IACI,OAAO;AACX,CAAC;AACD;IACI,6BAA6B;AACjC;AACA;IACI,wBAAwB;AAC5B;;;;AAIA,KAAK;AACL;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,UAAU;IACV,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,SAAS;IACT,UAAU;AACd;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;AACA,2CAA2C;AAC3C;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA,4BACgC,gBAAgB;IAC5C,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,yCAAyC;IACzC,yCAAyC;IACzC,mCAAmC;IACnC,qCAAqC;IACrC,yCAAyC;IACzC,qCAAqC;IACrC,mCAAmC;IACnC,4CAA4C;IAC5C,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,mEAAmE;AACvE;AACA;IACI,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,gBAAgB,CAAC,gBAAgB;IACjC,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;;;;;;;;;;;GAWG;AACH;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,yFAAyF;IACzF,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,cAAc;IACd,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,oCAAoC;IACpC,6BAA6B;IAC7B,wBAAwB;IACxB,gBAAgB;AACpB;AACA;IACI,+EAA+E;IAC/E,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,aAAa;IACb,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,OAAO;IACP,yBAAyB;IACzB,MAAM;IACN,qBAAqB;AACzB;;AAEA;QACQ,gBAAgB;QAChB,iBAAiB;QACjB,wBAAwB;QACxB,mCAAmC;QACnC,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,oBAAoB;QACpB,kBAAkB;QAClB,eAAe;QACf,4BAA4B;QAC5B,kBAAkB;QAClB,8BAA8B;AACtC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,+EAA+E;IAC/E,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,6EAA6E;IAC7E,2BAA2B;AAC/B;;AAEA;;IAEI,OAAO;AACX;;AAEA;;IAEI,WAAW,EAAE,kBAAkB;IAC/B,WAAW;AACf;;AAEA;;IAEI,sBAAsB;AAC1B;;;AAGA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,kBAAkB,CAAC,aAAa,CAAC,mBAAmB;IACpD,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;;AAGA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,+EAA+E;IAC/E,0BAA0B;AAC9B;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,WAAW,EAAE,kBAAkB;IAC/B,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;;;;GAIG;AACH;IACI,cAAc;IACd,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,yBAAyB;IACzB,4BAA4B;IAC5B,sCAAsC;IACtC,sEAAsE;AAC1E;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;;AAE5B;;AAEA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,mBAAmB,CAAC,gBAAgB;AACxC;AACA;IACI;AACJ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;AACnB;;;AAGA;KACK,UAAU;AACf;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;AACA,6CAA6C;IACzC;;;;mDAI+C;IAC/C,8BAA8B;IAC9B,mBAAmB;AACvB,MAAM;;AAEN;IACI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,SAAS;AACb;AACA,mDAAmD,WAAW;IAC1D,UAAU;IACV,WAAW;IACX,+EAA+E;IAC/E,kBAAkB;IAClB,OAAO;IACP,0BAA0B;IAC1B,QAAQ;;AAEZ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,mCAAmC,CAAC,UAAU,CAAC,gBAAgB;AACnE;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;AACA;IACI,UAAU,CAAC,SAAS,CAAC,4BAA4B;AACrD;AACA;IACI,cAAc,CAAC,gBAAgB;IAC/B,UAAU;AACd;AACA;IACI,UAAU;IACV,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;AACA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,8BAA8B;IAC9B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,mBAAmB,CAAC,wBAAwB;AAChD;AACA;IACI,0BAA0B;AAC9B;;AAEA,iBAAiB;;AAEjB;;IAEI;AACJ,kCAAkC;AAClC;;;;;;GAMG;;AAEH,yBAAyB;AACzB;;;;;IAKI,4BAA4B;AAChC;;AAEA,MAAM,UAAU,CAAC;AACjB,MAAM,UAAU,CAAC;AACjB,MAAM,UAAU,CAAC;AACjB;IACI,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;AACA;AACA,mBAAmB,CAAC,WAAW;AAC/B;AACA;AACA,WAAW;AACX;;AAEA;;GAEG;AACH;IACI,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,qBAAqB;AACzB;;;AAGA;IACI,yBAAyB;AAC7B;;;EAGE;IACE,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe,CAAC,oBAAoB;IACpC,eAAe;IACf,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,eAAe,CAAC,oBAAoB;IACpC,eAAe;IACf,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,mCAAmC;IACnC,uBAAuB;AAC3B;AACA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB,CAAC,yBAAyB;AACnD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yFAAyF;IACzF,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;IACI,uCAAuC;IACvC,cAAc;IACd,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,oCAAoC;IACpC,6BAA6B;IAC7B,wBAAwB;IACxB,gBAAgB;AACpB;AACA;IACI,iFAAiF;IACjF,WAAW;IACX,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,6BAA6B;IAC7B,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,cAAc;AAClB;AACA;IACI;IACA,YAAY,CAAC;AACjB;;;;;AAKA;IACI,iCAAiC;IACjC,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,6BAA6B;AACjC;AACA;QACQ,cAAc;QACd,qBAAqB;QACrB,eAAe;AACvB;AACA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;AACA;IACI,iCAAiC;IACjC,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;EACE,cAAc;AAChB;AACA;IACI,cAAc;EAChB;EACA;IACE,UAAU;EACZ;;;EAGA;IACE,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,UAAU;IACV,cAAc;IACd,YAAY;AAChB;AACA;IACI,6DAA6D;AACjE;AACA;IACI,gBAAgB;AACpB;AACA;IACI,uCAAuC;IACvC,8BAA8B;AAClC;AACA;AACA,8BAA8B;AAC9B;;AAEA;EACE;AACF;AACA;AACA,+BAA+B,GAAG,uCAAuC;AACzE;;AAEA;AACA,8BAA8B,GAAG,uCAAuC;AACxE;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,0BAA0B,CAAC,qBAAqB;IAChD,uCAAuC;AAC3C;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,qBAAqB,CAAC,kBAAkB,CAAC,YAAY,EAAE,qBAAqB,CAAC,2BAA2B,EAAE,aAAa,CAAC,kBAAkB;AAC9I;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;;;;AAKA;IACI,0BAA0B;AAC9B;;AAEA,qBAAqB;CACpB;IACG,oBAAoB;AACxB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;CACC;IACG,aAAa;AACjB;AACA;IACI,8EAA8E;IAC9E,gBAAgB;IAChB,gBAAgB;IAChB,uCAAuC;IACvC,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB,CAAC,mBAAmB;AAC3C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;AACpB;;;;AAIA;IACI,SAAS;AACb;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;AACA;;GAEG;;AAEH;IACI,yBAAyB,EAAE,iBAAiB;IAC5C,iBAAiB;IACjB,WAAW;IACX,6BAA6B;IAC7B,0BAA0B;AAC9B;;;;AAIA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,iBAAiB,GAAG,yBAAyB;IAC7C,iBAAiB;IACjB,WAAW,EAAE,gBAAgB;IAC7B,6BAA6B;AACjC;AACA;;GAEG;;AAEH;IACI,0BAA0B;AAC9B;AACA;IACI,UAAU;AACd;AACA;IACI,4CAA4C;IAC5C,0BAA0B;AAC9B;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI;AACJ;AACA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;AACA;IACI,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,cAAc;IACd,SAAS;IACT,UAAU;IACV,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA,mCAAmC;EACjC,8BAA8B;AAChC,MAAM;;AAEN;IACI;AACJ;;;AAGA;;IAEI,+EAA+E;EACjF,sBAAsB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,uBAAuB;AAC3B;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;AACtB;;AAEA;AACA,kBAAkB;AAClB,WAAW;AACX;;AAEA;AACA,kBAAkB;AAClB,UAAU;AACV,QAAQ;AACR,2BAA2B;AAC3B,eAAe;AACf,WAAW;AACX;;AAEA;AACA,kDAAkD;AAClD;;AAEA;AACA,sBAAsB;AACtB,gCAAgC;AAChC,8BAA8B;AAC9B,kBAAkB;AAClB,+BAA+B;AAC/B,UAAU;AACV,iBAAiB;AACjB,gBAAgB;AAChB,kBAAkB;AAClB,WAAW;AACX,QAAQ;AACR,WAAW;AACX;;AAEA;AACA,aAAa;AACb,eAAe;AACf;;AAEA;;AAEA,yBAAyB;AACzB;;AAEA;AACA,aAAa;AACb,WAAW;AACX;;;AAGA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;AACA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;;;IAGI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;IAC/B,UAAU,CAAC,SAAS;AACxB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;CAEC;IACG,uCAAuC;IACvC,oBAAoB;IACpB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,oBAAoB;IACpB,+BAA+B;AACnC;AACA;IACI,cAAc,CAAC,iBAAiB;AACpC;AACA;IACI,kBAAkB;AACtB;AACA,oBAAoB;AACpB;;;;IAII,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;QACQ,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;QACT,gBAAgB;AACxB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,0BAA0B;AAC9B;;;AAGA;IACI,SAAS;IACT,yBAAyB;IACzB,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,yBAAyB;IACzB,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,mCAAmC;IACnC,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;IAC3B,mCAAmC;AACvC;;;AAGA;IACI,WAAW;IACX,yBAAyB,CAAC,kBAAkB;IAC5C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;IAC3B,qBAAqB;AACzB;AACA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;;GAEG;;;AAGH;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,SAAS;IACb;AACJ;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW,CAAC,kBAAkB;AAClC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,cAAc;IACd,WAAW;AACf;;AAEA,YAAY;AACZ;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,cAAc;IACd,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,iBAAiB,CAAC,oBAAoB;AAC1C;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,gBAAgB,EAAE,yBAAyB;IAC3C,wBAAwB,EAAE,eAAe;IACzC,qBAAqB,EAAE,gBAAgB;IACvC,4BAA4B;KAC3B,yDAA0wB;IAC3wB,sCAAsC;IACtC,qBAAqB,EAAE,oCAAoC;IAC3D,mBAAmB,EAAE,4BAA4B;AACrD;AACA;IACI,gBAAgB,EAAE,yBAAyB;IAC3C,wBAAwB,EAAE,eAAe;IACzC,qBAAqB,EAAE,gBAAgB;IACvC,4BAA4B;KAC3B,yDAA0wB;IAC3wB,sCAAsC;IACtC,qBAAqB,EAAE,oCAAoC;IAC3D,mBAAmB,EAAE,4BAA4B;;AAErD;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;CACC,YAAY;CACZ,gBAAgB;IACb,uBAAuB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;AAC3B;AACA;IACI;;;;;;;;OAQG;;IAEH;UACM,sBAAsB;IAC5B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,UAAU;AACd;AACA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;;AAGA;AACA,eAAe;AACf;AACA;;GAEG;AACH;IACI,eAAe;AACnB;;;;AAIA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;IAC5B,qCAAqC;IACrC,kBAAkB;AACtB,CAAA;;;AAGA;IACI,4CAA4C;AAChD;AACA;IACI,8BAA8B;AAClC;;AAEA;GACG,6BAA6B;;AAEhC;;AAEA;IACI,uCAAuC;AAC3C;;;CAGC;IACG,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;IAC5B,qCAAqC;IACrC,kBAAkB;IAClB,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,6BAA6B;AACjC;;;AAGA,yFAAyF;AACzF;IACI,mBAAmB;AACvB;;AAEA,0BAA0B;;AAE1B;CACC,gBAAgB;AACjB;AACA;CACC,WAAW;AACZ;;;AAGA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE;AACF;AACA;CACC,wBAAwB;CACxB,mBAAmB;AACpB;;;AAGA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU,CAAC,oBAAoB;EAC/B,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,yDAAqU;EACrU,4BAA4B;EAC5B,wBAAwB;AAC1B;;;;AAIA;EACE,wBAAwB;EACxB,mBAAmB,CAAC,gBAAgB;AACtC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA;AACA,yBAAyB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU,CAAC,oBAAoB;EAC/B,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,yDAAqU;EACrU,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;;AAGA;CACC,gBAAgB;CAChB,wBAAwB;CACxB,qBAAqB;CACrB,4BAA4B;CAC5B,iCAAiC;CACjC,sCAAsC;CACtC,qBAAqB;CACrB,mBAAmB;AACpB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,UAAU;IACV,qBAAqB;IACrB,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,SAAS,CAAC,kBAAkB;IAC5B,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;IACI,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;CACC;EACC,yBAAyB,EAAE,sBAAsB;EACjD,qBAAqB;AACvB;AACA;;;;IAII,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;CAEC;IACG,6BAA6B;IAC7B,UAAU;IACV,mBAAmB;CACtB;;CAEA;IACG,eAAe;CAClB;CACA;IACG,eAAe;CAClB;AACD;EACE,gBAAgB,WAAW,iCAAiC;EAC5D,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;IACI,sBAAsB;AAC1B;;AAEA;AACA,sBAAsB;AACtB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;;;;EAIE,2BAA2B;EAC3B,cAAc;EACd,2BAA2B;AAC7B;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;CACC,mBAAmB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA,0EAA0E;AAC1E;;;;EAIE,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,0BAA0B,CAAC,gBAAgB;AAC/C;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;AACA,wBAAwB;CACvB,iBAAiB;AAClB;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B,CAAC,0BAA0B;IACvD,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,4BAA4B;IAC5B,yDAAwxB;IACxxB,sCAAsC;IACtC,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI;IACA;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,8BAA8B,CAAC,gBAAgB;AACnD;;;AAGA;;;;GAIG;;AAEH;IACI,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;AACnC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap'); \n\nbody {\n    background-image: linear-gradient(109.6deg, rgb(221 232 241 / 31%) 11.2%, rgb(205 216 220 / 49%) 100.2%);\n    font-family: \"Mulish\", sans-serif;\n    font-size: 16px;\n    line-height: 1.2;\n    font-weight: 600; \n}\n::-webkit-scrollbar-track\n{\n\t-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.116);\n\tbackground-color: #F5F5F5;\n}\n\n::-webkit-scrollbar\n{\n\twidth: 7px;\n\tbackground-color: #F5F5F5;\n}\n\n::-webkit-scrollbar-thumb\n{\n\tbackground-color: #555555; \n\tborder: 2px solid #ffffff;\n}\n\n.el-board-table::-webkit-scrollbar-track\n{\n\t-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.116);\n\tbackground-color: #F5F5F5;\n}\n\n.el-board-table::-webkit-scrollbar\n{\n\theight: 7px;\n\tbackground-color: #F5F5F5;\n}\n\n.el-board-table::-webkit-scrollbar-thumb\n{\n\tbackground-color: #555555; \n\tborder: 2px solid #ffffff;\n}\n\na{\n    cursor: pointer;\n}\n.btn-check:checked+.btn:focus-visible, :not(.btn-check)+.btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n    box-shadow:none!important;\n}\nth .btn.dropdown-toggle:hover { \n    background-color:transparent!important; \n}\n.back-link {\n    text-decoration: none;\n    text-decoration: none;\n    color: #eb4e0e!important;\n    position: relative;\n    left: -7px;\n    font-weight: 600!important;\n    font-size: 18px!important;\n    position: relative;\n    left: -7px;\n    width: fit-content!important;\n}\ntd .btn:hover, td .btn:focus,td .btn:active{\n    background-color: transparent;border: 0;\n}\n.btn:first-child:active{\n    background-color: transparent!important;border: 0;\n}\n.back-link + .el-bg-table {\n    margin-top: 20px;\n}\n\n.el-bg-table.el-super-admin .col-md-4:has(.form-check) {\n    margin: 0;\n}\nmain {\n    min-height: 100vh;\n}\n\n.el-logo {\n    height: 80px;\n    display: flex;\n    justify-content: center;\n    align-items: center;padding-top: 4px;\n}\n\n.el-sidebar {\n    height: 100vh;\n    overflow: auto;\n    background: #fff;\n    position: fixed;\n    left: 0;\n    transition: all 0.5s ease;\n    top: 0;\n    z-index: 9999;\n}\n@media (max-width: 480px) {\n    .el-sidebar {\n        position: absolute !important;\n        display: block !important;\n    }\n}\n \n\n@media (max-width: 992px) {\n    .el-sidebar {\n        position: absolute !important;\n        display: block;\n    }\n    .el-middle {\n        padding: 0;\n    }\n}\n.el-sidebar .navbar-expand-lg {\n    display: flex;\n    flex-direction: column;\n}\n\n.el-sidebar .navbar-expand-lg .navbar-collapse {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    align-items: normal;\n}\n\n.el-sidebar .nav-item {\n    /* padding: 0 20px; */\n\n}\n\n.el-sidebar .nav-item .nav-link {\n    background: rgba(0, 0, 0, 0);\n    padding: 12px 17px;\n    color: #202224;\n    font-weight: 600;\n    font-size: 15px;\n    border-radius: 6px; \n}\n\n.el-sidebar .nav-item .nav-link i {\n    font-size: 18px;\n    display: inline-block;\n    vertical-align: middle;\n    color: #000;\n}\n\n.el-sidebar .nav-item .nav-link span {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0 0 0 8px;\n}\n\n.el-sidebar .nav-item .nav-link.active,\n.el-sidebar .nav-item .nav-link:hover {\n    background: #f47403;\n    background: -moz-linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    background: -webkit-linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    color: #fff;\n}\n\n.el-sidebar .el-navlabel {\n    display: flex;\n    position: relative;\n    align-items: center;\n    font-size: 13px;\n    color: #000;\n    font-weight: bold;\n    margin: 10px 0;\n    text-transform: uppercase;\n}\n\n.el-sidebar .el-navlabel:before {\n    content: \"\";\n    display: block;\n    background: #202224;\n    /* width: 43px; */\n    width: 35px;\n    height: 1px;\n    margin-right: 10px;\n}\n\n.el-middle {\n    width: 100%;\n    padding-left: 280px;\n}\n\n@media (max-width: 992px) {\n    .el-middle {\n        padding: 0;\n    }\n}\n\n.el-middle-wrapper {\n    padding: 20px 45px;\n}\n\n@media (max-width: 768px) {\n    .el-middle-wrapper {\n        padding: 20px;\n    }\n}\n\n.el-topbar {\n    background: #fff;\n    padding: 15px 45px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-left: 280px;\n}\n\n@media (max-width: 1199px) {\n    .el-topbar {\n        flex-wrap: wrap;\n        padding: 20px;\n    }\n}\n\n.el-topbar-left {\n    font-size: 22px;\n    margin-left: 45px;\n}\n\n.el-topbar-left span {\n    color: #ec008c;\n}\n\n.el-topbar-right {\n    display: flex;\n}\n\n.el-topbar-right > div {\n    background: #f2f2f2;\n    margin: 0 0 0 10px;\n    border-radius: 5px;\n    padding: 10px;\n    display: flex;\n    justify-content: space-between;\n    min-width: 240px;\n}\n\n.el-topbar-right > div i {\n    width: 21%;\n    display: flex;\n    background: #fff;\n    border-radius: 5px;\n    font-size: 30px;\n    color: #f16806;\n    align-items: center;\n    justify-content: center;\n    height: 46px;\n}\n\n.el-topbar-right > div span {\n    display: block;\n    width: calc(100% - 57px);\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.el-topbar-right > div span small {\n    font-size: 14px;\n    color: #f16806;\n}\n\n.el-topbar-right > div.el-topbar-weather {\n    min-width: 200px;\n}\n\n.el-topbar-right > div.el-topbar-weather i {\n    width: 46px;\n}\n\n.el-topbar-right > div.el-topbar-weather span {\n    width: calc(100% - 57px);\n}\n\n.el-middle-top {\n    display: flex;\n    margin: 0 0 20px;\n}\n\n@media (max-width: 1300px) {\n    .el-middle-top {\n        flex-wrap: wrap;\n    }\n}\n\n@media (min-width: 992px) and (max-width: 1300px) {\n    .el-middle-top .el-middle-top-col {\n        margin-bottom: 15px;\n        max-width: 100%;\n        min-width: 400px;\n    }\n}\n\n@media (min-width: 568px) and (max-width: 768px) {\n    .el-middle-top .el-middle-top-col {\n        margin-bottom: 15px;\n        max-width: 100%;\n        min-width: fit-content;\n    }\n}\n\n@media (min-width: 568px) {\n    .el-middle-top-col {\n        margin-bottom: 15px;\n        max-width: 100%;\n        min-width: fit-content;\n    }\n}\n\n@media (max-width: 568px) {\n    .el-middle-top-col {\n        margin-bottom: 15px;\n        max-width: 100%;\n        min-width: 100%;\n    }\n}\n\n@media (max-width: 1300px) {\n    .el-table-container.el-board-table {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n}\n\n.el-middle-top-col {\n    margin-right: 1%;\n    display: flex;\n    align-items: center;\n    border-radius: 12px;\n    padding: 12px 20px;\n    background: #f47403;\n    background: linear-gradient(136deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n}\n\n@media (min-width: 1600px) {\n    .el-middle-top-col {\n        width: 24%;\n    }\n}\n\n@media (min-width: 1201px) {\n    .el-middle-top-col {\n        flex-wrap: wrap;\n    }\n}\n\n.el-middle-top-col strong {\n    display: block;\n    font-size: 32px;\n    color: #fff;\n    margin: 0 0 10px;\n}\n\n.el-middle-top-col span {\n    font-size: 18px;\n    color: #fff;\n    font-weight: bold;\n}\n\n.el-middle-top-col + .el-middle-top-col {\n    background: #e83f12;\n    background: linear-gradient(136deg, rgb(232, 63, 18) 0%, rgb(189, 75, 118) 58%, rgb(145, 79, 179) 100%);\n}\n\n.el-middle-top-col + .el-middle-top-col + .el-middle-top-col {\n    background: #8d4db2;\n    background: linear-gradient(\n        136deg,\n        rgb(141, 77, 178) 0%,\n        rgb(141, 77, 178) 40%,\n        rgb(123, 64, 157) 64%,\n        rgb(72, 26, 98) 92%\n    );\n}\n\n.el-middle-top-img {\n    margin-right: 16px;\n}\n\n.el-middle-content {\n    padding: 20px;\n    background: #fff;\n    border-radius: 20px;\n}\n\n.el-middle-title {\n    margin: 0 0 20px;\n}\n\n.el-middle-title h2 {\n    color: #ec008c;\n    font-size: 20px;\n    font-weight: 500;\n}\n\n.el-table-container {\n    border: 1px solid RGB(196, 196, 196);\n    border-radius: 10px;\n    padding: 0 8px;\n    margin-bottom: 20px;\n}\n\n.el-table-container .table {\n    margin: 0;\n}\n\n.el-table-container .table tbody tr td {\n    vertical-align: middle;\n     padding: 15px 13px; \n    border-bottom: 2px solid #efefef;\n}\n\n.el-table-container .table tbody tr:nth-last-child(1) td {\n    border-bottom: 0px;\n}\n\n.btn.btn-primary {\n    height: auto;\n    padding-top: 0px;\n    padding-bottom: 0px;\n    text-align: left !important;\n    justify-content: flex-start;\n    border-radius: 6px;\n    color: #fff !important;font-weight: 600;\n    min-height: initial !important;\n    /* padding-left: 8px !important; */\n    /* min-width: 147px; */\n    /* min-width: 85px; */\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.btn.btn-primary:hover {\n    opacity: 0.8;\n}\n\n.btn.btn-primary.blood {\n    background: #c82121;\n    border-color: #c82121;\n}\n\n.el-radio {\n    position: relative;\n    height: 100%;\n}\n\n.el-radio input {\n    -webkit-appearance: none;\n    position: absolute;\n    left: -9999px;\n    opacity: 0;\n}\n\n.el-radio input + label {\n    width: 16px;\n    height: 16px;\n    display: block;\n}\n\n.el-radio input + label:before {\n    content: \"\";\n    border: solid 1px #202224;\n    width: 16px;\n    height: 16px;\n    display: block;\n    border-radius: 100%;\n}\n\n.el-radio input + label:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    background: #f47324;\n    width: 12px;\n    height: 12px;\n    border-radius: 100%;\n    top: 2px;\n    left: 2px;\n    opacity: 0;\n}\n\n.el-radio input:checked + label:after {\n    opacity: 1;\n}\n\n.el-login-sec .el-login-card .el-login-logo img {\n    margin: 0 auto 30px auto;\n    display: block;\n    width: 250px;\n    max-width: 100%;\n}\n\n@media (max-width: 768px) {\n    .el-login-sec .el-login-card .el-login-logo img {\n        width: 200px;\n        margin: 0 auto 40px auto;\n    }\n}\n\n.el-login-sec .el-login-footer {\n    background-color: #fff;\n    padding: 45px 0px 37px;\n}\n\n.el-login-sec .el-login-footer .el-copyright-txt p {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 12px;\n    text-align: center;\n    color: #585858;\n    margin-bottom: 60px;\n}\n\n.el-login-sec .el-login-background {\n    background: #fff;\n    padding: 80px 58px;\n    border-radius: 20px;\n    max-width: 600px;\n    height: 100%;\n    backdrop-filter: blur(50px);\n    box-shadow: -2px 2px 25px rgba(0, 0, 0, 0.0705882353);\n}\n\n@media (max-width: 768px) {\n    .el-login-sec .el-login-background {\n        padding: 40px 30px;\n    }\n}\n\n.el-login-sec .el-form-group label {\n    font-size: 17px;\n    margin-bottom: 10px;\n    color: #000 !important;\n}\n\n.el-login-sec .form-control {\n    height: 50px;\n    border: 1px solid #000;\n    margin-bottom: 10px;\n}\n\n.el-login-sec .el-btn-primary {\n    background: #f47324;\n    background: #000;\n    color: #fff;\n    text-decoration: none;\n    padding: 15px 30px;\n    margin: 15px auto !important;\n    display: block;\n    text-align: center;\n    max-width: 70%;\n    margin-bottom: 15px;\n    width: 100%;\n    box-shadow: none;\n    font-weight: 700;\n    transition: all 0.5s ease;\n    border-radius: 12px;\n    border: 2px solid #fff;\n    margin-top: 10px;\n}\n\n.el-login-sec .el-btn-primary:hover {\n    background: rgba(0, 0, 0, 0);\n    border: 2px solid #000;\n    color: #000;\n}\n\n.el-login-sec .elfotget-password {\n    color: #ec008c;\n    font-size: 16px;\n    padding-top: 20px;\n}\n\n.el-login-sec .text-red {\n    color: #c82121;\n    margin-left: 5px;\n}\n\n.el-login-sec .form-check-input:checked {\n    background-color: #f47324;\n    border-color: #f47324;\n}\n\n.el-gradient-login-box {\n    width: 50%;\n    position: absolute;\n    background: -moz-linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    background: -webkit-linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    height: 100%;\n    left: 0;\n    opacity: 0.8;\n    backdrop-filter: blur(40px);\n}\n\n.el-gradient-login-box {\n    width: 52%;\n    position: absolute;\n    background: -moz-linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    background: -webkit-linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    height: 100%;\n    left: 0;\n    opacity: 0.8;\n    backdrop-filter: blur(74px);\n}\n\n@media (max-width: 992px) {\n    .el-gradient-login-box {\n        width: 100%;\n        opacity: 0.8;\n    }\n}\n\n.el-text-dark {\n    text-decoration: underline !important;\n}\n\nsection.el-login-sec.w-100 {\n    max-width: 600px;\n    background: #fff;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n}\n\n@media (max-width: 768px) {\n    section.el-login-sec.w-100 {\n        background: rgba(255, 255, 255, 0.6196078431) !important;\n    }\n}\n\n.el-login-card h3 {\n    text-align: left;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 40px;\n    margin: 20px 0 20px 0 !important;\n}\n\n.el-login-sec .el-login-background {\n    background: #fff;\n    padding: 0;\n    border-radius: 20px;\n    max-width: 500px;\n    height: 100%;\n    position: relative;\n    margin: 15px;\n    backdrop-filter: unset;\n    padding: 30px;\n    margin: 20px;\n    box-shadow: none;\n}\n\n.el-login-sec .el-login-card .el-login-logo img {\n    margin: 0 auto 50px 0 !important;\n    display: block;\n    width: 200px;\n    max-width: 100%;\n}\n\n.el-login-card h2 {\n    text-align: left;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 40px;\n    margin: 20px 0;\n}\n\n.el-login-sec .form-control {\n    height: initial;\n    padding: 12px 16px;\n    font-size: 16px;\n    line-height: 24px;\n    border: 1px solid #dad9da;\n    border-radius: 4px;\n    max-width: 100%;\n}\n\n@media (min-width: 1200px) {\n    .el-login-sec .form-control {\n        width: 450px;\n    }\n}\n\n.el-login-sec .form-control:focus {\n    box-shadow: none;\n    border: 1px solid #f47324;\n}\n\n.el-login-sec .el-btn-primary {\n    max-width: 100%;\n}\n\n.el-login-sec .elfotget-password {\n    color: #ec008c;\n    font-size: 14px;\n    padding-top: 20px;\n    text-decoration: none;\n}\n\n.el-login-sec .el-login-background {\n    background: #fff !important;\n    padding: 0;\n    border-radius: 0;\n    max-width: 600px;\n    position: relative;\n    margin: 15px;\n    backdrop-filter: unset;\n    padding: 80px;\n    margin: 0;\n    box-shadow: none;\n    left: 0;\n    align-items: center;\n}\n\n@media (max-width: 768px) {\n    .el-login-sec .el-login-background {\n        background: rgba(0, 0, 0, 0) !important;\n        padding: 40px;\n    }\n    .el-login-card {\n        margin-top: 0;\n        background: #fff;\n        border-radius: 20px;\n        padding: 40px !important;\n        padding: 15px;\n    }\n    .el-login-sec .el-login-card .el-login-logo img {\n        margin: 0 auto 50px auto !important;\n        display: block;\n        width: 200px;\n        max-width: 100%;\n    }\n}\n\n@media (max-width: 568px) {\n    .el-login-sec .el-login-background {\n        padding: 20px;\n    }\n    .el-login-card {\n        padding: 20px !important;\n    }\n}\n\n.el-login-card p {\n    font-size: 18px;\n    line-height: 24px;\n    margin-bottom: 40px;\n}\n\n@media (max-width: 768px) {\n    .el-topbar-right {\n        display: none;\n    }\n}\n\n.el-addministrative-setting {\n    background: #fff;\n    border-radius: 16px;\n    box-sizing: border-box;\n    box-shadow: 10px 15px 25px rgba(204, 204, 204, 0.459);\n    text-align: start;\n    padding: 15px 20px !important;\n    margin: 15px 0;\n    height: 100%;\n    position: relative;\n    margin: auto;\n    width: 100%;\n    min-height: 350px;\n}\n\n@media (max-width: 1200px) {\n    .el-addministrative-setting {\n        height: 100%;\n    }\n}\n\n.el-addministrative-setting img {\n    height: 100px;\n    max-width: 100%;\n    object-fit: contain;\n    margin: 20px 0;\n}\n\n.el-addministrative-setting p {\n    line-height: 130%;\n}\n\n.el-addministrative-setting h3 {\n    font-size: 18px;\n    line-height: 26px;\n    font-weight: 700;\n    font-family: \"Mulish\", sans-serif;\n    margin-bottom: 14px;\n}\n\n.el-addministrative-setting button.btn.btn-outline-primary {\n    border: 1px solid #ee5b0b;\n    transition: all 0.2s ease-in;\n    color: #ee5b0b;\n    position: absolute;\n    bottom: 20px;\n}\n\n@media (max-width: 1400px) {\n    .el-addministrative-setting button.btn.btn-outline-primary {\n        position: relative !important;\n        bottom: 0 !important;\n    }\n}\n\n.el-addministrative-setting button.btn.btn-outline-primary:hover {\n    background: #ee5b0b;\n    color: #fff;\n}\n\n.col-xxl-3:has(.el-addministrative-setting) {\n    margin: 15px 0;\n}\n\n.el-title {\n    font-size: 26px;\n    margin-bottom: 15px;\n    font-weight: 900;\n    font-weight: 500;\n}\n\n.el-bg-table {\n    background: #fff;\n    padding: 20px;\n    box-sizing: border-box;\n    box-shadow:4px 11px 50px rgb(45 43 43 / 5%); \n    border-radius: 12px;\n    /* overflow: auto; */\n}\n\n.el-bg-table:has(table) {\n    background: #fff;\n    padding: 20px;\n    box-sizing: border-box;\n    box-shadow: 4px 11px 50px rgb(45 43 43 / 5%); \n    border-radius: 12px;\n    overflow: auto;\n}\n.el-bg-table .el-bordered-btn {\n    background: rgba(0, 0, 0, 0);\n    color: #202224;\n    margin: 0 15px;\n    border: 1px solid #202224;\n    margin: auto;\n    padding: 8px 20px;\n    font-size: 17px;\n}\n\n.el-bg-table .el-bordered-btn:hover {\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0);\n}\n\n.el-bg-table button.btn.btn-secondary.dropdown-toggle {\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    border: 0;\n    outline: 0;\n    min-height: 43px;\n    padding: 4px 20px;\n    font-size: 17px;\n}\n.el-bg-table button.btn.btn-secondary .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: .3em solid;\n    border-right: .3em solid rgba(0, 0, 0, 0);\n    border-bottom: 0;\n    border-left: .3em solid rgba(0, 0, 0, 0);\n    top: 2px;\n    position: relative;\n}\n.el-bg-table h3 {\n    font-size: 20px;\n    margin-bottom: 15px;\n    font-weight: 900;\n    margin: 0;\n    font-weight: 500;\n}\n\n.el-bg-table ul.dropdown-menu.el-admin {\n    border: 0;\n    box-sizing: border-box;\n    overflow: hidden;\n    box-shadow: 3px 5px 25px 13px rgba(204, 204, 204, 0.25);\n    padding: 0;\n    left: -80% !important;\n}\n\n.el-bg-table ul.dropdown-menu.el-admin a.dropdown-item {\n    border-bottom: 1px solid #ccc;\n    padding: 10px 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0);\n}\n\n.el-bg-table ul.dropdown-menu.el-admin a.dropdown-item:hover {\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%) !important;\n    color: #fff;\n}\n\n.el-bg-table ul.dropdown-menu.el-admin li {\n    border-bottom: 1px solid #ccc;\n}\n\n.el-bg-table ul.dropdown-menu.el-admin li:last-child {\n    border: 0;\n}\n\n.el-bg-table .el-table-container {\n    margin-top: 30px;\n}\n\n.el-bg-table .btn-primary {\n    outline: 0;\n    width: fit-content;\n    background: rgba(0, 0, 0, 0);\n    border: 0;\n}\n\n.el-bg-table .btn-primary:focus {\n    background: rgba(0, 0, 0, 0);\n}\n\n.el-bg-table ul.dropdown-menu.el-action {\n    border: 0;\n    box-sizing: border-box;\n    overflow: hidden;\n    box-shadow: 3px 5px 25px 13px rgba(204, 204, 204, 0.25);\n    padding: 0;\n    top: -36px !important;\n    left: 30px !important;\n}\n\n.el-bg-table ul.dropdown-menu.el-action a.dropdown-item {\n    border-bottom: 1px solid #ccc;\n    padding: 10px 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0);\n}\n\n.el-bg-table ul.dropdown-menu.el-action a.dropdown-item:hover {\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%) !important;\n    color: #fff;\n}\n\n.el-bg-table ul.dropdown-menu.el-action li {\n    border-bottom: 1px solid #ccc;\n}\n\n.el-bg-table ul.dropdown-menu.el-action li:last-child {\n    border: 0;\n}\n\n.el-bg-table .el-active {\n    color: #03a827 !important;\n    display: flex;\n    align-items: center;\n}\n\n.el-bg-table .el-active .el-activebtn {\n    width: 10px;\n    height: 10px;\n    background: #03a827 !important;\n    margin-right: 15px;\n    border-radius: 50%;\n}\n\n.el-bg-table .el-inactive {\n    color: #3a3a3a !important;\n    display: flex;\n    align-items: center;\n}\n\n.el-bg-table .el-inactive .el-inactive {\n    width: 10px;\n    height: 10px;\n    background: #222 !important;\n    margin-right: 15px;\n    border-radius: 50%;\n}\n\n.el-bg-table .el-table-container {\n    padding: 0;\n}\n\n.el-bg-table .el-table-container th {\n    background: #e6ebed;\n    color: #161616;min-width: 100px;\n}\n\n.el-bg-table .el-table-container th:first-child {\n    border-top-left-radius: 10px;\n}\n\n.el-bg-table .el-table-container th:last-child {\n    border-top-right-radius: 10px;\n}\n\n.el-bg-table .el-table-container .table tr:last-child td:first-child {\n    border-bottom-left-radius: 10px;\n}\n\n.el-bg-table .el-table-container .table tr:last-child td:last-child {\n    border-bottom-right-radius: 10px;\n}\n\n.el-deactivate-modal .modal-body {\n    padding: 30px;\n}\n\n.el-deactivate-modal .modal-body h2 {\n    font-size: 24px;\n    text-align: center;\n    font-weight: 700;\n    line-height: 32px;\n    margin-bottom: 30px;\n}\n\n.el-deactivate-modal .modal-body .deactivateimg {\n    width: 150px;\n    margin: 20px auto;\n    display: block;\n    height: auto;\n}\n\n.el-deactivate-modal .el-filled-btn {\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    color: #fff;\n    margin: auto;\n    padding: 4px 50px;\n    font-size: 17px;\n    margin: 0 15px;\n}\n\n.el-deactivate-modal .el-filled-btn :hover {\n    color: #fff;\n}\n\n.el-deactivate-modal .el-bordered-btn {\n    background: rgba(0, 0, 0, 0);\n    color: #202224;\n    margin: 0 15px;\n    border: 1px solid #202224;\n    margin: auto;\n    padding: 4px 50px;\n    font-size: 17px;\n}\n\n.el-deactivate-modal .w-f-content {\n    width: fit-content;\n}\n\n.el-profile-board {\n    background: #fff;\n    padding: 20px;\n    box-sizing: border-box;\n    box-shadow: 10px 15px 25px rgba(204, 204, 204, 0.459);\n    border-radius: 20px;min-height: auto;\n}\n\n.el-profile-board h3 {\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 600;\n    color: #070a13;\n    margin: 0;\n}\n\n.el-profile-board h4 {\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 500;\n    color: #070a13;\n    margin: 0;\n}\n\n.el-profile-board h5 {\n    font-size: 19px;\n    line-height: 26px;\n    font-weight: 700;\n    color: #070a13;\n    margin: 0;\n}\n\n.el-profile-board .el-border-rounded {\n    width: fit-content;\n    margin: 20px 10px;\n}\n\n.el-profile-board .el-property-details-card-content {\n    width: 100%;\n}\n\n.el-profile-board .el-flexbox {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 0;\n    align-items: center;\n    border-bottom: 1px solid #cbd5e1;\n    margin-bottom: 15px;\n}\n\n.el-profile-board .el-request-detail-profile-name {\n    font-size: 12px;\n    color: #000;\n    line-height: 18px;\n    font-weight: 600;\n    margin-bottom: 0px !important;\n}\n\n.el-profile-board .el-request-detail-profile-name a {\n    color: #000 !important;\n    text-decoration: none;\n}\n\n.el-profile-board .location-icon {\n    padding: 0 8px;\n}\n\n.el-profile-board .location-icon img {\n    height: auto;\n    width: 10px;\n    margin-right: 10px;\n}\n\n.el-profile-board .el-card-content p {\n    font-size: 12px;\n    line-height: 18px;\n    font-weight: 600;\n    margin-bottom: 0px !important;\n    color: #64748b;\n}\n\n.el-profile-board .el-border-rounded img {\n    width: 100px;\n    height: 100px;\n    border-radius: 8px;\n}\n\n\n\n.el-profile-board .active {\n    color: #03a827 !important;\n}\n\n.el-profile-board button.btn.btn-secondary.dropdown-toggle {\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    border: 0;\n    outline: 0;\n}\n\n.el-profile-board ul.dropdown-menu.el-admin {\n    border: 0;\n    box-sizing: border-box;\n    overflow: hidden;\n    box-shadow: 3px 5px 25px 13px rgba(204, 204, 204, 0.25);\n    padding: 0;\n    left: -80% !important;\n}\n\n.el-profile-board ul.dropdown-menu.el-admin a.dropdown-item {\n    border-bottom: 1px solid #ccc;\n    padding: 10px 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0);\n}\n\n.el-profile-board ul.dropdown-menu.el-admin a.dropdown-item:hover {\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%) !important;\n    color: #fff;\n}\n\n.el-profile-board ul.dropdown-menu.el-admin li {\n    border-bottom: 1px solid #ccc;\n}\n\n.el-profile-board ul.dropdown-menu.el-admin li:last-child {\n    border: 0;\n}\n\n.el-profile-board .form-check {\n    margin-bottom: 30px !important;\n}\n\n.el-profile-board .el-filled-btn {\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    color: #fff;\n    margin: auto;\n    padding: 8px 20px;\n    border: 1px solid rgba(0, 0, 0, 0);\n    font-size: 17px;\n    margin: 0 15px;\n}\n\n.el-profile-board .el-filled-btn:hover {\n    color: #202224;\n    background: rgba(0, 0, 0, 0) !important;\n    border: 1px solid #202224;\n}\n\n.el-profile-board .el-bordered-btn {\n    background: rgba(0, 0, 0, 0);\n    color: #202224;\n    margin: 0 15px;\n    border: 1px solid #202224;\n    margin: auto;\n    padding: 8px 20px;\n    font-size: 17px;\n}\n\n.el-profile-board .el-bordered-btn:hover {\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0);\n}\n\n.el-profile-board .w-f-content {\n    width: fit-content;\n}\n\n@media (min-width: 768px) {\n    .el-card-content .flex-sec {\n        display: flex;\n        justify-content: start;\n        flex-wrap: wrap;\n    }\n}\n\n.el-profile-board .el-card-content p {\n    font-size: 16px;\n    line-height: 24px;\n    color: #000;\n    font-family: \"Mulish\", sans-serif;\n    margin-bottom: 5px !important;\n    font-weight: 600;\n}\n\n.el-flex-area {\n    display: flex;\n     \n    align-items: center;\n}\n\n.el-profile-board .el-request-detail-profile-name {\n    font-size: 14px;\n    color: #000000e8;\n    line-height: 18px;\n    font-weight: 500;\n    margin-bottom: 0px !important;\n}\n\n.el-profile-board .location-icon img {\n    height: auto;\n    width: 21px;\n    margin-right: 5px !important;\n}\n\n.el-profile-board .form-check {\n    margin-bottom: 30px !important;\n    color: #000;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n}\n\n.el-profile-board .form-check .form-check-input[type=\"checkbox\"] {\n    border-radius: 0.25em;\n    border: 1px solid #f16806;\n    margin-right: 15px;\n}\n\n.el-profile-board .form-check .form-check-input:checked {\n    background-color: #f16806;\n    border-color: #f16806;\n}\n\nspan.navbar-toggler-icon img {\n    width: 14px;\n    line-height: 40px;\n}\n\nspan.navbar-toggler-icon {\n    background: #f16806;\n    position: absolute;\n    right: 0;\n    top: 40px;\n    display: flex;\n    width: 30px;\n    height: 40px;\n    border-radius: 6px 0 0 6px;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n}\n\n#sidebar-open img {\n    width: 24px;\n}\n\n.hr-line {\n    margin-bottom: 20px;\n    background: #cbd5e1;\n    height: 1px;\n    width: 100%;\n}\n\n.el-super-admin .form-check {\n    margin-bottom: 30px;\n    color: #000;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n}\n\n.el-super-admin .form-check .form-check-input[type=\"checkbox\"] {\n    border-radius: 0.25em;\n    border: 1px solid #f16806;\n    margin-right: 15px;\n}\n\n.el-super-admin .form-check .form-check-input:checked {\n    background-color: #f16806;\n    border-color: #f16806;\n}\n\n.el-super-admin .el-filled-btn {\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    color: #fff;\n    margin: auto;\n    padding: 8px 20px;\n    border: 1px solid rgba(0, 0, 0, 0);\n    font-size: 17px;\n    margin: 0 15px 0 0;\n}\n\n.el-super-admin .el-filled-btn:hover {\n    color: #202224;\n    background: rgba(0, 0, 0, 0) !important;\n    border: 1px solid #202224;\n}\n\n.el-or {\n    position: relative;\n}\n\n.el-or h2 {\n    background: #fff;\n    font-size: 20px;\n    position: absolute;\n    width: 60px;\n    top: -11px;\n    border-radius: 0;\n    text-align: center;\n    font-size: 19px;\n    font-weight: bold;\n    padding: 2px;\n    left: 19px;\n    top: -15px;\n    border-left: 1px solid #cbd5e1;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-right: 1px solid #cbd5e1;\n}\n\n.el-or .hr-line {\n    margin: 40px 0;\n}\n\n.el-appoinment-duration label.form-label {\n    font-size: 16px;\n    margin-bottom: 15px;\n    font-weight: 700;\n}\nlabel.form-label {\n    font-weight: 700;\n    font-size: 16px;\n}\n.el-appoinment-duration select.form-select {\n    border: 1px solid #888;\n}\n\n.el-appoinment-duration input.form-control {\n    border: 1px solid #888;\n}\n\n.el-appoinment-duration span.input-group-text {\n    background: #f16806;\n    border: 1px solid #888;\n    color: #fff;\n}\n\n.el-appoinment-duration .form-select:focus {\n    border-color: #f16806;\n    box-shadow: 0 0 0 0.25rem rgba(241, 104, 6, 0.25);\n}\n\n.el-appoinment-duration .form-select option {\n    background-color: #fff;\n    color: #000;\n}\n\n.el-appoinment-duration .form-select option:hover {\n    background-color: #f16806;\n    color: #fff;\n}\n\n.el-appoinment-duration .form-select option:checked {\n    background-color: #f16806;\n    color: #fff;\n}\n\n.el-appoinment-duration .form-control:focus {\n    border-color: #f16806;\n    box-shadow: 0 0 0 0.25rem rgba(241, 104, 6, 0.25);\n}\n\n.form-switch .form-check-input {\n    width: 51px !important;\n    height: 23px;\n    border-radius: 50px;\n}\n\n.form-check.form-switch .form-check-input {\n    border-radius: 50px !important;\n}\n\nselect.form-select.w-fit-content {\n    width: fit-content;\n}\n\n.btn-hours-outline {\n    width: fit-content !important;\n    margin-right: auto;\n    display: block;\n    margin-left: 13px !important;\n    margin-top: 15px !important;\n    padding: 10px;\n}\n\n.el-super-admin select.form-select {\n    border: 1px solid #888;\n}\n\n.el-super-admin .input-group-text {\n    background: #f16806;\n    border: 1px solid #888;\n    color: #fff;\n}\n\n.ely-sample-request-details button.accordion-button {\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.ely-sample-request-details .accordion-button:focus {\n    box-shadow: none;\n}\n\n.ely-sample-request-details .accordion-button:not(.collapsed) {\n    color: #000;\n    background-color: #e6ebed4f;\n    box-shadow: none;\n}\n\n.ely-sample-request-details .accordion-button:not(.collapsed)::after {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23eb4e0e' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e\");\n    transform: var(--bs-accordion-btn-icon-transform);\n}\n\n.ely-sample-request-details .accordion-item {\n    margin-bottom: 20px;\n}\n\n.ely-sample-request-details .accordion-item:has(.show) {\n    border: 0;\n}\n\n.ely-sample-request-details .accordion-body {\n    padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n    background: rgba(204, 204, 204, 0.21);\n    border: 0;\n    box-shadow: none;\n}\n\n.ely-sample-request-details button.accordion-button[aria-expanded=\"true\"] .badge {\n    background: #dc3545  !important;\n    color: #fff !important;\n}\n \n.ely-sample-request-details div#accordionFlushExample1 .accordion-button:not(.collapsed) {\n    color: #212529 !important;\n}\n\n.ely-sample-request-details div#accordionFlushExample1 .accordion-button:not(.collapsed)::after {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23f16806' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e\");\n    transform: var(--bs-accordion-btn-icon-transform);\n}\n\n \n.ely-sample-request-details div#accordionFlushExample1 .accordion-body {\n    padding: 20px;\n border: 0;\n    border-top: 0;\n    background: #fff;\n    box-shadow: 7px 5px 18px rgba(0, 0, 0, .0705882353);\n}\n.ely-sample-request-details div#accordionFlushExample1 .accordion-item .dropdown-toggle {\n    background: #f4f4f4 !important;\n     \n    padding: 10px 10px;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    display: flex;\n}\n.ely-sample-request-details div#accordionFlushExample1 .accordion-item .dropdown-toggle img {\n    margin: auto;\n    display: block;\n}\n\n.ely-sample-request-details div#accordionFlushExample1 .accordion-item .dropdown-toggle::after {\n    display: none !important;\n}\n \n.form-select {\n    height: 50px !important;\n    border: 1px solid #888 !important;\n}\n\n.el-mb-0 {\n    margin-bottom: 0px !important;\n}\n\n.w-f-content {\n    width: fit-content;\n}\n\n@media (max-width: 768px) {\n    .el-bg-table .d-flex:first-child {\n        flex-wrap: wrap;\n    }\n    .el-bg-table h3 {\n        margin-bottom: 20px;\n    }\n    .form-select {\n        margin-bottom: 15px;\n    }\n    .el-property-details-card-content select {\n        margin-top: 30px;\n    }\n    .el-property-details-card-content .col-md-3 select {\n        margin-top: 0;\n    }\n}\n\n/* sidebar closing arrow */\n\nspan.navbar-toggler-icon img {\n    width: 14px;\n    line-height: 40px;\n}\n\nspan.navbar-toggler-icon {\n    background: #f16806;\n    position: absolute;\n    right: 0;\n    top: 40px;\n    display: flex;\n    width: 30px;\n    height: 40px;\n    border-radius: 6px 0 0 6px;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n}\n\n#sidebar-open img {\n    width: 20px;\n}\n\n\n@media (max-width: 1300px) {\n    .el-middle-top {\n        flex-wrap: wrap;\n    }\n}\n\n@media (min-width: 992px) and (max-width: 1300px) {\n    .el-middle-top .el-middle-top-col {\n        margin-bottom: 15px;\n        max-width: 100%;\n        min-width: 400px;\n    }\n}\n\n@media (min-width: 568px) and (max-width: 768px) {\n    .el-middle-top .el-middle-top-col {\n        margin-bottom: 15px;\n        max-width: 100%;\n        min-width: fit-content;\n    }\n}\n\n@media (min-width: 568px) {\n    .el-middle-top-col {\n        margin-bottom: 15px;\n        max-width: 100%;\n        min-width: fit-content;\n    }\n}\n\n@media (max-width: 568px) {\n    .el-middle-top-col {\n        margin-bottom: 15px;\n        max-width: 100%;\n        min-width: 100%;\n    }\n}\n\n@media (max-width: 1400px) {\n    .el-table-container.el-board-table {\n        display: block;\n        width: 100%;\n        overflow: unset;\n    }\n    .el-table-container .table {\n        margin: 0;\n        overflow: auto;\n    }\n}\n\n.el-middle-top-col {\n    margin-right: 1%;\n    display: flex;\n    align-items: center;\n    border-radius: 12px;\n    padding: 12px 20px;\n    background: #f47403;\n    background: linear-gradient(136deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n}\n\n@media (min-width: 1600px) {\n    .el-middle-top-col {\n        width: 24%;\n    }\n}\n\n@media (min-width: 1201px) {\n    .el-middle-top-col {\n        flex-wrap: wrap;\n    }\n}\n\n.el-middle-top-col strong {\n    display: block;\n    font-size: 32px;\n    color: #fff;\n    margin: 0 0 10px;\n}\n\n.el-middle-top-col span {\n    font-size: 18px;\n    color: #fff;\n    font-weight: bold;\n}\n\n.el-middle-top-col + .el-middle-top-col {\n    background: #e83f12;\n    background: linear-gradient(136deg, rgb(232, 63, 18) 0%, rgb(189, 75, 118) 58%, rgb(145, 79, 179) 100%);\n}\n\n.el-middle-top-col + .el-middle-top-col + .el-middle-top-col {\n    background: #8d4db2;\n    background: linear-gradient(\n        136deg,\n        rgb(141, 77, 178) 0%,\n        rgb(141, 77, 178) 40%,\n        rgb(123, 64, 157) 64%,\n        rgb(72, 26, 98) 92%\n    );\n}\n\n@media (max-width: 568px) {\n    .el-topbar-right {\n        display: none;\n    }\n    .el-topbar {\n        padding: 20px;\n    }\n}\n\n.el-middle {\n    transition: all 0.5s linear;\n}\n\n.el-middle.collapsed-body {\n    width: 100%;\n    padding: 0;\n}\n\n@media (min-width: 992px) {\n    .el-topbar.el-middle.collapsed-body {\n        padding: 15px 45px;\n    }\n}\n@media (max-width: 991px) {\n    .el-topbar.el-middle.collapsed-body {\n        padding: 20px !important;\n    }\n    .el-middle #sidebar-open {\n        display: block !important;\n    }\n    button#sidebar-open {\n        position: unset !important;\n    }\n}\n\n.el-middle #sidebar-open {\n    display: none;\n}\n\n.el-middle.collapsed-body #sidebar-open {\n    display: block;\n}\n\nbutton#sidebar-open {\n    position: absolute;\n}\n\n.el-board-table th .dropdown-menu.show {\n    padding: 12px 12px;\n    min-width:240px;\n    border: 0;\n    box-shadow: 6px 20px 45px #cccccc70;\n}\n\n.el-board-table th .form-check-input[type=\"checkbox\"] {\n    border-radius: 0.25em;\n    margin-top: 0;\n    border: 1px solid #000;\n}\n\n.el-board-table th input.btn.btn-link {\n    padding: 0;\n    text-decoration: none;\n    border-top: 1px solid #ccc;\n    border-radius: 0;\n    width: 100%;\n    margin-top: 16px;\n    font-weight: 700;\n    padding: 6px 0 0 0;\n    color: #e63516;\n}\n\n.el-board-table th .form-check {\n    margin-bottom: 15px!important;\n}\n.el-board-table th input.btn.btn-link {\n    margin-top: 0;\n}\n.el-board-table th .form-check-input:checked {\n    background-color: #f47324;\n    border-color: #f47324;\n}\n.el-board-table th label {\n    margin-right: 10px;\n}\n\n.el-board-table th input[type=\"text\"] {\n    width: 90%;\n    position: absolute;\n    left:0;\n    top: 4px;\n    height: 85%;\n    border: 0;\n    padding: 0 15px;\n    border-radius: 10px ;padding-left: 40px!important;\n}\n.el-board-table th {\n    position: relative;\n}\n\n/* .el-board-table button#roleFilterDropdown:hover { */\n    /* background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%); */\n/* } */\n\n.el-board-table .btn.show {\n    background: transparent;\n}\n\ninput[type=\"text\"]:focus-visible {\n    border: 0;\n    outline: 0;\n}\n\n  a.nav-link.active i {\n    color: #fff !important;\n}\n\n a.nav-link:hover i {\n    color: #fff !important;\n}\n.el-searchimg {\n    width: 25px;\n    height: 28px;\n    background: #ffffff;\n    z-index: 999;\n    position: absolute; \n    left:1px;\n    display: flex;cursor: pointer;\n    align-items: center;\n    justify-content: center;\n    color: #888;\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n    border-right: 1px solid #888;\n} \n.el-table-input + input {\n    padding-left: 30px !important;\n}\n.el-board-table .el-table-input {\n    display: flex;height: 30px;\n    align-items: center;\n}\n.el-board-table .el-table-input svg{\n    cursor: pointer;\n}\n\n.el-table-input:has(label) {\n    position: relative; \n}\n.el-page-count {\n    display: flex;\n    align-items: center; \n    padding: 6px 0px;\n    font-weight: 700;\n    border-radius: 8px;\n    color: #161616;\n}\n\n.el-page-count .btn-link {\n    color: #161616;\n    text-decoration: none;\n}\n.el-page-count .btn-link:hover {\n    color: #161616;\n}\n\n  a.page-link {\n    background: #EB4E0E;\n    color: #fff;\n    font-size: 18px;\n    border: 0;border-radius: 5px;\n}\n.el-board-table .btn:focus-visible {\n    background: transparent !important;\n}\n/* .el-board-table .btn:hover {\n    background: transparent !important;\n} */\n  li.page-item.disabled .page-link {\n    background: transparent !important;\n    border: 0;\n    font-size: 50px;\n    color: #003479 !important;\n}\n\n.el-bg-table.el-super-admin .col-md-4 {\n    margin-bottom: 0px;\n}\n\n.form-check-input{\n    margin-top: 0!important; color:  #888;\n}\n@media(max-width:991px){\n.el-searchimg {  \n    left: 0; \n}}\n.dropdown-item:active{\n    background: #fb8b43!important;\n}\n.toast-container{\n    z-index: 99999!important;\n}\n\n\n\n/*  */\n.text-red{\n    margin-left: 5px;\n    color: red;\n}\n\n.react-datepicker-wrapper {\n    display: block;\n}\n\n.remove-btn-wrapper button {\n    padding: 5px 15px !important;\n}\n.remove-btn-wrapper {\n    margin-bottom: 15px;\n}\n\n.text-green{\n    margin-left: 5px;\n    color: green;\n}\n\n\n.child-wrapper {\n    position: relative;\n}\n\n.child-wrapper::before {\n    content: \"\";\n    position: absolute;\n    background: #eee;\n    width: 1px;\n    height: 100%;\n    left: 20px;\n    top: -15px;\n}\n\n.child-menu-permission {\n    padding-left: 40px !important;\n    position: relative;\n}\n\n.child-menu-permission::before {\n    content: \"\";\n    position: absolute;\n    background: #ccc;\n    width: 20px;\n    height: 1px;\n    top: 12px;\n    left: 20px;\n}\n.text-bodyla-fluid {\n    color: #796c00 !important;\n}\n.text-exhaledbreath {\n    color: #1ce4ff !important;\n}\n.text-skin-tap {\n    color: #C98C55 !important\n}\n\n.text-hair-follicle {\n    color: #000 !important;\n}\n\n.text-stool {\n    color: #a3622c !important;\n}\n/* CSS to remove arrows from number input */\n.no-arrows::-webkit-outer-spin-button,\n.no-arrows::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.no-arrows[type=\"number\"] {\n    -moz-appearance: textfield; /* For Firefox */\n    appearance: textfield; \n}\n\n.el-blood-donation-section {\n    margin-top: 50px;\n}\n.bg-bodyla-fluid {\n    background: #4d460c !important;\n    background-image: initial !important;\n    background-position-x: initial !important;\n    background-position-y: initial !important;\n    background-size: initial !important;\n    background-repeat: initial !important;\n    background-attachment: initial !important;\n    background-origin: initial !important;\n    background-clip: initial !important;\n    background-color: rgb(77, 70, 12) !important;\n    font-size: 14px;\n}\n\n.text-white {\n    --bs-text-opacity: 1!important;\n    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n.bg-bukkal-swab {\n    background:#E8598C !important;\n    font-size: 14px;\n}\n.el-dononr-sample-type .btn {\n    background: #fff;\n    margin: 10px 15px;\n    font-weight: 600;\n    border: 1px solid #f16806;\n    font-size: 18px;\n    cursor: auto;\n    padding: 6px 7px;text-align: left;\n    min-width: 140px;\n    font-size: 15px;\n}\n.bg-hair-follicle {\n    background: #353333 !important;\n    font-size: 14px;\n}\n.bg-text-skin-tap {\n    background: #8d5524 !important;\n    font-size: 14px;\n}\n.bg-stool {\n    background:#674F12 !important;\n    font-size: 14px;\n}\n\n/* .form-control {\n    background: RGB(255, 255, 255);\n    border: 1px solid rgba(0, 0, 0, .47);\n    border-radius: 10px;\n    padding: 17px 20px;\n    font-weight: 500;\n    font-size: inherit;\n    line-height: inherit;\n \n    color: #000;\n    min-height: 53px;\n} */\n.form-control.invalid {\n    border-color: red !important;\n}\n\n.ely-sample-request-details div#accordionFlushExample1 .accordion-item button {\n    background: #f4f4f4;\n    border: 0px solid var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n    padding: 10px 10px;\n    font-size: 15px;\n}\n \n\n.ely-sample-request-details div#accordionFlushExample1 .accordion-button:not(.collapsed) {\n    color: #212529 !important;\n    background: #e8e8e8;\n} \n\n.el-line-btns {\n    background: rgba(0, 0, 0, 0) !important;\n    color: #f47403;\n    font-size: 17px;\n    margin: 0 15px;\n    height: fit-content;\n    border: 1px solid #f47403 !important;\n    padding: 24px 30px !important;\n    line-height: 0!important;\n    font-weight: 600;\n} \nspan.navbar-toggler-icon {\n    background: linear-gradient(136deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    position: relative;\n    left: 58px;\n    top: -2px;\n    display: flex;\n    width: 22px;\n    height: 34px;\n    border-radius: 0 5px 5px 0;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n} \n.el-sidebar {\n    height: 100vh;\n    overflow: visible;\n    background: #fff;\n    position: fixed;\n    left: 0;\n    transition: all 0.5s ease;\n    top: 0;\n    z-index: 99!important;\n}\n\n.el-main-button {  \n        font-weight: 700;\n        padding: 8px 16px;\n        color: #ee5b0b!important;\n        border: 1px solid #ee5b0b!important;\n        font-size: 16px;\n        overflow: hidden;\n        border-radius: 50px;\n        display: flex;\n        align-items: center;\n        background: transparent;\n        pointer-events: auto;\n        position: relative;\n        cursor: pointer;\n        width: fit-content!important;\n        margin: 0 30px 0 0;\n        transition: color 0.2s ease-in;\n} \n\n.el-error-button {  \n    font-weight: 700;\n    padding: 8px 16px;\n    color: #ff0000 !important;\n    border: 1px solid #ff0000 !important;\n    font-size: 16px;\n    overflow: hidden;\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    background: transparent;\n    pointer-events: auto;\n    position: relative;\n    cursor: pointer;\n    width: fit-content!important;\n    margin: 0 30px 0 0;\n    transition: color 0.2s ease-in;\n}\n  \n.el-main-button:after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute; \n    left: -100%;\n    top: 0;\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%); \n    transition: all .2s ease-in;\n}\n\n.el-error-button:after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute; \n    left: -100%;\n    top: 0;\n    background: linear-gradient(321deg, rgb(244, 3, 3) 0%, rgb(227, 42, 25) 100%); \n    transition: all .2s ease-in;\n}\n\n.el-main-button:hover::after,\n.el-error-button:hover::after {\n    left: 0;\n}\n\n.el-main-button:hover span,\n.el-error-button:hover span {\n    color: #fff; position: relative;\n    z-index: 99;\n}\n\n.el-main-button:hover span,\n.el-error-button:hover span {\n    transition-delay: 0.1s;\n}\n\n\n.el-super-admin .el-filled-btn {\n    font-weight: 700;\n    padding: 8px 16px;    \n    color: #ee5b0b;\n    border: 1px solid #ee5b0b;\n    font-size: 16px;\n    overflow: hidden; \n    border-radius: 6px;display: flex;align-items: center;\n    background: transparent; \n    pointer-events: auto;\n    position: relative; \n    cursor: pointer; \n    transition: color 0.2s linear;\n}\n\n\n.el-super-admin .el-filled-btn:after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute; \n    left: -100%;\n    top: 0;\n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%); \n    transition: all .2s linear;\n}\n\n.el-super-admin .el-filled-btn:hover::after {\n    left: 0;\n}\n\n.el-super-admin .el-filled-btn:hover span {\n    color: #fff; position: relative;\n    z-index: 99;\n}\n\n.el-super-admin .el-filled-btn:hover span {\n    transition-delay: 0.2s;\n}\n \n.el-main-button i{\n    font-size: 20px;\n}\n.el-board-table .el-table-input label{\n    font-weight: 600;\n    color: #161616;\n}\n.el-min-height-content {\n    min-height: 140px;\n}\n  \n.el-text-btn {\n    color: #ee5b0b;\n    outline: 0;\n    border: 0;\n    background: transparent;\n    font-weight: 700;\n    text-decoration: underline;\n}\n\n/* @media(min-width:1600px){\n    .el-bg-table.el-super-admin > form {\n        width: 80%;\n    }\n} */\n.form-control {\n    display: block;\n    width: 100%;\n    padding: .375rem .75rem;\n    font-size: 1rem;\n    border: 1px solid #00000091!important;\n    font-weight: 400;\n    line-height: 1.5;\n    min-height: 50px;\n    background: transparent;\n    color: var(--bs-body-color);\n    appearance: none;\n    background-color: #f1f1f1;\n    background-clip: padding-box;\n    border-radius: var(--bs-border-radius);\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n}\n\n.form-check-input[type=radio] {\n    border-radius: 50%;\n    border: 1px solid #00000091!important;\n}\n\nbutton + .back-link {\n    color: #000000!important;\n    \n}\n\n.el-sidebar .el-navlabel { \n    color: #000000; \n}\n.el-sidebar .el-navlabel:before { \n    background: #000000; \n}\n.el-sidebar .nav-item .nav-link.active {\n    background: transparent;\n    background: transparent;\n    color: #202224;\n    border: 1px solid #eb4e0e;\n    border-radius: 50px;font-weight: 700;\n}\na.nav-link.active i, a.nav-link:hover i {\n    color: #eb4e0e!important \n}\n.el-sidebar .nav-item .nav-link{\n    margin-bottom: 5px; \n}\ntable.table.table-striped.table td {\n    background: transparent;\n    box-shadow: none;\n}\n.el-board-table .el-table-input label, .el-bg-table .btn-primary, .el-board-table th label {\n    font-weight: 600;\n    color: #161616!important;\n    font-size: 17px;\n} \n\n\n.el-table-container .table tbody tr:last-child td .dropdown-toggle::after{\n     opacity: 0;\n}\n\nbutton.text-danger.btn.btn-outlined-secondary {\n    background: transparent;\n    padding: 0;\n    width: 35px;\n    height: 35px;\n    /* border: 1px solid #eb4e0e; */\n}\n/* table.table.table-striped.table td .btn{ */\n    /* background: transparent;\n    padding: 0;\n    width: 35px;\n    height: 35px;\n    border: 1px solid #eb4e0e;border-radius: 5px; */\n    /* color: #eb4e0e!important; */\n    /* margin: 0 5px; */\n/* } */\n\ntable.table.table-striped.table td .btn {\n    background: transparent;\n    /* padding: 0; */\n    width: auto;\n    height: auto;\n    padding-top: 0;\n    padding-bottom: 0;\n    border: none;\n    border-radius: 5px; \n    color: #000; \n    margin: 0;\n}\n\ntable.table.table-striped.table td .btn.text-danger{\n    color: #000!important;\n} \n\n\nbutton#dropdown-basic{\n    border: 0;\n}\n.el-sidebar .nav-item .nav-link.active:before {    content: '';\n    width: 8px;\n    height: 90%;\n    background: linear-gradient(136deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%);\n    position: absolute;\n    left: 0;\n    border-radius: 0 5px 5px 0;\n    top: 3px;\n\n}\n \n.el-sidebar .nav-item {\n    /* padding: 0 20px; */\n    padding: 0 0px;\n    position: relative;\n}\n.el-sidebar .nav-item .nav-link.active, .el-sidebar .nav-item .nav-link:hover {\n    background: transparent;\n    background: transparent;\n    color: #eb4e0e;\n    font-weight: 600;\n    border: 0px solid #eb4e0e;\n    border-radius: 50px;\n}\n \n.el-sidebar .nav-item .nav-link.active span {\n    display: inline-block;\n    vertical-align: middle;\n    color: #eb4e0e!important;\n    margin: 0 0 0 8px;\n}\n\n.el-sidebar .nav-item .nav-link span {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0 0 0 8px;\n    font-weight: 600;\n}\n.el-topbar {\n    transition: all 0.5s linear;\n    border-bottom: 1px solid #dee2e6;\n}\n.el-sidebar{\n    border-right: 1px solid #dee2e6;\n}\n.el-sidebar .navbar-expand-lg {\n    padding-top: 14px; \n}\n.el-logo {\n    height: 96px; \n}\n \n.el-middle-content { \n    box-shadow: 4px 11px 25px #20202012;\n}\n.el-board-table  th {\n    padding: 10px!important;\n}\n.el-board-table  th {\n    position: relative;\n    line-height: 100%;\n}\n.el-board-table  th {\n    padding: 10px 13px!important;\n}\n\n.el-board-table .job-list-st-filter {\n    padding: 0px !important;\n}\n.job-list-st-filter #statusFilterDropdown::after {\n    display: none;\n    content: none;\n}\n\n.el-action.dropdown-menu {\n    box-shadow: -5px 2px 25px #3733332e;padding: 0;overflow: hidden;\n}\n.el-action.dropdown-menu  a.dropdown-item {\n    padding: 4px 8px;\n    margin: 0 0 5px 0;\n    font-weight: 600;\n}\n.el-action.dropdown-menu  a.dropdown-item:last-child{\n    margin: 0;\n}\n.el-action.dropdown-menu  a.dropdown-item:hover{\n    background: #eb4e0e; \n    color: #fff!important;\n}\n.el-action.dropdown-menu  a.dropdown-item:hover label{\n    background: #eb4e0e; \n    color: #fff!important;\n}\n\n.dropdown-item:hover{\n    background: #eb4e0e!important; \n    color: #fff!important;\n}\n.dropdown-menu{\n    padding: 0;margin: 0;border-radius: 5px!important;\n}\n.dropdown-menu.show {\n    display: block;overflow: hidden;\n    padding: 0;\n}\nbutton.back-link  {\n    outline: 0;\n    background: transparent;\n    border: 0;\n}\n \ntd .dropdown button::after {\n    opacity: 0;\n}\nli.page-item {\n    margin: 0 5px;\n}\n\ntd .btn.btn-primary {\n    height: auto;\n    padding-top: 0px;\n    padding-bottom: 0px;\n    text-align: left !important;\n    justify-content: flex-start;\n    border-radius: 6px;\n    color: #fff !important;\n    font-weight: 600;\n    min-height: initial !important;\n    /* padding-left: 8px !important; */\n    min-width: 100px;\n    font-size: 16px;\n    font-weight: 700;\n    padding: 5px 15px;\n    text-align: center;\n}\n.btn.btn-primary.blood:hover{\n    background: #c82121;color: #c82121!important;\n}\n.dropdown-item { \n    padding: 7px 7px!important; \n}\n\n/* icons shadow */\n\n/* .el-icon-job-board:before,.el-icon-upcoming-donation:before, .el-icon-donation-history:before, .el-icon-donation-history:before, .el-icon-email-sms:before,.el-icon-profile-setting:before, .el-icon-email-sms:before  { \n    text-shadow: 1px 0px #000;\n}  */\n/* Default text shadow for icons */\n/* .el-icon-job-board:before,\n.el-icon-upcoming-donation:before,\n.el-icon-donation-history:before,\n.el-icon-email-sms:before,\n.el-icon-profile-setting:before {\n    text-shadow: 1px 0px #000;\n} */\n\n/* Text shadow on hover */\n.el-sidebar .nav-item .nav-link:hover .el-icon-job-board:before,\n.el-sidebar .nav-item .nav-link:hover .el-icon-upcoming-donation:before,\n.el-sidebar .nav-item .nav-link:hover .el-icon-donation-history:before,\n.el-sidebar .nav-item .nav-link:hover .el-icon-email-sms:before,\n.el-sidebar .nav-item .nav-link:hover .el-icon-profile-setting:before {\n    text-shadow: 1px 0px #eb4e0e;\n}\n\n.w-40{width: 40%;}\n.w-20{width: 20%;}\n.w-30{width: 30%;}\nbutton.text-danger:has(.el-icon-trash) {\n    border: 1px solid #dc3545;\n    background: transparent;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 0;\n    border-radius: 5px;\n}\nbutton.text-danger:has(.el-icon-trash):hover {\nbackground: #dc3545;color: #fff;\n}\nbutton.text-danger:hover i {\ncolor: #fff;\n}\n\n/* table.table.table-striped.table td .btn:hover i{\n     color: #eb4e0e; \n} */\n.bs-popover-end>.popover-arrow::after, .bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after { \n    border-right-color: #e9ecef!important;\n}\n\n.el-bg-table .el-table-container th {\n    background: #e6ebed;\n    color: #161616;\n    vertical-align: middle;\n    min-width: 100px;\n}\n\n.el-bg-table .el-table-container th {\n    background: #e6ebed4f;\n    color: #161616;\n    min-width: 100px;\n}\n\nli.page-item.disabled .page-link {\n    background: transparent !important;\n    border: 0;\n    line-height: 17px;\n    font-size: 35px;\n    color: #000!important;\n}\n\n\n.btn-outlined-secondary i {\n    font-size: 24px!important;\n}\n\n\n  span.page-link span { \n    position: relative;\n    visibility: hidden;\n}\n\n.backbtnarrow span.page-link span::after{\n    content: \"5\";\n    font-size: 16px;font-family: \"elily\";\n    cursor: pointer;\n    left: 0;\n    line-height: 24px;\n    position: absolute;\n    visibility: visible;\n    opacity: 1;\n}  \n\n.nexttnarrow span.page-link span::after{\n    content: \"v\";\n    font-size: 16px;font-family: \"elily\";\n    cursor: pointer;\n    right: 0;\n    line-height: 24px;\n    position: absolute;\n    visibility: visible;\n    opacity: 1;\n}   \n.page-link:hover{\n    border: 1px solid #eb4e0e!important;\n    color:#eb4e0e!important; ;\n}\n.page-link{\n    border: 1px solid transparent!important;\n}\n\n.alert.alert-dark.h-100 {\n    background: #eaf3fd9c;border: 1px solid #d0e3f7;\n}\n\n.disabled {\n    opacity: .6;\n}\n\n.ely-sample-request-details div#accordionFlushExample1 .accordion-item button {\n    background: #f4f4f4;\n    border: 1px solid var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n    padding: 10px 10px;\n    font-size: 15px;\n}\n\n\n.el-line-btns {\n    background: rgba(0, 0, 0, 0) !important;\n    color: #f47403;\n    font-size: 17px;\n    margin: 0 15px;\n    height: fit-content;\n    border: 1px solid #f47403 !important;\n    padding: 24px 30px !important;\n    line-height: 0!important;\n    font-weight: 600;\n}\n.el-fill-btns {\n    background: linear-gradient(321deg, #f47403 0%, rgb(227, 42, 25) 100%) !important;\n    color: #fff;\n    font-size: 17px;\n    margin: 0 15px;\n    height: fit-content;\n    border: 1px solid #f47403;\n    padding: 24px 30px !important;\n    line-height: 0!important;\n    font-weight: 600;\n}\n\n.el-custom-button i.el-icon-blood ,.el-custom-button  .el-icon-urine, .el-custom-button  i.el-icon-saliva{\n    font-size: 16px!important;\n}\n.el-sidebar .navbar-expand-lg .navbar-collapse {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    align-items: normal;\n    height: 100vh;\n    overflow: auto;\n}\n@media(max-width:1500px){\n    .el-sidebar .navbar-expand-lg .navbar-collapse {\n    height: 80vh;}\n}\n \n \n \n \n.navbar-drop-buttons{\n    background: transparent!important;\n    border: 0;\n    outline: 0;\n    min-height: 43px;\n    font-size: 17px;\n    font-weight: 700;\n    padding: 8px 16px;\n    color: #ee5b0b!important;\n    border: 1px solid #ee5b0b!important;\n    font-size: 16px;\n    overflow: hidden;\n    border-radius: 50px!important;\n    display: flex;\n    align-items: center;\n    background: transparent;\n    pointer-events: auto;\n    position: relative;\n    cursor: pointer;\n    width: fit-content !important; \n    transition: color 0.2s linear;\n}\n.dropdown-menu.show { \n        display: block;\n        border-color: #ee5b0b;\n        padding: 12px 0; \n}\n.navbar-drop-buttons:hover{\n    background:#ee5b0b!important ;\n    color: #fff!important;\n}\ntd .navbar-drop-buttons:hover{\n    background:transparent!important ;\n    color: #fff!important;\n}\ntd .navbar-drop-buttons{\n    border: 0!important;\n}\n.el-bg-table label.form-label {\n    font-weight: 700;\n    font-size: 15px;\n    position: relative;\n    margin-top: 2px !important;\n    /* left: 9px; */\n    left: 10px;;\n    /* bottom: -19px; */\n    bottom: -15px;\n    z-index: 9;\n    background: #fff;\n    /* padding: 0 10px; */\n    padding: 0 5px;\n}\n\n[class*=btn-outlined-secondary] i {\n    width: 24px;\n    height: 24px;\n    font-size: 24px!important;\n    display: inline-flex;\n    color: #000!important;\n    margin: 0 8px;\n    align-items: center;\n    justify-content: center; \n}\n.el-flexarea-icon{\n    align-items: center;\n    border-radius: 6px;\n    display: inline-flex;\n    height: 24px;\n    justify-content: space-evenly;\n    max-width: 100%;\n    padding: 0px!important;\n    width: auto;\n    margin-top: 10px;\n}\n\n.el-flexarea-icon .button {\n    padding: 0;\n}\nbutton.text-urine.btn.btn-outlined-secondary {\n    padding: 0;\n}\n.el-icon-urine:before{\n  font-size: 80%;\n}\n.el-icon-saliva:before{\n    font-size: 80%;\n  }\n  table.table.table-striped.table td .btn{\n    padding: 0;\n  }\n    \n\n  .modal-header {\n    background: #e6ebed4f;\n}\n\n.modal-header .h4 {\n    font-size: 24px;\n    margin-bottom: 0;\n}\n\n.modal-body .form-check {\n    margin-bottom: 15px!important;\n} \n\n.css-5wchs2-MuiDateCalendar-root {\n    margin: 0;\n    border: 1px solid #ccc;\n    padding: 0;\n    border-radius: 20px;\n} \n \n.modal-body:has(.el-super-admin){\n    padding: 0;\n}\n.modal-body:has(.el-super-admin) form {\n    width: fit-content;\n    margin: auto;\n}\n.react-datepicker-popper {\n    z-index: 1;\n    line-height: 0;\n    z-index: 999;\n}\n.form-control:focus { \n    box-shadow: 0 0 0 .25rem rgba(222, 228, 255, 0.644)!important;\n}\n.opened-label{\n    margin-top: -6px;\n}\n.bg-danger {\n    border: 1px solid transparent!important;\n    background: #C82121 !important;\n}\n.bg-saliva-fluid{\nbackground: #d7b91c !important;\n}\n\n.bg-hair-follicle{\n  background:  #3C3C3C !important\n}\n.bg-bodyla-fluid{\nbackground: #d7b91c !important ;  border: 1px solid transparent!important;\n}\n\n.bg-exhaledbreath {\nbackground: #d7b91c !important;  border: 1px solid transparent!important;\n}\n \n.bg-warning{\n    background: #d7b91c !important; \n}\n \n.el-sample-btn {\n    padding: 5px 15px 5px 10px !important;\n    font-weight: 800!important;color: #fff!important;\n    border: 1px solid transparent!important;\n}\n.el-sample-btn:hover{\n    color: #fff!important;\n}\n.el-dononr-sample-type .btn i:before {\n    font-size: 100%!important;\n}\n.el-flex-area img {\n    margin-top: 5px;\n    width: 18px!important;\n}\n.el-flex-area {\n    display: flex;\n    align-items: start;\n}\n.el-icons-bg-box:has(.btn-outlined-secondary){\n    background: #003479b6;border-radius: 6px;padding: 5px; color: #fff!important;flex-wrap: nowrap!important; display: flex;width: fit-content;\n}\n.el-icons-bg-box:has(.btn-outlined-secondary) i{\n    color: #fff!important;\n}\n.el-sample-btn:hover {\n    filter: brightness(.9);\n}\n.el-profile-board .el-flex-area {\n    margin: 15px 20px 15px 0;\n}\n \n@media(min-width:1600px){\n    .el-profile-board .el-flex-area {\n        margin: 15px 40px 15px 0;\n    }\n}\n\n \n\n \n.dropdown-toggle .form-check {\n    margin-bottom: 0!important;\n}\n\n/* sample request   */\n .el-custom-accordion {\n    width: 70%!important;\n}\n.el-custom-accordion   .accordion-body  .accordion-item .accordion-body {\n    padding-left: 24px!important;\n}\n.el-custom-accordion .accordion-body .accordion-item .accordion-body:has(.text-danger) {\n    padding-left: 15px !important;\n}\n.el-custom-accordion .el-flex-area {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n}\n .el-custom-accordion .accordion-body img{\n    display: none;\n}\n.el-custom-accordion   .accordion-body {\n    padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n    background: #fff;\n    box-shadow: none;\n    box-shadow: 7px 13px 20px 0px #00000012;\n    border-radius: 0 0 10px 10px;\n    border: 1px solid #f1f1f196;\n}\n \n.el-custom-accordion button.accordion-button {\n    background: #f2f2f2;border-radius: 12px;\n}\n\n.el-custom-accordion  .flex-sec {\n    display: flex;\n    justify-content: start;\n    flex-wrap: wrap;\n    flex-direction: column!important;\n}\n.el-custom-accordion  .flex-sec div:first-child{\n    margin-top: 0;\n}\n\n.el-custom-accordion  p {\n    font-size: 20px;\n    line-height: 24px;\n    color: #000; \n    margin-bottom: 5px !important;\n    font-weight: 600;\n}\n  \n\n\n.el-custom-accordion .accordion-item {\n    border: 0;\n}\n.el-custom-accordion .accordion-button:not(.collapsed) {\n    color: #000;\n    background-color: #f2f2f2;\n    box-shadow: none;\n}\n/* .el-custom-accordion  .mx-fit-content.col-md-12 {\n    padding: 0;\n} */\n\n.el-custom-accordion  .el-request-detail-profile-title {\n    font-size: 17px!important; font-weight: bold;\n    line-height: 24px;\n    color: #000; \n    margin-bottom: 5px !important;\n    font-weight: 700!important;\n}\n \n\n\n.el-custom-accordion  .el-content-detail {\n    display: flex;\n    align-items: start;\n}\n.el-custom-accordion .el-request-detail-profile-name{\n    margin-left: 10px;  font-size: 17px!important; \n    line-height: 24px;\n    color: #000; font-weight: 500;\n    margin-bottom: 5px !important; \n}\n/* .el-custom-accordion .accordion-header button {\n    font-size: 19px!important;\n} */\n\nth , th button, th label{\n    font-weight: 700!important;\n}\n.el-page-count button#dropdown-basic-button {\n    padding: 0;\n}\n.el-icons-bg-box button {\n    border-right: 1px solid #ffffff66 !important;\n    border-radius: 0!important;\n}\n.el-icons-bg-box button:last-child{\n    border-right:0px solid #ffffff66 !important;\n}\n.el-custom-accordion .accordion-body .el-content-detail {\n    display: block!important;\n}\n\n.el-custom-accordion .el-custom-accordion .el-request-detail-profile-name{\n    margin-left:0 \n}\n.el-custom-accordion .accordion-body h4.el-request-detail-profile-name {\n    padding: 0;\n    margin-left: 0!important;\n}\n\n.el-custom-accordion .accordion-body .el-flex-area {\n    margin: 5px 0 !important;\n}\n.el-custom-accordion .accordion-body p.el-request-detail-profile-name {\n    margin: 0!important;\n}\n.el-custom-accordion .accordion-body p.el-request-detail-profile-name {\n    margin: 5px 0!important;\n    font-weight: 500!important;\n}\nbutton.accordion-button div:has(i) {\n    padding: 5px 30px 5px 20px!important;\n    text-align: start;\n}\n\n.ely-sample-request-details div#accordionFlushExample1 .accordion-item button {\n    background: transparent;\n    border: 0px solid #aeb2ae;\n    padding: 15px 10px;\n    font-size: 15px; \n}  \n#accordionFlushExample1 .flex-sec.justify-content-between.col-xxl-6 {\n    padding: 0 ;\n}\nspan.text-bg-success.badge {\n    padding: 10px;\n}\n\n\nspan.text-bg-success.badge i.el-icon-dot.mb-0 {\n    font-size: 34px;\n    line-height: 0;\n    position: relative;\n    top: 6px !important;\n}\nspan.text-bg-success.badge .el-icon-dot:before {\n    content: \"N\";\n    line-height: 0;\n    margin: 0;\n    padding: 0;\n    height: 0;\n} \n\n#accordionFlushExample .accordion  .accordion-item, #accordionFlushExample1  .accordion  .accordion-item{\n    border: 1px solid #00000021 ;\n    padding: 0!important;\n    border-radius: 15px!important;\n    overflow: hidden;\n}\n\n/* .btn.bg-bodyla-fluid:hover i{  */\n  /* color: #4d460c!important; */\n/* } */\n\n.css-5wchs2-MuiDateCalendar-root{\n    width:100%!important\n}\n\n\n.el-main-active{\n \n    background: linear-gradient(321deg, rgb(244, 116, 3) 0%, rgb(227, 42, 25) 100%); \n  color: white!important;\n}\n\n.el-schedule-pickup-sr-modal {\n    max-width: 50% !important;\n}\n.el-change-appointment-time-modal {\n    max-width: 80% !important;\n}\n.el-change-appointment-time-modal .modal-body {\n    padding: 60px!important; \n}\n\n/** Autocomplete Style **/\n.autocomplete-container {\n    position: relative;\n}\n\n.input-wrapper {\nposition: relative;\nwidth: 100%;\n}\n\n.search-icon {\nposition: absolute;\nleft: 10px;\ntop: 50%;\ntransform: translateY(-50%);\nfont-size: 16px;\ncolor: #888;\n}\n\n.autocomplete-input {\npadding: .375rem 0.75rem .375rem 2.5rem !important;\n}\n\n.autocomplete-dropdown {\nbackground-color: #fff;\nborder-bottom: 1px solid #f2f2f2;\nborder-left: 1px solid #f2f2f2;\nborder-radius: 4px;\nborder-right: 1px solid #f2f2f2;\nleft: 12px;\nmax-height: 200px;\noverflow-y: auto;\nposition: absolute;\nright: 12px;\ntop: 81%;\nz-index: 10;\n}\n\n.autocomplete-item {\npadding: 10px;\ncursor: pointer;\n}\n\n.autocomplete-item:hover,\n.autocomplete-item.active {\nbackground-color: #F2F2F2;\n}\n\n.no-suggestions {\npadding: 10px;\ncolor: #999;\n}\n\n\n.radio-wrapper .form-check {\n    padding-right: 1.5rem;\n    margin-bottom: 5px !important;\n}\n\n.sample-type-dropdown-menu {\n    width: 400px;\n    padding: 20px 50px !important;\n}\n\n.sample-type-dropdown-menu .form-check {\n    margin-bottom: 5px !important;\n}\n\n.el-bg-inner-table {\n    border: 1px solid #f2f2f2;\n    box-shadow: none !important;\n}\n\n.sample-heading {\n    font-weight: 700 !important;\n}\nbody .sample-type {    \n    color: #fff !important;\n    padding: 5px 30px 2px 15px;\n    border-radius: 5px;\n}\n.sample-type i {\n    display: inline-block;\n    padding-right: 10px;\n}\n.sample-type.text-danger {\n    background-color: #C82121;\n}\n.sample-type.text-urine,\n.sample-type.text-exhaled-breath,\n.sample-type.text-saliva {\n    background-color: #E3BF00;\n}\n.sample-type.text-bukkal-swab {\n    background-color: #E8598C;\n}\n.sample-type.text-hair-follicle {\n    background-color:#3C3C3C;\n}\n.sample-type.text-skin-tap {\n    background-color:#C98C55;\n}\n.sample-type.text-stool {\n    background-color: #674F12;\n}\n\n\n\n.el-bg-content-inner .el-bg-collapsable {\n    position: absolute;\n    border: none;\n    background-color: transparent;  \n    width: 100%;\n    right: 20px;\n    margin-top: -30px;  \n}\n\n.el-bg-content-inner .el-bg-collapsable i::before {\n    font-size: 24px;\n    font-weight: 300;\n    padding: 0;\n    width: auto;\n    margin: 0;\n    float: inline-end;\n}\n.el-bg-content-inner .el-bg-collapsable i::before {\n    font-size: 24px;\n    font-weight: 300;\n    padding: 0;\n    width: auto;\n    margin: 0;\n}\n\n.el-bg-collapsible-content { \n    transform-origin: top; \n    transition: transform 0.3s ease;  \n    opacity: 0;height: 0;\n}\n\n.el-bg-collapsible-content.open { \n    height: auto;\n    opacity: 1;\n}\n\n#accordionFlushExample #accordionFlushExample1.accordion .accordion-item{\n    border: 0;\n}\n\n .accordion-body .accordion .accordion-item{\n    border: 1px solid #87878750  !important;\n    padding: 0!important;\n    border-radius: 15px!important;\n    overflow: hidden;\n}\n\n.accordion-body .accordion .accordion-flush {\n    margin-bottom: 0!important;\n}\n\n#accordionFlushExample #accordionFlushExample1.accordion .accordion-item {\n    border: 0;\n    margin-bottom: 8px;\n}\n\n.el-custom-accordion .accordion-body:has(.accordion-item) {\n    padding: 20px!important;\n}\n\n.el-custom-accordion .accordion-body .accordion-body{\n    padding: 20px!important;\n}\n\n.el-profile-board:has(.el-custom-accordion) {\n    padding-left: 20px!important;\n}\n.text-danger {\n    --bs-text-opacity: 1;\n    color: rgb(211 0 20) !important;\n}\n.el-property-details-card-content .mx-fit-content {\n    padding-top: 0;padding-bottom: 0;\n}\n.el-main-button span:has(i) {\n    padding-right: 9px;\n}\n/** Custom Fields **/\n.custom-type-label,\n.custom-type-checkbox,\n.custom-type-input,\n.custom-type-number {\n    min-height: 60px;\n    display: flex;\n    align-content: center;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n}\n.custom-type-input,\n.custom-type-number{\n    flex-wrap: wrap;\n}\n.custom-type-label {\n    text-align: center;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-direction: column;    \n}\n\n.sample-new-request .radio-wrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    flex-direction: row;\n}\n\n.sample-new-request .special-donor-or {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    align-content: center;\n    justify-content: space-around;\n    align-items: center;\n}\n\n.sample-new-request .special-donor-qty,\n.sample-new-request .special-donor-gender {\n    margin-top: 1.7rem;\n}\n\n.tube-size-wrapper {\n    text-align: center;\n    width: 100%;\n}\n\n.el-bg-content-inner .el-bg-collapsable-delete {\n    right: 110px;\n}\n.el-schedule-pickup-sr-modal .modal-body {\n    padding: 20px!important; \n}\n\n.m-2.d-flex.align-items-center:has(button) {\n    border-top: 1px solid #ccc;\n    padding-top: 20px;\n}\n \n.el-modal-content{ \n        font-size: 16px;\n        font-weight: 400;\n        line-height: 22px;\n        margin: 0;\n        margin-top: 15px; \n}\nbutton.el-main-button.me-3.mb-3.el-datebtn {\n    min-width: 123px;\n    text-align: center;\n    justify-content: center;\n    color: #000000cc !important;\n    font-weight: 500;\n}\n.el-board-table th .form-check-input[type=\"checkbox\"] {\n    border-radius: 0.25em;\n    margin-top: 0; \n    margin-right: 10px;\n    border-radius: 0.25em;\n    border: 1px solid #f16806;\n    margin-right: 15px;\n}\n.el-board-table th .form-check {\n    margin-bottom: 10px!important;\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n}\n \n.el-board-table .el-table-input label, .el-bg-table .btn-primary, .el-board-table th label {\n    font-weight: 600;\n    color: #161616!important;\n    font-size: 16px;\n    font-weight: 500!important;\n}\n \n\n.css-5wchs2-MuiDateCalendar-root {\n    margin: 0;\n    border: 1px solid #595959;\n    padding: 0;\n    border-radius: 20px;\n}\n.css-5wchs2-MuiDateCalendar-root {\n    margin: 0;\n    border: 1px solid #f16806;\n    padding: 0;\n    border-radius: 20px;\n}\n.css-4k4mmf-MuiButtonBase-root-MuiPickersDay-root.Mui-selected {\n    color: #fff;\n    background-color: #f16806!important;\n    font-weight: 500;\n} \nbutton.el-main-button.me-3.mb-3.el-datebtn {\n    min-width: 123px;\n    height: fit-content;\n    text-align: center;\n    justify-content: center;\n    color: #000000cc !important;\n    font-weight: 500;\n}\n.css-4k4mmf-MuiButtonBase-root-MuiPickersDay-root { \n    font-size: 17px!important; \n}\n.el-bg-collapsible-content .dropdown-menu {\n    padding: 15px 0px!important;\n    box-shadow: 4px 17px 25px #cccccc82;\n}\n\n\n.el-bg-content-inner {\n    color: #000;\n    background-color: #f2f2f2;position: relative;\n    box-shadow: none;\n    padding: 16px 20px;\n}\n\n.el-bg-table.el-sample-request-wrapper {\n    padding: 0!important; \n    border: 1px solid #00000021;\n    padding: 0 !important;\n}\n.el-bg-table.el-super-admin { \n    border: 1px solid #00000021; \n    border-radius: 15px !important;\n    /* overflow: hidden; */\n}\n\n.el-bg-collapsible-content.open {\n    padding: 16px 20px;\n    background: #fff;\n    box-shadow: none!important;\n    border-radius: 0 0 10px 10px;\n    border: 1px solid #f1f1f196;\n}\n\n/* .el-bg-collapsible-content .mt-4 {\n    margin-top: 0!important; \n} */\n \n\nbutton.el-bg-collapsable i {\n    color: #eb4e0e;\n}\n\n.el-bg-table:has(.el-bg-content-inner){\n    box-shadow: none; \n}\n\n@media(min-width:1600px){\n    .w-md-70{\n        width: 70%;\n    }\n}\n@media(min-width:1200px){\n    .w-md-70{\n        width:85%;\n    }\n}\n.w-md-70   h3 {\n    font-size: 19px;\n    line-height: 26px;\n    font-weight: 700;\n    color: #000;\n    margin: 0;\n    margin-bottom: 0!important;\n}\n\n.w-md-70 .sample-type-dropdown-menu .form-check {\n    margin-bottom: 10px !important;\n}\nh3.mb-3 {\n    margin-bottom: 1rem !important;\n}\n\n.el-bg-content-inner .el-bg-collapsable-delete {\n    right: 78px;\n    position: absolute;\n    z-index: 99;width: fit-content;\n}\n.el-bg-content-inner .el-bg-collapsable-delete  i{ \n    color: #C82121!important;\n}\n.el-display-block {\n    display: block;\n    width: 100%;\n}\n\n/** Hours **/\nbody .el-add-hours {\n    margin-top: -11px;\n}\nbody .remove-btn-wrapper {\n    margin-top: 38px;\n}\nbody .el-add-hours-btn {\n    margin-left: 10px;\n    margin-top: 15px;\n}\n\n.el-bg-collapsible-content > .mt-4 {\n    margin-top: 0!important;\n}\n\n.custom-type-checkbox .form-check-input[type=\"checkbox\"] {\n    border-radius: 0.25em;\n    border: 1px solid #f16806;\n    margin-right: 15px;\n}\n\n.el-bg-collapsible-content.open > .mt-4:has(.el-main-button) {\n    margin-top: 20px!important;\n}\n\n\nspan.text-bg-success.badge {\n    padding: 10px 30px;\n}\nspan.text-bg-success.badge i.el-icon-dot.mb-0 {\n    font-size: 31px;\n    line-height: 0;\n    width: 0;\n    position: relative;\n    top: 5px !important;\n    height: 0;\n    display: inline-flex ;\n    right: 10px;\n    align-items: center;\n}\n.left-0 {\n    left: 0!important;padding: 0!important;\n}\n\n.custom-type-checkbox:has([type=\"checkbox\"]) {\n    display: flex!important;\n}\nselect.form-control{\n    appearance: none; /* Remove default arrow */\n    -webkit-appearance: none; /* For Safari */\n    -moz-appearance: none; /* For Firefox */ \n    background-repeat: no-repeat;    \n     background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 7\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.839293 1.08474C0.979918 0.944293 1.17054 0.865403 1.36929 0.865403C1.56804 0.865403 1.75867 0.944293 1.89929 1.08474L5.36929 4.55474L8.83929 1.08474C8.98147 0.952263 9.16951 0.880139 9.36382 0.883567C9.55812 0.886995 9.7435 0.965708 9.88092 1.10312C10.0183 1.24053 10.097 1.42592 10.1005 1.62022C10.1039 1.81452 10.0318 2.00257 9.89929 2.14474L5.89929 6.14474C5.75867 6.28519 5.56804 6.36408 5.36929 6.36408C5.17054 6.36408 4.97992 6.28519 4.83929 6.14474L0.839293 2.14474C0.698843 2.00412 0.619954 1.81349 0.619954 1.61474C0.619954 1.41599 0.698843 1.22537 0.839293 1.08474Z\" fill=\"black\"/></svg>');\n    background-position: right 10px center;\n    background-size: 16px; /* Adjust size based on your arrow */\n    padding-right: 30px; /* Add space for the arrow */\n}\ndiv.form-control{\n    appearance: none; /* Remove default arrow */\n    -webkit-appearance: none; /* For Safari */\n    -moz-appearance: none; /* For Firefox */ \n    background-repeat: no-repeat;    \n     background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 7\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.839293 1.08474C0.979918 0.944293 1.17054 0.865403 1.36929 0.865403C1.56804 0.865403 1.75867 0.944293 1.89929 1.08474L5.36929 4.55474L8.83929 1.08474C8.98147 0.952263 9.16951 0.880139 9.36382 0.883567C9.55812 0.886995 9.7435 0.965708 9.88092 1.10312C10.0183 1.24053 10.097 1.42592 10.1005 1.62022C10.1039 1.81452 10.0318 2.00257 9.89929 2.14474L5.89929 6.14474C5.75867 6.28519 5.56804 6.36408 5.36929 6.36408C5.17054 6.36408 4.97992 6.28519 4.83929 6.14474L0.839293 2.14474C0.698843 2.00412 0.619954 1.81349 0.619954 1.61474C0.619954 1.41599 0.698843 1.22537 0.839293 1.08474Z\" fill=\"black\"/></svg>');\n    background-position: right 10px center;\n    background-size: 16px; /* Adjust size based on your arrow */\n    padding-right: 30px; /* Add space for the arrow */\n    \n}\n\n.left-38{\n    left: 38px!important;\n}\n\n.el-bg-table.el-super-admin:has(.el-bg-collapsible-content) { \n    padding: 0!important;\n}\n\n.dateRanegeFilter button {\n\tborder: none;\n\tbox-shadow: none;\n    background: transparent;\n}\n\n.dateRanegeFilter button span {\n  font-weight: 500 !important;\n  font-size: 16px;\n  color: #161616 !important;\n}\n@media(max-width:480px){\n    /* .accordion-body {\n        padding: 0px!important;\n    }\n\n    #accordionFlushExample .accordion .accordion-item, #accordionFlushExample1 .accordion .accordion-item {\n       border: none !important;\n        padding: 0 !important;\n        border-radius: 15px !important; \n    } */\n\n    .el-custom-accordion {\n          width: 100% !important;  \n    }\n} \n\n.li-sl-bg-blue{\n    background: #00A0DF!important;   \n    padding: 10px 10px!important;   \n}\n\n.li-sl-blue{\n    color: #00A0DF!important;   \n}\n\n.fa-dot{\n    font-size: xx-small;\n}\n\n\n.el-sample-tyep .el-checkbox-wrap input {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    opacity: 0;\n    z-index: 9;\n}\n.el-sample-tyep .el-checkbox-wrap {\n    display: inline-block;\n    position: relative;\n}\n.el-sample-tyep .el-checkbox-wrap input:checked + .btn::after {\n    opacity: 1;\n    border: 2px solid;\n}\n.el-sample-tyep .el-checkbox-wrap .btn::after {\n    content: \"✔\";\n    font-family: \"janssen\";\n    position: absolute;\n    font-weight: 200;\n    letter-spacing: 0px !important;\n    font-size: 17px;\n    opacity: 0;\n    background-color: inherit;\n    padding: 2px;\n    border-radius: 50px;\n    top: -8px;\n    right: 0px;\n    width: 23px;\n    height: 23px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.el-404-title span{\n    color: #f16806;\n}\n\n.dashboard-card-count{\n    cursor: pointer\n}\n\n\n.dropdown-item label{\ncursor: pointer;\n}\n/* .error-placeholder {\n    min-height: 20px;\n} */\n.radio-pointer {\n    cursor: pointer;\n}\n\n\n\n.el-bg-collapsible-content:not(.open) h3 {\n    opacity: 0;\n}\n\n.el-bg-content-inner:not(.open) h3 .el-bg-collapsible-content.open {\n    background: #fff;\n    border: 1px solid #f1f1f196;\n    border-radius: 0 0 20px 20px;\n    box-shadow: 7px 13px 20px 0 #00000012;\n    padding: 16px 20px;\n}; \n\n\n.el-bg-collapsible-content {\n    border-radius: 20px 20px 14px 20px!important;\n}\n.el-bg-table.el-bg-inner-table.el-super-admin:has(.el-bg-collapsible-content:not(.open)) .el-bg-content-inner{\n    border-radius: 14px !important;\n}  \n\n.el-bg-table.el-bg-inner-table.el-super-admin:has(.open) .el-bg-content-inner {\n   border-radius: 14px!important;\n\n}\n\n.el-bg-table.el-bg-inner-table.el-super-admin:has(.el-bg-collapsible-content.open) .el-bg-content-inner{\n    border-radius: 14px 14px 0 0 !important;\n}  \n\n \n .el-bg-collapsible-content.open {\n    background: #fff;\n    border: 1px solid #f1f1f196;\n    border-radius: 0 0 10px 10px;\n    box-shadow: 7px 13px 20px 0 #00000012;\n    padding: 16px 20px;\n    border-bottom-left-radius: 14px;\n    border-bottom-right-radius: 14px;\n}\n\n.el-bg-table.el-super-admin.el-sr:has(.el-bg-collapsible-content.open) .el-bg-content-inner-sr {\n    border-radius: 14px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n\n/* When .el-bg-collapsible-content is present but not open, remove bottom border radius */\n.el-bg-table.el-super-admin.el-sr:has(.el-bg-collapsible-content-sr:not(.open)) .el-bg-content-inner-sr {\n    border-radius: 14px;\n}\n\n/* //Css added 22-08-2025*/\n\n.form-control { \n\tmin-height: 30px;\n}\n.job-list-st-filter button {\n\twidth: 100%;\n}\n\n \n.el-board-table .dropdown-menu  .form-check {\n  margin: 10px 10px;\n}\n.el-board-table .dropdown-menu .form-check input {\n  margin-right: 10px;\n}  \n\n.el-board-table .dropdown-menu  .form-check-input:focus{\n  box-shadow:none\n}\n.job-list-st-filter .d-inline-block.form-control.dropdown {\n\tdisplay: flex !important;\n\talign-items: center;\n}\n\n \n.job-list-st-filter .d-inline-block.form-control.dropdown {\n  display: flex !important;\n  align-items: center;\n}\n.d-inline-block.form-control.show.dropdown button {\n  width: 100% !important;\n}\n.job-list-st-filter  .form-control.dropdown {\n  background-image: none;\n  padding-right: 0;\n}\n \n.dropdown-toggle {\n  width: 100% !important;\n}\n.job-list-st-filter .form-control.dropdown:after {\n  content: \"\";\n  position: absolute;\n  right: 0px;pointer-events: none;\n  top: 60%;\n  transform: translateY(-90%);\n  width: 24px;\n  height: 8px;\n  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 7\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.84 1.085a.75.75 0 0 1 1.06 0l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06Z\" fill=\"%23000\"/></svg>');\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n\n \n.job-list-st-filter .d-inline-block.form-control.dropdown {\n  display: flex !important;\n  align-items: center;min-height: 52px;\n}\n \n.d-inline-block.form-control.show.dropdown button {\n  width: 100% !important;\n}\n.job-list-st-filter  .form-control.dropdown {\n  background-image: none;\n  padding-right: 0;\n}\n \n.dropdown-toggle {\n  width: 100% !important;\n}\n.job-list-st-filter .form-control{\npadding-right:0!important; \n}\n.job-list-st-filter .form-control:after {\n  content: \"\";\n  position: absolute;\n  right: 0px;pointer-events: none;\n  top: 60%;\n  transform: translateY(-90%);\n  width: 24px;\n  height: 8px;\n  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 7\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.84 1.085a.75.75 0 0 1 1.06 0l3.47 3.47 3.47-3.47a.75.75 0 0 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06Z\" fill=\"%23000\"/></svg>');\n  background-repeat: no-repeat;\n  background-size: contain;\n}  \n\n.job-list-st-filter button:hover {\n  background: transparent;\n}\n\n.job-list-st-filter button {\n\tpadding: 0 !important;\n}\n.pagination {\n\talign-items: center;\n}\n.el-sidebar .navbar-expand-lg .navbar-collapse {\n\theight: calc(100vh - 96px);\n}\n\n.el-sidebar .nav-item .nav-link { \n\tpadding: 12px ;\n}\n\n.el-recruit-donor-box  p.el-request-detail-profile-title {\n\tpadding-left: 13px;\n}\n#compensation {\n\tcursor: pointer;\n}\n\n.job-list-st-filter .form-control {\n\tposition: relative;\n}\n\n\n.job-list-st-filter div.form-control {\n\tappearance: none;\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n\tbackground-repeat: no-repeat;\n\tbackground-image: none !important;\n\tbackground-position: right 10px center;\n\tbackground-size: 16px;\n\tpadding-right: 30px;\n}\n.jb-filters{\n    width: 175px;\n}\n\n.jb-filter-date{\n    width: 100px;\n}\n.el-board-table div input.btn.btn-link {\n    padding: 0;\n    text-decoration: none;\n    border-top: 1px solid #ccc;\n    border-radius: 0;\n    width: 100%;\n    margin-top: 16px;\n    font-weight: 700;\n    padding: 6px 0 0 0;\n    color: #e63516;\n}\n\n.el-board-table div .dropdown-menu.show {\n    padding: 12px 0px;\n    /* min-width: 240px; */\n    border: 0;width: max-content;\n    box-shadow: 6px 20px 45px #cccccc70;\n    border: 1px solid #f16806;\n}\n\n.profile-setting-accord .el-custom-accordion{\n    width: 100%!important;\n}\n.donate-st-question{\n    font-size: medium!important;\n}\n\n.form-check-profile-setting-race-ethnicity{\n    margin-bottom: 10px!important;\n}\n\n.el-custom-accordion p{\n    /* margin-top: 10px; */\n    /* width: 98%!important; */\n    font-size: medium!important;\n}\n\n.custom-list-style li::marker {\n  font-size: 1.2em!important;    \n  color: #f16806!important;      \n}\n.form-check-health-questionnaire-radio{\n    width: 1.15rem!important;\n    height: 1.1rem!important;\n}\n    \n.cursor-pointer{\n    cursor: pointer!important;\n}\n .large-modal {\n  max-width: 65% !important; /* default is ~500px */\n  width: 65% !important;\n}\n.health-quesion-popup-accord \n.accordion-item \n.accordion-header \n.accordion-button::after {\n    display: none;\n}\n\n.font-size-small{\n    font-size: small!important;\n}\n\n .parent-study  .form-control{\n    line-height: 2.5rem!important;\n    width: 25%;\n    border-radius: 10px;\n }\n\n .form-check input{\n    cursor: pointer;\n }\n .form-check label{\n    cursor: pointer;\n }\n.confirmInfoCheckbox {\n  appearance: none;          /* Remove default browser style */\n  -webkit-appearance: none;\n  width: 19px;\n  height: 19px;\n  border: 2px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n}\n\n.confirmInfoCheckbox:checked {\n  background-color: #f47324;\n  border-color: #f47324;\n}\n\n.confirmInfoCheckbox:checked::after {\n  content: \"✓\";\n  color: #fff;                    \n  position: absolute;\n  top: 55%;\n  left: 50%;\n  transform: translate(-50%, -58%);\n  font-size: 12px;\n  font-weight: bold;\n  pointer-events: none;\n}\n.el-submenu .accordion-button {\n  background: none;\n  padding: 0.5rem 0.8rem!important;\n  font-weight: normal;\n  box-shadow: none !important;\n}\n\n.el-submenu .accordion-button::after {\n  margin-left: auto;\n}\n\n.el-submenu .accordion-body {\n  padding: 0;\n}\n\n.el-submenu .nav-link {\n  padding-left: 2rem; \n  font-size: 0.9rem;\n}\n.el-submenu .nav-item{\n    padding: 0px!important;\n}\n\n.nav-pills .accordion-body{\npadding: 0px!important;\n}\n.nav-pills .accordion-button{\n  background: none;\n  padding: 0.5rem 0.5rem 0.5rem 0rem;\n  font-weight: normal;\n  box-shadow: none !important;\n}\n\n/* Remove hover/active blue background */\n.nav-pills .accordion-button:not(.collapsed),\n.nav-pills .accordion-button:focus,\n.el-submenu .accordion-button:not(.collapsed),\n.el-submenu .accordion-button:focus {\n  background: none !important;\n  color: inherit;\n  box-shadow: none !important;\n} \n.password-info-btn{\n    background: white !important;\n    position: absolute;\n    bottom: -2px;\n}\n\n.appointment-duration-compensation{\n left: 0px!important;\n}\n.el-submenu span{\n    margin-left: 10px;\n}\n/* target accordion-items inside el-submenu (top-level and nested cases) */\n.el-submenu.accordion > .accordion-item,\n.el-submenu .accordion > .accordion-item,\n.el-submenu .accordion-item.el-submenu-item,\n.el-submenu .accordion .accordion-item.el-submenu-item {\n  border: none !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  overflow: visible !important;\n} \n.position-unset{\n    position: unset!important;\n}\n.error-placeholder:has(.text-danger){\n    margin-top: 10px;\n}\n.el-bg-collapsible-content .radio-wrapper .form-check {\n    padding-right: 1.5rem;\n    margin-bottom: 0px !important;\n}\nstrong {\n    font-weight: 700!important;\n}\n.el-form-group input.form-control + .text-danger {\n    margin-top: 10px;\n}\n.el-bg-collapsible-content-sr button.el-main-button + .text-danger {\n    margin-top: 10px;\n}\n.el-bg-collapsible-content-sr .dropdown-item {\n    padding: 5px 8px!important;line-height: 1.2;\n}\ninput.form-control + .text-danger {\n    margin-top: 10px;\n}\np{\n    font-weight: 400;\n}\n.el-bg-table li {\n    font-weight: 400;\n    line-height: 1.2;\n}\n.el-table-container .table tbody tr td {\n    vertical-align: middle;\n    padding: 15px 13px;\n    border-bottom: 2px solid #efefef;\n    font-weight: 400;\n}\n\n.el-bg-table .el-table-container th { \n    font-weight: 600!important;\n}\n.el-board-table .el-table-input label, .el-bg-table .btn-primary, .el-board-table th label { \n    font-weight: 600!important;\n}\n.el-horizontal-action-button img {\ntransform: rotate(90deg);\n margin-left: 20px;\n}\n.modal-body .form-check.el-mb-0{\n    margin-bottom: 0!important;\n}\n\n.modal-body  .form-check + .text-danger {\n    margin-bottom: 20px!important; \n}\n\n.modal-body .form-check:has(+ .text-danger) {\n    margin: 0!important;\n}\n\n.modal-dialog.modal-dialog-centered .modal-body  .form-check-input[type=checkbox] {\n    border-radius: .25em;\n    width: 20px;\n    height: 20px;\n}\n\n#donor-health-questionnaire-section .form-check-input[type=radio] {\n    border-radius: 50%;\n    min-width: 20px!important;\n    min-height: 20px!important;\n    max-width: 20px;\n    max-height: 20px;\n}\n.navbar  .accordion-item {\n    border-bottom: 0;\n}\n\n.job-list-st-filter.el-request-management-dropdown .form-control, .job-list-st-filter.el-request-management-dropdown.form-control {\n    position: relative;\n    text-align: left;\n    padding-left: 15px!important;min-height: 54px!important;\n    border-radius: 0.575rem;\n}\n\n.job-list-st-filter.el-request-management-dropdown   .form-control , .job-list-st-filter.el-request-management-dropdown.form-control{\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-repeat: no-repeat;\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,<svg xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 11 7\\\" fill=\\\"none\\\"><path fill-rule=\\\"evenodd\\\" clip-rule=\\\"evenodd\\\" d=\\\"M0.839293 1.08474C0.979918 0.944293 1.17054 0.865403 1.36929 0.865403C1.56804 0.865403 1.75867 0.944293 1.89929 1.08474L5.36929 4.55474L8.83929 1.08474C8.98147 0.952263 9.16951 0.880139 9.36382 0.883567C9.55812 0.886995 9.7435 0.965708 9.88092 1.10312C10.0183 1.24053 10.097 1.42592 10.1005 1.62022C10.1039 1.81452 10.0318 2.00257 9.89929 2.14474L5.89929 6.14474C5.75867 6.28519 5.56804 6.36408 5.36929 6.36408C5.17054 6.36408 4.97992 6.28519 4.83929 6.14474L0.839293 2.14474C0.698843 2.00412 0.619954 1.81349 0.619954 1.61474C0.619954 1.41599 0.698843 1.22537 0.839293 1.08474Z\\\" fill=\\\"black\\\"/></svg>\");\n    background-position: right 10px center;\n    background-size: 16px;\n    padding-right: 30px;\n}\n.confirmInfoCheckbox{\n    margin-left: 8px;\n}\n.confirmInfoCheckbox + label{\n    margin-left: 13px!important;\n}\n\n.job-list-st-filter.el-request-management-dropdown.dropdown-toggle::after{\n    display:none!important\n    ;\n}\n\n.dropdown-menu.sample-type-dropdown-menu.show {\n    padding: 15px!important;\n}\n\n.el-profile-board .special-donor-gender .form-check {\n    margin-bottom: 12px !important; \n}\n.el-bg-table .el-appoinment-duration label.form-label {\n    bottom: 0px!important;\n}\n.custom-type-number:has(.text-danger) {\n    margin-bottom: 15px;\n} \n\n.el-bg-table:has(table) { \n    min-height: 65vh;\n}\n.donate-el-between-radio-button{\n    justify-content: space-between;max-width: 150px;\n}\n\n\n/* @media (min-width: 1600px) {\n .el-bg-table.el-super-admin + .el-bg-table.el-super-admin + .el-bg-table.el-super-admin:has(#donor-health-questionnaire-section) .el-custom-accordion {\n    max-width: 80%;\n}\n} */\n\n.table-x-scroll{\n    overflow-x: auto!important;\n}\n\n.bg-orange{\n    background-color: #ee5b0b!important;\n    border-color: #ee5b0b!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
